(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2593],{

/***/ 30422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VY": function() { return /* binding */ getTentativeParents; },
/* harmony export */   "j0": function() { return /* binding */ getTentativeParentsLoading; },
/* harmony export */   "ae": function() { return /* binding */ getTentativeParentsError; },
/* harmony export */   "qj": function() { return /* binding */ getTentativeParentsSearchResults; },
/* harmony export */   "qk": function() { return /* binding */ getTentativeParentsSearchLoading; },
/* harmony export */   "cp": function() { return /* binding */ getShowParentErrorModal; },
/* harmony export */   "LI": function() { return /* binding */ getShowParentConfirmModal; },
/* harmony export */   "Yr": function() { return /* binding */ getSelectedParentForConfirmation; }
/* harmony export */ });
/* unused harmony exports getTentativeParentsFeedback, getTentativeParentsSearchFeedback, getTentativeParentsSearchError, getShouldShowParentSelectorModal, getTentativeParentById, getFilteredTentativeParents */
// Selectors for TentativeParents state
var getTentativeParents = function(state) {
    return state.tentativeParents ? state.tentativeParents.tentativeParents || [] : [];
};
var getTentativeParentsFeedback = function(state) {
    return state.tentativeParents ? state.tentativeParents.feedback || {} : {};
};
var getTentativeParentsLoading = function(state) {
    return state.tentativeParents && state.tentativeParents.feedback ? state.tentativeParents.feedback.requesting || false : false;
};
var getTentativeParentsError = function(state) {
    return state.tentativeParents && state.tentativeParents.feedback ? state.tentativeParents.feedback.error || false : false;
};
// Search selectors
var getTentativeParentsSearchResults = function(state) {
    return state.tentativeParents ? state.tentativeParents.searchResults || [] : [];
};
var getTentativeParentsSearchFeedback = function(state) {
    return state.tentativeParents ? state.tentativeParents.searchFeedback || {} : {};
};
var getTentativeParentsSearchLoading = function(state) {
    return state.tentativeParents && state.tentativeParents.searchFeedback ? state.tentativeParents.searchFeedback.requesting || false : false;
};
var getTentativeParentsSearchError = function(state) {
    return state.tentativeParents && state.tentativeParents.searchFeedback ? state.tentativeParents.searchFeedback.error || false : false;
};
// Modal selectors
var getShowParentErrorModal = function(state) {
    var tentativeParents = state.tentativeParents;
    return tentativeParents ? tentativeParents.showParentErrorModal || false : false;
};
var getShowParentConfirmModal = function(state) {
    var tentativeParents = state.tentativeParents;
    return tentativeParents ? tentativeParents.showParentConfirmModal || false : false;
};
var getSelectedParentForConfirmation = function(state) {
    var tentativeParents = state.tentativeParents;
    return tentativeParents ? tentativeParents.selectedParentForConfirmation || null : null;
};
var getShouldShowParentSelectorModal = function(state) {
    var tentativeParents = state.tentativeParents;
    return tentativeParents ? tentativeParents.shouldShowParentSelectorModal || false : false;
};
// Utility selectors
var getTentativeParentById = function(state, parentId) {
    var tentativeParents = getTentativeParents(state);
    return tentativeParents.find(function(parent) {
        return parent.parent && parent.parent.id === parentId;
    });
};
var getFilteredTentativeParents = function(state, searchTerm) {
    var parents = getTentativeParents(state);
    if (!searchTerm) return parents;
    return parents.filter(function(parent) {
        var user = parent.parent && parent.parent.user;
        if (!user) return false;
        var fullName = "".concat(user.firstName || '', " ").concat(user.lastName || '').toLowerCase();
        var email = (user.email || '').toLowerCase();
        var searchTermLower = searchTerm.toLowerCase();
        return fullName.includes(searchTermLower) || email.includes(searchTermLower);
    });
};


/***/ }),

/***/ 60987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ rfcRegex; }
/* harmony export */ });
/* harmony import */ var _services_validators__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82257);

// RFC validation regex pattern based on Mexican official format
// RFC: 3-4 letters + 6 digits (YYMMDD) + 3 alphanumeric characters
var rfcRegex = /^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/;
var fiscalInfoValidator = function(values) {
    var errors = {};
    // RFC validation
    if (!values.rfc) {
        errors.rfc = 'El RFC es requerido';
    } else if (!rfcRegex.test(values.rfc.toUpperCase())) {
        errors.rfc = 'El formato del RFC no es v\xe1lido';
    }
    // Nationality validation
    if (!values.nationality) {
        errors.nationality = 'El pa\xeds de origen es requerido';
    }
    // CURP validation - mandatory only for Mexican nationality (MX)
    if (values.nationality === 'MX') {
        if (!values.curp) {
            errors.curp = 'La CURP es requerida para nacionalidad mexicana';
        } else if (!(0,_services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validCurp */ .gi)(values.curp.toUpperCase())) {
            errors.curp = 'El formato de la CURP no es v\xe1lido';
        }
    } else if (values.curp && !(0,_services_validators__WEBPACK_IMPORTED_MODULE_0__/* .validCurp */ .gi)(values.curp.toUpperCase())) {
        // If CURP is provided for non-Mexican nationality, validate format
        errors.curp = 'El formato de la CURP no es v\xe1lido';
    }
    if (!values.notificationAddress || typeof values.notificationAddress === 'string' && !values.notificationAddress.trim()) {
        errors.notificationAddress = 'El domicilio de notificaci\xf3n es requerido';
    }
    // Beneficiaries validation
    if (!values.beneficiaries || !Array.isArray(values.beneficiaries) || values.beneficiaries.length === 0) {
        errors.beneficiaries = 'Debe completar al menos un beneficiario';
    } else {
        var beneficiaries = values.beneficiaries;
        var completedBeneficiaries = [];
        var totalPercentage = 0;
        var beneficiaryErrors = [];
        beneficiaries.forEach(function(beneficiary, index) {
            var beneficiaryError = {};
            // Check if this beneficiary has any data
            var hasName = beneficiary && beneficiary.nombre && beneficiary.nombre.trim();
            var hasRelationship = beneficiary && beneficiary.parentesco && beneficiary.parentesco.trim();
            var hasAddress = beneficiary && beneficiary.domicilio && beneficiary.domicilio.trim();
            var hasPercentage = beneficiary && beneficiary.porcentaje && beneficiary.porcentaje.toString().trim() && !isNaN(Number(beneficiary.porcentaje)) && Number(beneficiary.porcentaje) > 0;
            var hasAnyData = hasName || hasRelationship || hasAddress || hasPercentage;
            if (hasAnyData) {
                // Check if this is a complete beneficiary (all required fields)
                var isComplete = hasName && hasRelationship && hasAddress && hasPercentage;
                // If beneficiary has any data, validate all required fields
                if (!hasName) {
                    beneficiaryError.nombre = 'El nombre es requerido';
                }
                if (!hasRelationship) {
                    beneficiaryError.parentesco = 'El parentesco es requerido';
                }
                if (!hasAddress) {
                    beneficiaryError.domicilio = 'El domicilio es requerido';
                }
                if (!hasPercentage) {
                    beneficiaryError.porcentaje = 'El porcentaje es requerido';
                } else {
                    var percentage = Number(beneficiary.porcentaje);
                    if (percentage < 1 || percentage > 100) {
                        beneficiaryError.porcentaje = 'El porcentaje debe estar entre 1 y 100';
                    } else if (isComplete) {
                        // Only count percentage if this is a complete beneficiary
                        totalPercentage += percentage;
                        completedBeneficiaries.push(beneficiary);
                    }
                }
            }
            beneficiaryErrors[index] = beneficiaryError;
        });
        // Check if at least one beneficiary is completed
        if (completedBeneficiaries.length === 0) {
            errors.beneficiaries = {
                _error: 'Debe completar al menos un beneficiario'
            };
        } else if (totalPercentage !== 100) {
            // Check percentage total - must be exactly 100%
            errors.beneficiaries = {
                _error: "La suma de porcentajes debe ser exactamente 100% (actual: ".concat(totalPercentage, "%)")
            };
        }
        // Add individual beneficiary errors if any
        var hasFieldErrors = beneficiaryErrors.some(function(error) {
            return Object.keys(error).length > 0;
        });
        if (hasFieldErrors) {
            if (!errors.beneficiaries) {
                errors.beneficiaries = {};
            }
            beneficiaryErrors.forEach(function(error, index) {
                if (Object.keys(error).length > 0) {
                    errors.beneficiaries[index] = error;
                }
            });
        }
    }
    return errors;
};
/* harmony default export */ __webpack_exports__["Z"] = (fiscalInfoValidator);


/***/ }),

/***/ 81809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var app_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11256);




function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var hasPermission = function(userPermissions, neededPermissions) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = userPermissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var perm = _step.value;
            if (neededPermissions.includes(perm)) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
var checkUserPermission = function(param) {
    var _userRoles = param.userRoles, userRoles = _userRoles === void 0 ? [] : _userRoles, _userPlans = param.userPlans, userPlans = _userPlans === void 0 ? [] : _userPlans, _roles = param.roles, roles = _roles === void 0 ? [] : _roles, _plans = param.plans, plans = _plans === void 0 ? [] : _plans;
    var authByRoles = roles.length === 0 ? true : hasPermission(userRoles, roles);
    var authByPlans = plans.length === 0 ? true : hasPermission(userPlans, plans);
    return authByPlans && authByRoles;
};
var AuthByRoles = /*#__PURE__*/ function(PureComponent1) {
    "use strict";
    _inherits(AuthByRoles, PureComponent1);
    var _super = _createSuper(AuthByRoles);
    function AuthByRoles(props) {
        _classCallCheck(this, AuthByRoles);
        var _this;
        _this = _super.call(this, props);
        _this.isAuth = props.isAuth;
        return _this;
    }
    _createClass(AuthByRoles, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, _notMatch = _props.notMatch, notMatch = _notMatch === void 0 ? null : _notMatch;
                return this.isAuth ? children : notMatch;
            }
        }
    ]);
    return AuthByRoles;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
var mapStateToProps = function(state, ownProps) {
    return {
        isAuth: checkUserPermission({
            userRoles: (0,app_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getUserRoles */ .Jm)(state),
            userPlans: (0,app_selectors__WEBPACK_IMPORTED_MODULE_2__/* .getUserPlans */ .gQ)(state),
            roles: ownProps.roles,
            plans: ownProps.plans
        })
    };
};
AuthByRoles.propTypes = {
    isAuth: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool.isRequired),
    roles: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)),
    plans: prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().any),
    notMatch: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().element)
    ])
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .connect */ .$j)(mapStateToProps)(AuthByRoles));


/***/ }),

/***/ 24020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var app_selectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11256);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);



/**
 * ContractFeaturesFlag is a component that renders children if the broker has the contractFeature
 * @example
 *  <ContractFeaturesFlag contractFeature={CONTRACT_FEATURES.CAN_CREATE_PROPERTIES}>
 *   <div>Can create properties</div>
 *  </ContractFeaturesFlag>
 *
 *  <ContractFeaturesFlag
 *   contractFeature={CONTRACT_FEATURES.CAN_CREATE_PROPERTIES}
 *   defaultChildren={<div>Can't create properties</div>}
 *  >
 *   <div>Can create properties</div>
 *  </ContractFeaturesFlag>
 */ function ContractFeaturesFlag(param) {
    var contractFeature = param.contractFeature, _children = param.children, children = _children === void 0 ? null : _children, _defaultChildren = param.defaultChildren, defaultChildren = _defaultChildren === void 0 ? null : _defaultChildren;
    var hasContractFeature = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return (0,app_selectors__WEBPACK_IMPORTED_MODULE_0__/* .hasContractFeatureSelector */ .DM)(state, contractFeature);
    });
    if (hasContractFeature) {
        return children;
    }
    return defaultChildren;
}
ContractFeaturesFlag.propTypes = {
    /**
   * It comes from 'app/constants/contractFeatures'
   */ contractFeature: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    /**
   * defaultChildren is rendered when contractFeature is not present
   * or broker does not have the feature
   */ defaultChildren: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
    /**
   * children is rendered when contractFeature is present
   * and broker has the feature
   */ children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (ContractFeaturesFlag);


/***/ }),

/***/ 38302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Profile_ParentSelector; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./app/reducers/TentativeParentsRedux.js
var TentativeParentsRedux = __webpack_require__(82802);
// EXTERNAL MODULE: ./app/selectors/TentativeParentsSelectors.js
var TentativeParentsSelectors = __webpack_require__(30422);
// EXTERNAL MODULE: ./controls/Input/index.js
var Input = __webpack_require__(24493);
// EXTERNAL MODULE: ./controls/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(88654);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/Forms/Profile/searcherStyles.js

var _defaultExport = new String(".parent-searcher.jsx-20a6642a7dbaf052{padding:1rem 0}\n.search-container.jsx-20a6642a7dbaf052{margin-bottom:1rem}\n.search-results.jsx-20a6642a7dbaf052{position:relative;\nz-index:10}\n.loading.jsx-20a6642a7dbaf052{padding:1rem;\ntext-align:center;\ncolor:".concat(theme/* colors.textSecondary */.O9.textSecondary || '#666', ";\nborder:1px solid ").concat(theme/* colors.border */.O9.border || '#e0e0e0', ";\nborder-radius:4px;\nbackground-color:").concat(theme/* colors.background */.O9.background || '#fff', ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:0.5rem}\n.loading.jsx-20a6642a7dbaf052 span.jsx-20a6642a7dbaf052{font-style:italic;\nfont-size:0.9rem}\n.results-list.jsx-20a6642a7dbaf052 h6.jsx-20a6642a7dbaf052{margin:0 0 1rem 0;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nfont-size:0.9rem;\nfont-weight:bold}\n.search-result-item.jsx-20a6642a7dbaf052{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\npadding:0.75rem;\nmargin-bottom:0.5rem;\nborder:1px solid ").concat(theme/* colors.border */.O9.border || '#e0e0e0', ";\nborder-radius:4px;\nbackground-color:").concat(theme/* colors.background */.O9.background || '#fff', ";\nbox-shadow:0 1px 3px rgba(0, 0, 0, 0.1)}\n.search-result-item.jsx-20a6642a7dbaf052:hover{border-color:").concat(theme/* colors.primary */.O9.primary || '#007bff', ";\nbox-shadow:0 2px 5px rgba(0, 0, 0, 0.15)}\n.parent-info.jsx-20a6642a7dbaf052{-webkit-flex:1;\n-ms-flex:1;\nflex:1}\n.parent-name.jsx-20a6642a7dbaf052{font-weight:bold;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin-bottom:0.25rem}\n.parent-email.jsx-20a6642a7dbaf052{font-size:0.85rem;\ncolor:").concat(theme/* colors.alpha */.O9.alpha ? theme/* colors.alpha */.O9.alpha(theme/* colors.black */.O9.black, 0.6) : '#666', ";\nmargin-bottom:0.1rem}\n.parent-phone.jsx-20a6642a7dbaf052{font-size:0.85rem;\ncolor:").concat(theme/* colors.alpha */.O9.alpha ? theme/* colors.alpha */.O9.alpha(theme/* colors.black */.O9.black, 0.6) : '#666', "}\n.parent-actions.jsx-20a6642a7dbaf052{margin-left:1rem}\n.no-results.jsx-20a6642a7dbaf052{padding:1rem;\ntext-align:center;\ncolor:").concat(theme/* colors.textSecondary */.O9.textSecondary || '#666', ";\nfont-style:italic;\nborder:1px dashed ").concat(theme/* colors.border */.O9.border || '#e0e0e0', ";\nborder-radius:4px;\nbackground-color:").concat(theme/* colors.backgroundLight */.O9.backgroundLight || '#f8f9fa', "}"));
_defaultExport.__hash = "20a6642a7dbaf052";
/* harmony default export */ var searcherStyles = (_defaultExport);

;// CONCATENATED MODULE: ./components/Forms/Profile/ParentSearcher.js











function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ParentSearcher = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ParentSearcher, Component1);
    var _super = _createSuper(ParentSearcher);
    function ParentSearcher(props) {
        _classCallCheck(this, ParentSearcher);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function(event) {
            var searchTerm = event.target.value;
            _this.setState({
                searchTerm: searchTerm
            });
            // Clear previous timeout
            if (_this.searchTimeout) {
                clearTimeout(_this.searchTimeout);
            }
            if (searchTerm.trim().length >= 2) {
                // Debounce search by 500ms
                _this.searchTimeout = setTimeout(function() {
                    _this.props.searchParents(searchTerm);
                    _this.setState({
                        showResults: true
                    });
                }, 500);
            } else {
                _this.setState({
                    showResults: false
                });
                _this.props.clearSearchResults();
            }
        });
        _defineProperty(_assertThisInitialized(_this), "handleSelectParent", function(parent) {
            if (_this.props.onParentSelected) {
                _this.props.onParentSelected(parent);
            }
            // Clear search after selection
            _this.setState({
                searchTerm: '',
                showResults: false
            });
            _this.props.clearSearchResults();
        });
        _this.state = {
            searchTerm: '',
            showResults: false
        };
        _this.searchTimeout = null;
        return _this;
    }
    _createClass(ParentSearcher, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _state = this.state, searchTerm = _state.searchTerm, showResults = _state.showResults;
                var _props = this.props, searchResults = _props.searchResults, isSearchLoading = _props.isSearchLoading;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-searcher",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(searcherStyles.__hash) + " " + "search-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* InputForm */.M5, {
                                value: searchTerm,
                                onChange: this.handleSearchChange,
                                placeholder: "Buscar padrino por nombre, ID, email...",
                                label: "Buscar Padrino"
                            })
                        }),
                        showResults && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(searcherStyles.__hash) + " " + "search-results",
                            children: isSearchLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(searcherStyles.__hash) + " " + "loading",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "jsx-".concat(searcherStyles.__hash),
                                    children: "Buscando padrinos..."
                                })
                            }) : searchResults.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(searcherStyles.__hash) + " " + "results-list",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "jsx-".concat(searcherStyles.__hash),
                                        children: "Resultados de b\xfasqueda:"
                                    }),
                                    searchResults.map(function(result) {
                                        var _this1 = _this;
                                        var user = result.user;
                                        var fullName = user ? "".concat(user.firstName || '', " ").concat(user.lastName || '').trim() : 'N/A';
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-".concat(searcherStyles.__hash) + " " + "search-result-item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-info",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-name",
                                                            children: fullName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-email",
                                                            children: (user === null || user === void 0 ? void 0 : user.email) || 'N/A'
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-phone",
                                                            children: (user === null || user === void 0 ? void 0 : user.telephone) || 'N/A'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-".concat(searcherStyles.__hash) + " " + "parent-actions",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                        color: "primary",
                                                        size: "small",
                                                        onClick: function() {
                                                            return _this1.handleSelectParent(result);
                                                        },
                                                        children: "Elegir"
                                                    })
                                                })
                                            ]
                                        }, result.id));
                                    })
                                ]
                            }) : searchTerm.trim().length >= 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(searcherStyles.__hash) + " " + "no-results",
                                children: "No se encontraron padrinos que coincidan con la b\xfasqueda."
                            }) : null
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: searcherStyles.__hash,
                            children: searcherStyles
                        })
                    ]
                }));
            }
        }
    ]);
    return ParentSearcher;
}(react.Component);
ParentSearcher.propTypes = {
    // Redux props
    searchResults: (prop_types_default()).array.isRequired,
    isSearchLoading: (prop_types_default()).bool.isRequired,
    searchParents: (prop_types_default()).func.isRequired,
    clearSearchResults: (prop_types_default()).func.isRequired,
    // Callback props
    onParentSelected: (prop_types_default()).func
};
ParentSearcher.defaultProps = {
    onParentSelected: null
};
var mapStateToProps = function(state) {
    return {
        searchResults: (0,TentativeParentsSelectors/* getTentativeParentsSearchResults */.qj)(state),
        isSearchLoading: (0,TentativeParentsSelectors/* getTentativeParentsSearchLoading */.qk)(state)
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        searchParents: function(searchTerm) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.search */.Lz.search(searchTerm));
        },
        clearSearchResults: function() {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.clearSearch */.Lz.clearSearch());
        }
    };
};
/* harmony default export */ var Profile_ParentSearcher = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(ParentSearcher));

// EXTERNAL MODULE: ./components/Modals/index.js + 32 modules
var Modals = __webpack_require__(37952);
// EXTERNAL MODULE: ./components/Forms/Profile/styles.js
var styles = __webpack_require__(46769);
;// CONCATENATED MODULE: ./components/Forms/Profile/ParentSelector.js











function ParentSelector_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ParentSelector_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ParentSelector_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ParentSelector_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ParentSelector_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ParentSelector_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ParentSelector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParentSelector_getPrototypeOf(o) {
    ParentSelector_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ParentSelector_getPrototypeOf(o);
}
function ParentSelector_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ParentSelector_setPrototypeOf(subClass, superClass);
}
function ParentSelector_possibleConstructorReturn(self, call) {
    if (call && (ParentSelector_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ParentSelector_assertThisInitialized(self);
}
function ParentSelector_setPrototypeOf(o, p) {
    ParentSelector_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ParentSelector_setPrototypeOf(o, p);
}
var ParentSelector_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ParentSelector_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ParentSelector_createSuper(Derived) {
    var hasNativeReflectConstruct = ParentSelector_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ParentSelector_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ParentSelector_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ParentSelector_possibleConstructorReturn(this, result);
    };
}
var ParentSelector = /*#__PURE__*/ function(Component1) {
    "use strict";
    ParentSelector_inherits(ParentSelector, Component1);
    var _super = ParentSelector_createSuper(ParentSelector);
    function ParentSelector(props) {
        ParentSelector_classCallCheck(this, ParentSelector);
        var _this;
        _this = _super.call(this, props);
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "selectParent", function(parent) {
            // Show confirmation modal instead of directly selecting
            _this.props.openParentConfirmModal(parent);
        });
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "selectParentFromSearch", function(searchResult) {
            // Show confirmation modal for search results too
            _this.props.openParentConfirmModal(searchResult);
        });
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "deleteParent", function(parent) {
            // Use the parent.id from the nested structure
            var parentId = parent.parent && parent.parent.id;
            if (parentId) {
                _this.props.removeParent(parentId);
                if (_this.props.onParentDeleted) {
                    _this.props.onParentDeleted(parent);
                }
            }
        });
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "closeParentErrorModal", function() {
            _this.props.closeParentErrorModal();
        });
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "handleConfirmParentSelection", function() {
            var selectedParent = _this.props.selectedParentForConfirmation;
            if (selectedParent) {
                var ref;
                // Get the parent ID from either structure
                var parentId = ((ref = selectedParent.parent) === null || ref === void 0 ? void 0 : ref.id) || selectedParent.id;
                if (parentId) {
                    // Set loading state for this specific parent
                    _this.setState({
                        selectingParentId: parentId
                    });
                    // Dispatch the confirmation action which will trigger the actual selection
                    _this.props.confirmParentSelection();
                    _this.props.chooseParent(parentId);
                    if (_this.props.onParentSelected) {
                        _this.props.onParentSelected(selectedParent);
                    }
                }
            }
        });
        ParentSelector_defineProperty(ParentSelector_assertThisInitialized(_this), "handleCancelParentSelection", function() {
            _this.props.hideParentConfirmModal();
        });
        _this.state = {
            selectingParentId: null // Track which parent is being selected
        };
        return _this;
    }
    ParentSelector_createClass(ParentSelector, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Load tentative parents when component mounts
                this.props.loadTentativeParents();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Clear loading state when operation finishes (for error cases)
                // Note: Success cases will reload the page, so this mainly handles errors
                if (prevProps.isLoading && !this.props.isLoading) {
                    this.setState({
                        selectingParentId: null
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, tentativeParents = _props.tentativeParents, isLoading = _props.isLoading, error = _props.error, showParentConfirmModal = _props.showParentConfirmModal, selectedParentForConfirmation = _props.selectedParentForConfirmation, subtitleComponent = _props.subtitleComponent;
                var selectingParentId = this.state.selectingParentId;
                var title = subtitleComponent || /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "title",
                    style: {
                        fontWeight: 'bold'
                    },
                    children: "Elige a tu padrino y potencia tu crecimiento en iad"
                });
                // Get parent name for confirmation modal
                var getParentName = function(parent) {
                    var ref;
                    if (!parent) return 'este asesor';
                    var user = ((ref = parent.parent) === null || ref === void 0 ? void 0 : ref.user) || parent.user;
                    if (user) {
                        return "".concat(user.firstName || '', " ").concat(user.lastName || '').trim() || user.email || 'este asesor';
                    }
                    return 'este asesor';
                };
                if (isLoading) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-selector",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "loading",
                                children: "Cargando padrinos..."
                            }),
                            (0,jsx_runtime.jsx)(style["default"], {
                                id: styles/* default.__hash */.ZP.__hash,
                                children: styles/* default */.ZP
                            })
                        ]
                    }));
                }
                if (error && !this.props.showParentErrorModal) {
                    var _this1 = this;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-selector",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "error",
                                children: [
                                    "Error al cargar los padrinos.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return _this1.props.loadTentativeParents();
                                        },
                                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash),
                                        children: "Reintentar"
                                    })
                                ]
                            }),
                            (0,jsx_runtime.jsx)(style["default"], {
                                id: styles/* default.__hash */.ZP.__hash,
                                children: styles/* default */.ZP
                            })
                        ]
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-selector",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "selector-leyend",
                            children: [
                                title,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "subtitle",
                                    children: "Selecciona al asesor experto en tu \xe1rea, que refleje los valores de iad: profesional, confiable, humilde, unido, valiente, sabio, leal y colaborativo, y crece acompa\xf1ado en cada paso para lograr tu \xe9xito."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ParentSearcher, {
                            onParentSelected: this.selectParentFromSearch
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "suggested-parents",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "jsx-".concat(styles/* default.__hash */.ZP.__hash),
                                    children: "Opciones sugeridas:"
                                }),
                                tentativeParents.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "no-results",
                                    children: "No hay sugerencias de padrinos disponibles en este momento."
                                }) : tentativeParents.map(function(parent) {
                                    var _this2 = _this;
                                    var ref, ref1;
                                    var user = (ref = parent.parent) === null || ref === void 0 ? void 0 : ref.user;
                                    var fullName = user ? "".concat(user.firstName || '', " ").concat(user.lastName || '').trim() : 'N/A';
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-option",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                size: "small",
                                                onClick: function() {
                                                    return _this2.deleteParent(parent);
                                                },
                                                className: "delete-button",
                                                title: "Eliminar padrino",
                                                children: "✕"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-info",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-name",
                                                        children: fullName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-email",
                                                        children: (user === null || user === void 0 ? void 0 : user.email) || 'N/A'
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-phone",
                                                        children: (user === null || user === void 0 ? void 0 : user.telephone) || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(styles/* default.__hash */.ZP.__hash) + " " + "parent-actions",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                    color: "primary",
                                                    size: "small",
                                                    loading: selectingParentId === (((ref1 = parent.parent) === null || ref1 === void 0 ? void 0 : ref1.id) || parent.id),
                                                    onClick: function() {
                                                        return _this2.selectParent(parent);
                                                    },
                                                    children: "Elegir"
                                                })
                                            })
                                        ]
                                    }, parent.id));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ParentErrorModal */.zw, {
                            isOpen: this.props.showParentErrorModal || false,
                            onClose: this.closeParentErrorModal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ParentConfirmModal */.Mw, {
                            isOpen: showParentConfirmModal || false,
                            onConfirm: this.handleConfirmParentSelection,
                            onCancel: this.handleCancelParentSelection,
                            parentName: getParentName(selectedParentForConfirmation),
                            loading: selectingParentId !== null
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: styles/* default.__hash */.ZP.__hash,
                            children: styles/* default */.ZP
                        })
                    ]
                }));
            }
        }
    ]);
    return ParentSelector;
}(react.Component);
ParentSelector.propTypes = {
    // Redux props
    tentativeParents: (prop_types_default()).array.isRequired,
    isLoading: (prop_types_default()).bool.isRequired,
    error: (prop_types_default()).bool.isRequired,
    loadTentativeParents: (prop_types_default()).func.isRequired,
    removeParent: (prop_types_default()).func.isRequired,
    chooseParent: (prop_types_default()).func.isRequired,
    showParentErrorModal: (prop_types_default()).bool,
    closeParentErrorModal: (prop_types_default()).func.isRequired,
    showParentConfirmModal: (prop_types_default()).bool,
    selectedParentForConfirmation: (prop_types_default()).object,
    openParentConfirmModal: (prop_types_default()).func.isRequired,
    hideParentConfirmModal: (prop_types_default()).func.isRequired,
    confirmParentSelection: (prop_types_default()).func.isRequired,
    // Callback props
    onParentSelected: (prop_types_default()).func,
    onParentDeleted: (prop_types_default()).func,
    subtitleComponent: (prop_types_default()).node
};
ParentSelector.defaultProps = {
    onParentSelected: null,
    onParentDeleted: null,
    showParentErrorModal: false,
    showParentConfirmModal: false,
    selectedParentForConfirmation: null,
    subtitleComponent: null
};
var ParentSelector_mapStateToProps = function(state) {
    return {
        tentativeParents: (0,TentativeParentsSelectors/* getTentativeParents */.VY)(state),
        isLoading: (0,TentativeParentsSelectors/* getTentativeParentsLoading */.j0)(state),
        error: (0,TentativeParentsSelectors/* getTentativeParentsError */.ae)(state),
        showParentErrorModal: (0,TentativeParentsSelectors/* getShowParentErrorModal */.cp)(state),
        showParentConfirmModal: (0,TentativeParentsSelectors/* getShowParentConfirmModal */.LI)(state),
        selectedParentForConfirmation: (0,TentativeParentsSelectors/* getSelectedParentForConfirmation */.Yr)(state)
    };
};
var ParentSelector_mapDispatchToProps = function(dispatch) {
    return {
        loadTentativeParents: function(params) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.all */.Lz.all(params));
        },
        removeParent: function(agentId) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.remove */.Lz.remove(agentId));
        },
        chooseParent: function(agentId) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.choose */.Lz.choose(agentId));
        },
        closeParentErrorModal: function() {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.closeParentErrorModal */.Lz.closeParentErrorModal());
        },
        openParentConfirmModal: function(parent) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.showParentConfirmModal */.Lz.showParentConfirmModal(parent));
        },
        hideParentConfirmModal: function() {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.hideParentConfirmModal */.Lz.hideParentConfirmModal());
        },
        confirmParentSelection: function() {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.confirmParentSelection */.Lz.confirmParentSelection());
        }
    };
};
/* harmony default export */ var Profile_ParentSelector = ((0,es/* connect */.$j)(ParentSelector_mapStateToProps, ParentSelector_mapDispatchToProps)(ParentSelector));


/***/ }),

/***/ 46769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f7": function() { return /* binding */ userAvatar; },
/* harmony export */   "J5": function() { return /* binding */ passwordProfile; },
/* harmony export */   "kl": function() { return /* binding */ profileGlobals; },
/* harmony export */   "QL": function() { return /* binding */ nexsiteStyles; }
/* harmony export */ });
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57895);

var _defaultExport = new String(".react-tabsul.jsx-90268613b63ab0be li.jsx-90268613b63ab0be{-webkit-justify-content:left;\njustify-content:left}\n.container-Profile.jsx-90268613b63ab0be{}\n.conteiner-info.jsx-90268613b63ab0be{padding:1rem}\n.conteiner-info.jsx-90268613b63ab0be h4.jsx-90268613b63ab0be{margin-bottom:0}\n.controls.jsx-90268613b63ab0be{margin-top:1rem}\n.collapser-title.jsx-90268613b63ab0be{margin:0}\n.parent-selector.jsx-90268613b63ab0be{padding:0}\n.search-container.jsx-90268613b63ab0be{margin-bottom:1.5rem}\n.suggested-parents.jsx-90268613b63ab0be h6.jsx-90268613b63ab0be{margin:0 0 1rem 0;\ncolor:".concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.text */ .O9.text, ";\nfont-size:0.9rem;\nfont-weight:bold}\n.parent-option.jsx-90268613b63ab0be{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\npadding:0.75rem;\nmargin-bottom:0.5rem;\nborder:1px solid ").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.border */ .O9.border || '#e0e0e0', ";\nborder-radius:4px;\nbackground-color:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.background */ .O9.background || '#fff', ";\nposition:relative}\n.parent-info.jsx-90268613b63ab0be{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\nmin-width:0}\n.parent-name.jsx-90268613b63ab0be{font-weight:bold;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.text */ .O9.text, ";\nmargin-bottom:0.25rem}\n.parent-email.jsx-90268613b63ab0be{font-size:0.85rem;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.alpha */ .O9.alpha(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.black */ .O9.black, 0.5), "}\n.parent-phone.jsx-90268613b63ab0be{font-size:0.85rem;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.alpha */ .O9.alpha(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.black */ .O9.black, 0.5), "}\n.parent-actions.jsx-90268613b63ab0be{-webkit-flex-shrink:0;\n-ms-flex-negative:0;\nflex-shrink:0;\nmargin-left:1rem}\n.parent-option.jsx-90268613b63ab0be .delete-button{margin-left:0.5rem}\n@media (max-width:768px) {.parent-option.jsx-90268613b63ab0be{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:stretch;\n-webkit-box-align:stretch;\n-ms-flex-align:stretch;\nalign-items:stretch;\npadding:1rem 0.75rem 0.75rem 0.75rem}\n.parent-info.jsx-90268613b63ab0be{padding-right:2rem;\nmargin-bottom:1rem}\n.parent-name.jsx-90268613b63ab0be{word-wrap:break-word;\noverflow-wrap:break-word}\n.parent-email.jsx-90268613b63ab0be{display:block;\nwhite-space:nowrap;\noverflow:hidden;\ntext-overflow:ellipsis;\nmax-width:100%;\nword-wrap:break-word;\noverflow-wrap:break-word}\n.parent-phone.jsx-90268613b63ab0be{word-wrap:break-word;\noverflow-wrap:break-word}\n.parent-actions.jsx-90268613b63ab0be{width:100%;\nmargin-left:0}\n.parent-actions.jsx-90268613b63ab0be button{width:100%}\n.parent-option.jsx-90268613b63ab0be .delete-button{position:absolute;\ntop:0.5rem;\nright:0.5rem;\nmin-width:auto;\nwidth:24px;\nheight:24px;\npadding:0;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nborder-radius:50%;\nfont-size:1rem;\nline-height:1;\nmargin-left:0}}\n@media (max-width:480px) {.parent-option.jsx-90268613b63ab0be{padding:1rem 0.5rem 0.5rem 0.5rem}\n.parent-name.jsx-90268613b63ab0be{font-size:0.9rem}\n.parent-email.jsx-90268613b63ab0be, .parent-phone.jsx-90268613b63ab0be{font-size:0.8rem}}\n.no-results.jsx-90268613b63ab0be{padding:1rem;\ntext-align:center;\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.textSecondary */ .O9.textSecondary || '#666', ";\nfont-style:italic;\nborder:1px dashed ").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.border */ .O9.border || '#e0e0e0', ";\nborder-radius:4px}\n.title.jsx-90268613b63ab0be{font-weight:bold;\nmargin-top:0.5rem}\n.conteiner-info.jsx-90268613b63ab0be .container-profile.jsx-90268613b63ab0be .editor-form-text .quill{margin-top:0}\n.about-label.jsx-90268613b63ab0be, .experience-label.jsx-90268613b63ab0be{font-size:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .fontSizes.small */ .CH.small, ";\npadding:0.5rem 0;\nfont-weight:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .fontWeights.semiBold */ .vC.semiBold, ";\nmargin:1rem 0 0}"));
_defaultExport.__hash = "90268613b63ab0be";
/* harmony default export */ __webpack_exports__["ZP"] = (_defaultExport);
var userAvatar = new String(".picture-profile.jsx-820825e61c23ef30{height:150px;\nwidth:150px;\nborder-radius:50%;\n-webkit-justify-content:center;\njustify-content:center;\nmargin:auto;\nmargin-bottom:1rem;\nposition:relative}\n.picture-profile.jsx-820825e61c23ef30 span.jsx-820825e61c23ef30{font-size:3.2rem;\nvertical-align:middle;\npadding-top:25%;\ntext-align:center;\ndisplay:block}\n.user-profile.jsx-820825e61c23ef30{text-align:center}\n.user-profile.jsx-820825e61c23ef30>p.jsx-820825e61c23ef30{color:".concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.text */ .O9.text, ";\nfont-weight:bold;\nfont-size:1.2rem;\nmargin:0}\n.user-profile.jsx-820825e61c23ef30>span.jsx-820825e61c23ef30{color:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.primary */ .O9.primary, ";\nfont-size:.9rem}\n.information-profile.jsx-820825e61c23ef30{margin-top:0.5rem}\n.information-profile.jsx-820825e61c23ef30 p.jsx-820825e61c23ef30{font-size:.75rem;\nmargin-bottom:1.5rem}\n.information-profile.jsx-820825e61c23ef30 .title.jsx-820825e61c23ef30{font-weight:bold;\nmargin-bottom:1rem}\n.information-profile.jsx-820825e61c23ef30 span.jsx-820825e61c23ef30{font-size:.75rem}"));
userAvatar.__hash = "820825e61c23ef30";
var passwordProfile = new String(".password-profile.jsx-b8b8340411087877 .facebook-button{height:2.5rem;\npadding:0 1rem}\n.password-profile.jsx-b8b8340411087877 .facebook-button p{margin:0}\n.password-profile.jsx-b8b8340411087877 .ion-social-facebook{margin:0 .5rem}");
passwordProfile.__hash = "b8b8340411087877";
var profileGlobals = new String(".picture-profile.jsx-9149887c07864245 .overlay{opacity:0}\n.picture-profile.jsx-9149887c07864245 .add-image-profile:hover .overlay{background:".concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.alpha */ .O9.alpha(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.black */ .O9.black, 0.5), ";\ncolor:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.white */ .O9.white, ";\nfont-size:3.2rem;\nwidth:150px;\nheight:150px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nborder-radius:50%;\nopacity:1;\n-webkit-transition:120ms linear opacity;\ntransition:120ms linear opacity;\ncursor:pointer;\nposition:absolute;\ntop:0;\nleft:0}"));
profileGlobals.__hash = "9149887c07864245";
var nexsiteStyles = new String(".title.jsx-9ce6fee36b5e3018{font-weight:bold;\nfont-size:".concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .fontSizes.small */ .CH.small, "}\na.nexsite.jsx-9ce6fee36b5e3018{color:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .colors.primary */ .O9.primary, ";\nfont-size:").concat(theme__WEBPACK_IMPORTED_MODULE_0__/* .fontSizes.small */ .CH.small, "}"));
nexsiteStyles.__hash = "9ce6fee36b5e3018";


/***/ }),

/***/ 98946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Admin; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/Layout/index.js + 4 modules
var Layout = __webpack_require__(3300);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Modals/index.js + 32 modules
var Modals = __webpack_require__(37952);
// EXTERNAL MODULE: ./components/Modals/PasswordAuditModal/index.js + 1 modules
var PasswordAuditModal = __webpack_require__(40089);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
;// CONCATENATED MODULE: ./components/NotificationMenu/style.js

var _defaultExport = new String(".badgeleft.jsx-b08c98374083ad23{position:relative}\n.badgeleft[data-badge].jsx-b08c98374083ad23:after{content:attr(data-badge);\nposition:absolute;\ntop:-0.25rem;\nright:-0.25rem;\nfont:".concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\nbackground:").concat(theme/* colors.badge */.O9.badge, ";\ncolor:white;\nwidth:0.75rem;\nheight:0.75rem;\ntext-align:center;\nline-height:12px;\nborder-radius:50%;\npadding:1px}\n.badgeright.jsx-b08c98374083ad23{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nwidth:1rem;\nheight:1rem;\nbackground:").concat(theme/* colors.badge */.O9.badge, ";\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\ncolor:white;\nborder-radius:50%;\nmargin-left:0.25rem}\n.notification-menu-container.jsx-b08c98374083ad23{position:relative}\n.notification-menu-label.jsx-b08c98374083ad23{cursor:pointer;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.notification-menu-label.jsx-b08c98374083ad23 .icon-notification.jsx-b08c98374083ad23, .notification-menu-label.icon-notification.jsx-b08c98374083ad23 .hideOnLarge.jsx-b08c98374083ad23{margin-left:.75rem;\nmargin-right:.75rem}\n.notification-menu-content.jsx-b08c98374083ad23{position:absolute;\ntop:3.5rem;\nleft:-8.3rem;\nmin-width:13rem;\noverflow:hidden;\nbox-sizing:border-box;\nborder:1px solid ").concat(theme/* colors.border */.O9.border, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nvisibility:visible;\nopacity:1;\nz-index:3;\nbackground-color:").concat(theme/* colors.white */.O9.white, ";\nbox-shadow:0 8px 20px 0 rgba(197, 207, 222, 0.5);\nborder-radius:0.25rem;\n-webkit-transition:opacity 200ms, visibility 200ms;\ntransition:opacity 200ms, visibility 200ms}\n@media screen and (max-width:992px) {.notification-menu-content.jsx-b08c98374083ad23{left:-6rem}}\n.notification-menu-header.jsx-b08c98374083ad23{height:2.5rem;\nmin-width:13rem;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nbackground-color:").concat(theme/* colors.white */.O9.white, ";\nfont:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\ncolor:").concat(theme/* colors.text */.O9.text, "}\n@media screen and (max-width:992px) {.notification-menu-header.jsx-b08c98374083ad23{display:none}}\n.notification-menu-overlay.jsx-b08c98374083ad23{width:100%;\nheight:100%;\nposition:fixed;\ntop:0;\nleft:0;\nz-index:2}\n.collapsed.jsx-b08c98374083ad23{visibility:hidden;\nopacity:0;\n-webkit-transition:opacity 200ms, visibility 200ms;\ntransition:opacity 200ms, visibility 200ms}\n.notification-more.jsx-b08c98374083ad23{height:2rem;\nmin-width:13rem;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nbackground-color:").concat(theme/* colors.white */.O9.white, "}\n@media screen and (max-width:992px) {.notification-more.jsx-b08c98374083ad23{display:none}}\n.notification-more.jsx-b08c98374083ad23 a{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\ncolor:").concat(theme/* colors.limeGreen */.O9.limeGreen, "}\n.secondary-menu-item.jsx-b08c98374083ad23{height:2rem;\nmin-width:13rem;\nfont:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row;\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\npadding-left:20px;\ncursor:pointer;\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncolor:").concat(theme/* colors.text */.O9.text, "}\n@media screen and (min-width:992px) {.secondary-menu-item.jsx-b08c98374083ad23{display:none}}"));
_defaultExport.__hash = "b08c98374083ad23";
/* harmony default export */ var NotificationMenu_style = (_defaultExport);

// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/NotificationMenu/Notification/style.js

var style_defaultExport = new String(".notification-menu-item.jsx-e4c8d9f1f380232e{height:3.75rem;\nmin-width:13rem;\nfont:".concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nborder:solid 1px ").concat(theme/* colors.border */.O9.border, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row;\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\npadding-left:20px;\ncursor:pointer}\n.even.jsx-e4c8d9f1f380232e{background-color:").concat(theme/* colors.lighterGray */.O9.lighterGray, "}\n.notification-content.jsx-e4c8d9f1f380232e{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:left;\n-webkit-box-align:left;\n-ms-flex-align:left;\nalign-items:left;\nmargin-left:0.5rem}\n.notification-title.jsx-e4c8d9f1f380232e{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\nclor:").concat(theme/* colors.text */.O9.text, "}\n.notification-date.jsx-e4c8d9f1f380232e{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.micro */.CH.micro, ";\ncolor:").concat(theme/* colors.lightText */.O9.lightText, "}"));
style_defaultExport.__hash = "e4c8d9f1f380232e";
/* harmony default export */ var Notification_style = (style_defaultExport);

;// CONCATENATED MODULE: ./components/NotificationMenu/Notification/index.js








function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var icons = {
    'MESSAGE': 'icono-mensaje.png',
    'LEAD': 'icon-person.png',
    'PROPERTY': 'check-ok.png',
    'DIRECT_ANNONCE_LEAD': 'check-ok.png'
};
var Notification = /*#__PURE__*/ function(PureComponent1) {
    "use strict";
    _inherits(Notification, PureComponent1);
    var _super = _createSuper(Notification);
    function Notification() {
        _classCallCheck(this, Notification);
        return _super.apply(this, arguments);
    }
    _createClass(Notification, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, notification = _props.notification, index = _props.index;
                var date = moment_default()(notification.createdAt).format('DD/MM/YY');
                var icon = icons[notification.notificationType];
                var isEven = index % 2 === 0;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/dashboard/notifications",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "hideOnMobile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(Notification_style.__hash) + " " + (classnames_default()("notification-menu-item", {
                                even: isEven
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,services/* image */.BH)('icons/notifications', icon),
                                    className: "jsx-".concat(Notification_style.__hash)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(Notification_style.__hash) + " " + "notification-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-".concat(Notification_style.__hash) + " " + "notification-title",
                                            children: notification.sender
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-".concat(Notification_style.__hash) + " " + "notification-date",
                                            children: date
                                        })
                                    ]
                                }),
                                (0,jsx_runtime.jsx)(style["default"], {
                                    id: Notification_style.__hash,
                                    children: Notification_style
                                })
                            ]
                        })
                    })
                }));
            }
        }
    ]);
    return Notification;
}(react.PureComponent);
/* harmony default export */ var NotificationMenu_Notification = (Notification);

// EXTERNAL MODULE: ./app/services/store/index.js + 1 modules
var store = __webpack_require__(27293);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./app/reducers/NotificationRedux.js
var NotificationRedux = __webpack_require__(18735);
// EXTERNAL MODULE: ./app/services/config.js
var config = __webpack_require__(17698);
// EXTERNAL MODULE: ./app/config/index.js + 1 modules
var app_config = __webpack_require__(68080);
;// CONCATENATED MODULE: ./components/NotificationMenu/index.js















function NotificationMenu_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function NotificationMenu_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function NotificationMenu_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function NotificationMenu_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) NotificationMenu_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) NotificationMenu_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NotificationMenu_getPrototypeOf(o) {
    NotificationMenu_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return NotificationMenu_getPrototypeOf(o);
}
function NotificationMenu_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) NotificationMenu_setPrototypeOf(subClass, superClass);
}
function NotificationMenu_possibleConstructorReturn(self, call) {
    if (call && (NotificationMenu_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return NotificationMenu_assertThisInitialized(self);
}
function NotificationMenu_setPrototypeOf(o, p) {
    NotificationMenu_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return NotificationMenu_setPrototypeOf(o, p);
}
var NotificationMenu_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function NotificationMenu_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function NotificationMenu_createSuper(Derived) {
    var hasNativeReflectConstruct = NotificationMenu_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = NotificationMenu_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = NotificationMenu_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return NotificationMenu_possibleConstructorReturn(this, result);
    };
}
var NotificationMenu = /*#__PURE__*/ function(Component1) {
    "use strict";
    NotificationMenu_inherits(NotificationMenu, Component1);
    var _super = NotificationMenu_createSuper(NotificationMenu);
    function NotificationMenu(props) {
        NotificationMenu_classCallCheck(this, NotificationMenu);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(NotificationMenu_assertThisInitialized(_this), "toggleMenu", function() {
            var _props = _this.props, unreadNotifications = _props.unreadNotifications, badge = _props.badge;
            var lastNotification = unreadNotifications[0];
            if (badge && lastNotification) {
                _this.props.actions.newNotification(lastNotification.id, lastNotification.createdAt);
            }
            _this.props.actions.hideBadge();
            _this.setState({
                menuOpen: !_this.state.menuOpen
            });
        });
        _defineProperty(NotificationMenu_assertThisInitialized(_this), "renderHeader", function() {
            var _props = _this.props, notifications = _props.notifications, unreadNotifications = _props.unreadNotifications;
            if (notifications.length > 0) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hideOnMobile",
                    style: {
                        display: 'flex'
                    },
                    children: [
                        "Notificaciones",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "badgeright hideOnMobile",
                            children: unreadNotifications.length
                        })
                    ]
                }));
            } else {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hideOnMobile",
                    children: "Ninguna notificaci\xf3n"
                }));
            }
        });
        _this.state = {
            menuReady: false,
            menuOpen: false
        };
        return _this;
    }
    NotificationMenu_createClass(NotificationMenu, [
        {
            key: "UNSAFE_componentWillMount",
            value: function UNSAFE_componentWillMount() {
                this.props.actions.getNotifications();
                this.setState({
                    menuReady: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, notifications = _props.notifications, unreadNotifications = _props.unreadNotifications, badge = _props.badge;
                var _state = this.state, menuReady = _state.menuReady, menuOpen = _state.menuOpen;
                var h = menuOpen ? 'auto' : 0;
                var menuStyle = {
                    display: menuReady ? 'block' : 'none',
                    right: 0
                };
                var notificationList = null;
                if (notifications.length > 0) {
                    notificationList = notifications.slice(0, 3).map(function(n, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(NotificationMenu_Notification, {
                            notification: n,
                            index: i
                        }, n.id);
                    });
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-menu-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: this.toggleMenu,
                            className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-menu-label",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                className: classnames_default()({
                                    badgeleft: badge
                                }, 'hideOnMobile', 'icon-notification'),
                                "data-badge": unreadNotifications.length,
                                size: "small",
                                icon: "md-notifications"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: this.toggleMenu,
                            className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-menu-label hideOnLarge icon-notification",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                className: classnames_default()({
                                    badgeleft: badge
                                }, 'hideOnLarge'),
                                "data-badge": unreadNotifications.length,
                                size: "medium",
                                icon: "md-notifications"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: this.toggleMenu,
                            style: {
                                display: menuOpen ? 'block' : 'none'
                            },
                            className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-menu-overlay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: menuStyle,
                            className: "jsx-".concat(NotificationMenu_style.__hash) + " " + (classnames_default()('notification-menu-content', {
                                collapsed: menuReady && !menuOpen
                            }) || ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-menu-header",
                                    children: this.renderHeader()
                                }),
                                notificationList,
                                (0,app_config.checkFeatureFlag)('show-on-hl-integration') && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard/calendar",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "secondary-menu-item hideOnLarge",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                className: "hideOnLarge",
                                                size: "small",
                                                icon: "md-calendar"
                                            }),
                                            "Calendario"
                                        ]
                                    })
                                }),
                                config/* MAILCOW_SSO_URL */.tD && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: config/* MAILCOW_SSO_URL */.tD,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "secondary-menu-item hideOnLarge",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                            className: "hideOnLarge",
                                            size: "small",
                                            icon: "md-mail-open"
                                        }),
                                        "Correo"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard/notifications",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "secondary-menu-item hideOnLarge",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                className: classnames_default()({
                                                    badgeleft: badge
                                                }, 'hideOnLarge'),
                                                "data-badge": unreadNotifications.length,
                                                size: "small",
                                                icon: "md-notifications"
                                            }),
                                            "Notificaciones"
                                        ]
                                    })
                                }),
                                notifications.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(NotificationMenu_style.__hash) + " " + "notification-more",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "/dashboard/notifications",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "jsx-".concat(NotificationMenu_style.__hash),
                                            children: "M\xe1s notificaciones"
                                        })
                                    })
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: NotificationMenu_style.__hash,
                            children: NotificationMenu_style
                        })
                    ]
                }));
            }
        }
    ]);
    return NotificationMenu;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        profile: state.auth.profile,
        notifications: state.notification.notifications,
        unreadNotifications: state.notification.unreadNotifications,
        notification: state.notification,
        loading: state.notification.loading,
        badge: state.notification.badge
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            getNotifications: NotificationRedux/* NotificationActionCreators.getNotificationsRequest */.BB.getNotificationsRequest,
            newNotification: NotificationRedux/* NotificationActionCreators.newNotification */.BB.newNotification,
            addNotification: NotificationRedux/* NotificationActionCreators.addNotification */.BB.addNotification,
            hideBadge: NotificationRedux/* NotificationActionCreators.hideBadge */.BB.hideBadge
        }, dispatch)
    };
};
/* harmony default export */ var components_NotificationMenu = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(NotificationMenu));

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./controls/utils/react-flexbox-grid.js
var react_flexbox_grid = __webpack_require__(91584);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/styles.js

var header = new String("header.jsx-dfeb0eab3f00ad35{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:end;\n-ms-flex-pack:end;\n-webkit-justify-content:flex-end;\njustify-content:flex-end;\nbackground-color:".concat(theme/* colors.frame */.O9.frame, ";\nheight:").concat(theme/* measurements.headerHeight */.kg.headerHeight, ";\nz-index:100;\nposition:relative;\nwidth:100%}\n@media screen and (max-width:").concat(theme/* BREAKPOINTS.LG */.j$.LG, ") {header.jsx-dfeb0eab3f00ad35{position:fixed}}\n.menus.jsx-dfeb0eab3f00ad35{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nlist-style:none;\npadding:0}\nul.jsx-dfeb0eab3f00ad35{padding:0;\nmargin:0}\nli.jsx-dfeb0eab3f00ad35{color:").concat(theme/* colors.white */.O9.white, ";\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nmargin-right:1rem;\npadding:0 1rem;\nposition:relative;\ncursor:pointer;\nposition:relative;\nlist-style:none}\nli.jsx-dfeb0eab3f00ad35 i{margin-right:1rem}\nli.jsx-dfeb0eab3f00ad35:last-child i{margin-right:0;\nmargin-left:1rem}\n.user-initials.jsx-dfeb0eab3f00ad35{background-color:").concat(theme/* colors.primary */.O9.primary, ";\nborder-radius:50%;\nwidth:2rem;\nheight:2rem;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\nli.jsx-dfeb0eab3f00ad35:hover, li.active.jsx-dfeb0eab3f00ad35{cursor:pointer;\nbackground-color:").concat(theme/* colors.footerBg */.O9.footerBg, "}\nli.jsx-dfeb0eab3f00ad35:hover ul.jsx-dfeb0eab3f00ad35{visibility:visible}\nli.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35{position:absolute;\ntop:70px;\nbackground-color:").concat(theme/* colors.white */.O9.white, ";\nright:0;\npadding:0;\nvisibility:hidden;\nborder:solid 1px ").concat(theme/* colors.border */.O9.border, ";\nborder-radius:0.25rem;\nwidth:12rem}\nli.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35 li.jsx-dfeb0eab3f00ad35{margin:0;\ncolor:").concat(theme/* colors.footerBg */.O9.footerBg, ";\npadding:0.5rem 1rem}\nli.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35 li.jsx-dfeb0eab3f00ad35 *{color:").concat(theme/* colors.footerBg */.O9.footerBg, "}\nli.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35 li.jsx-dfeb0eab3f00ad35:hover, li.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35 li.jsx-dfeb0eab3f00ad35:hover *{color:").concat(theme/* colors.white */.O9.white, "}\nli.jsx-dfeb0eab3f00ad35 ul.jsx-dfeb0eab3f00ad35 li.jsx-dfeb0eab3f00ad35 span.jsx-dfeb0eab3f00ad35{padding:0 1rem;\nwidth:7.5rem}\n.showOnMobile.jsx-dfeb0eab3f00ad35{display:none}\n@media screen and (max-width:").concat(theme/* BREAKPOINTS.LG */.j$.LG, ") {.hideOnMobile.jsx-dfeb0eab3f00ad35{display:none}\n.showOnMobile.jsx-dfeb0eab3f00ad35{display:block}}"));
header.__hash = "dfeb0eab3f00ad35";
var content = new String(".container.jsx-90156b32547445f2{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nwidth:100%}\n.content.jsx-90156b32547445f2{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\nbackground:".concat(theme/* colors.lightGray */.O9.lightGray, ";\n-webkit-transition:width 0.3s ease;\ntransition:width 0.3s ease}\n.container.hide-lateral-menu.jsx-90156b32547445f2 .content.jsx-90156b32547445f2{width:100%}\n@media screen and (max-width:").concat(theme/* BREAKPOINTS.LG */.j$.LG, ") {.content.jsx-90156b32547445f2{width:100%}}"));
content.__hash = "90156b32547445f2";
var title = new String(".title.jsx-9b7e5300f1da5cf5{background-color:".concat(theme/* colors.frame */.O9.frame, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nwidth:100%;\nmax-height:5rem;\npadding:1.25rem 1rem;\nbackground-color:").concat(theme/* colors.white */.O9.white, ";\nborder:solid 1px ").concat(theme/* colors.border */.O9.border, ";\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n@media screen and (max-width:").concat(theme/* BREAKPOINTS.LG */.j$.LG, ") {.title.jsx-9b7e5300f1da5cf5{margin-top:4.375rem}}"));
title.__hash = "9b7e5300f1da5cf5";
var paymentRemainder = new String(".container.jsx-546af39efb583216{position:relative;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nbackground-color:".concat(theme/* colors.warning */.O9.warning, ";\ncolor:").concat(theme/* colors.white */.O9.white, ";\nmargin:1rem;\npadding:1rem 3rem}\n.container.jsx-546af39efb583216 h4.jsx-546af39efb583216{color:").concat(theme/* colors.white */.O9.white, "}\n.container.jsx-546af39efb583216 h4.jsx-546af39efb583216, .container.jsx-546af39efb583216 p.jsx-546af39efb583216{margin:0}\n.container.jsx-546af39efb583216 .icon-warning{position:absolute;\ntop:50%;\nleft:1rem}\n.container.jsx-546af39efb583216 .icon-close{position:absolute;\ntop:1rem;\nright:1rem;\ncursor:pointer}"));
paymentRemainder.__hash = "546af39efb583216";
var teamAssistantInfoRemainderStyles = new String(".tooltip-content.jsx-5f20c3165c5af005{text-align:center;\ncolor:".concat(theme/* colors.white */.O9.white, ";\npadding-bottom:0.5rem}\n.tooltip-content.jsx-5f20c3165c5af005 .title.jsx-5f20c3165c5af005{color:").concat(theme/* colors.white */.O9.white, ";\nmargin:0.5rem 0}\n.close-icon.jsx-5f20c3165c5af005{position:absolute;\ntop:2.5rem;\nright:0.5rem;\ncursor:pointer}"));
teamAssistantInfoRemainderStyles.__hash = "5f20c3165c5af005";

// EXTERNAL MODULE: ./app/selectors/propertyHighlight.js
var propertyHighlight = __webpack_require__(81115);
// EXTERNAL MODULE: ./components/ContractFeaturesFlag/index.js
var ContractFeaturesFlag = __webpack_require__(24020);
// EXTERNAL MODULE: ./app/constants/contractFeatures.js
var contractFeatures = __webpack_require__(10751);
;// CONCATENATED MODULE: ./components/PropertyHighlight/ShoppingCardIcon/styles.js

// TODO: Refactor - Create a badge component
var iconStyles = new String("i.shoppingCardIcon.shoppingCardIconBadge{position:relative;\ncolor:".concat(theme/* colors.white */.O9.white, "}\n.shoppingCardIcon[data-badge]:after{content:attr(data-badge);\nposition:absolute;\ntop:-0.25rem;\nright:-0.25rem;\nfont:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.tiny */.CH.tiny, ";\nbackground:").concat(theme/* colors.badge */.O9.badge, ";\ncolor:white;\nwidth:0.75rem;\nheight:0.75rem;\ntext-align:center;\nline-height:12px;\nborder-radius:50%;\npadding:1px}\ni.shoppingCardIcon.shoppingCardIconBadge.disabled{color:").concat(theme/* colors.gray */.O9.gray, ";\ncursor:not-allowed}"));
iconStyles.__hash = "1b542f51af8522c0";

;// CONCATENATED MODULE: ./components/PropertyHighlight/ShoppingCardIcon/index.js










function ShoppingCardIcon() {
    var goToShoppingCart = function goToShoppingCart() {
        if (!isShoppingCartPage && !isShoppingCartEmpty) {
            router.push('/dashboard/properties/highlight-checkout');
        }
    };
    var shoppingCartLength = (0,es/* useSelector */.v9)(propertyHighlight/* shoppingCartCountSelector */.UW);
    var router = (0,next_router.useRouter)();
    var isShoppingCartPage = router.pathname === '/dashboard/properties/highlight-checkout';
    var isShoppingCartEmpty = shoppingCartLength === 0;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ContractFeaturesFlag/* default */.Z, {
        contractFeature: contractFeatures/* CONTRACT_FEATURES.PROPERTY_HIGHLIGHT_ON_DEMAND */.Q.PROPERTY_HIGHLIGHT_ON_DEMAND,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                className: classnames_default()('shoppingCardIcon shoppingCardIconBadge', {
                    disabled: isShoppingCartEmpty
                }),
                "data-badge": shoppingCartLength || null,
                size: "medium",
                icon: "ios-cart",
                onClick: goToShoppingCart
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: iconStyles.__hash,
                /*#__PURE__*/ children: iconStyles
            })
        ]
    }));
}
/* harmony default export */ var PropertyHighlight_ShoppingCardIcon = (ShoppingCardIcon);

// EXTERNAL MODULE: ./components/Auth/AuthByRoles.js
var AuthByRoles = __webpack_require__(81809);
// EXTERNAL MODULE: ./components/index.js + 34 modules
var components = __webpack_require__(553);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/TeamAssistantInfoRemainder.js









var TeamAssistantInfoRemainder = function(param) {
    var children = param.children;
    var isOpenTeamRemainder = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref2;
        return Boolean((ref = state.auth) === null || ref === void 0 ? void 0 : (ref2 = ref.teamAssistant) === null || ref2 === void 0 ? void 0 : ref2.isOpenTeamRemainder);
    });
    var ref3 = (0,react.useState)(false), closedByUser = ref3[0], setClosedByUser = ref3[1];
    (0,react.useEffect)(function() {
        if (closedByUser) setVisible(false);
    }, [
        closedByUser
    ]);
    var ref1 = (0,react.useState)(isOpenTeamRemainder), visible = ref1[0], setVisible = ref1[1];
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            return setVisible(false);
        }, 7500);
        setVisible(isOpenTeamRemainder);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpenTeamRemainder
    ]);
    var tooltipContent = visible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(teamAssistantInfoRemainderStyles.__hash) + " " + "tooltip-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: "jsx-".concat(teamAssistantInfoRemainderStyles.__hash) + " " + "title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                        size: "large",
                        icon: "md-help-buoy",
                        className: "hideOnMobile"
                    }),
                    "Contactanos",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(teamAssistantInfoRemainderStyles.__hash) + " " + "close-icon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                            size: "small",
                            className: "close-icon",
                            onClick: function() {
                                return setClosedByUser(true);
                            },
                            icon: "md-close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "jsx-".concat(teamAssistantInfoRemainderStyles.__hash),
                children: "Recuerda que tienes un gran equipo que siempre est\xe1 listo para ayudarte"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                href: "/dashboard/team-assistant",
                color: "primary",
                children: "Conoce tu Equipo"
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: teamAssistantInfoRemainderStyles.__hash,
                children: teamAssistantInfoRemainderStyles
            })
        ]
    }) : null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(AuthByRoles/* default */.Z, {
        roles: [
            'BROKER'
        ],
        plans: [
            config/* PLANS.FULL_SERVICE */.Xf.FULL_SERVICE,
            config/* PLANS.IN_HOUSE_FULL */.Xf.IN_HOUSE_FULL,
            config/* PLANS.AFFILIATE */.Xf.AFFILIATE
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tooltip */.u, {
            isOpen: isOpenTeamRemainder,
            initialTooltipAlign: "left",
            tooltipContent: tooltipContent,
            children: children
        })
    }));
};
/* harmony default export */ var ContentWrapper_TeamAssistantInfoRemainder = (TeamAssistantInfoRemainder);

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/CommonLinks.js







var COMPANY_SHOP_URL = (0,app_config["default"])('COMPANY_SHOP_URL');
var NexiShopLink = function(param) {
    var hideOnMobile = param.hideOnMobile, _hideTextOnMobile = param.hideTextOnMobile, hideTextOnMobile = _hideTextOnMobile === void 0 ? false : _hideTextOnMobile;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
        style: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        className: classnames_default()({
            hideOnMobile: hideOnMobile
        }, {
            'hide-text-on-mobile': hideTextOnMobile
        }),
        href: COMPANY_SHOP_URL,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,services/* image */.BH)('/icons/nexi-tienda.svg'),
                alt: "Nexi-tienda",
                style: {
                    marginRight: '0.7rem',
                    maxWidth: '1.1rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Nexitienda"
            })
        ]
    });
};
var HestiaLink = function(param) {
    var hideOnMobile = param.hideOnMobile, hideIconOnMobile = param.hideIconOnMobile;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        className: classnames_default()({
            hideOnMobile: hideOnMobile
        }, 'hide-text-on-mobile'),
        href: "https://www.hestiaplp.com.mx",
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,services/* image */.BH)('/icons/cookie-hestia.svg'),
                alt: "Hestia",
                className: classnames_default()({
                    hideOnMobile: hideIconOnMobile
                }),
                style: {
                    marginRight: '0.7rem',
                    maxWidth: '1rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "P\xf3liza Hestia"
            })
        ]
    });
};
var NexicreditLink = function(param) {
    var hideOnMobile = param.hideOnMobile, hideIconOnMobile = param.hideIconOnMobile, _hideTextOnMobile = param.hideTextOnMobile, hideTextOnMobile = _hideTextOnMobile === void 0 ? false : _hideTextOnMobile;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        className: classnames_default()({
            hideOnMobile: hideOnMobile
        }, {
            'hide-text-on-mobile': hideTextOnMobile
        }),
        href: config/* NEXI_CREDITO_URL */.Ue,
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: (0,services/* image */.BH)('/icons/icon-nexicredito.svg'),
                alt: "Nexicr\xe9dito",
                className: classnames_default()({
                    hideOnMobile: hideIconOnMobile,
                    color: 'gray'
                }),
                style: {
                    marginRight: '0.7rem',
                    maxWidth: '2rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Nexicr\xe9dito"
            })
        ]
    });
};
var SogoEmailLink = function(param) {
    var _hideTextOnMobile = param.hideTextOnMobile, hideTextOnMobile = _hideTextOnMobile === void 0 ? false : _hideTextOnMobile;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        className: classnames_default()({
            'hide-text-on-mobile': hideTextOnMobile
        }),
        href: config/* MAILCOW_SSO_URL */.tD,
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                size: "small",
                icon: "md-mail-open",
                style: {
                    marginRight: '0.5rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Correo"
            })
        ]
    });
};
var CrmHighLevelLink = function(param) {
    var hideOnMobile = param.hideOnMobile, _hideTextOnMobile = param.hideTextOnMobile, hideTextOnMobile = _hideTextOnMobile === void 0 ? false : _hideTextOnMobile;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
        style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap'
        },
        className: classnames_default()({
            hideOnMobile: hideOnMobile
        }, {
            'hide-text-on-mobile': hideTextOnMobile
        }),
        href: config/* HIGH_LEVEL_URL */.d0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* MaterialIcon */.OL, {
                icon: "monitor",
                style: {
                    marginRight: '0.5rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "CRM"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Header.js


















function Header_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Header_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Header_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Header_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Header_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Header_defineProperties(Constructor, staticProps);
    return Constructor;
}
function Header_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_getPrototypeOf(o) {
    Header_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Header_getPrototypeOf(o);
}
function Header_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Header_setPrototypeOf(subClass, superClass);
}
function Header_possibleConstructorReturn(self, call) {
    if (call && (Header_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Header_assertThisInitialized(self);
}
function Header_setPrototypeOf(o, p) {
    Header_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Header_setPrototypeOf(o, p);
}
var Header_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Header_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Header_createSuper(Derived) {
    var hasNativeReflectConstruct = Header_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Header_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Header_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Header_possibleConstructorReturn(this, result);
    };
}
var ON_BOARDING_STATUS = [
    'CREATED',
    'PENDING',
    'VERIFIED',
    'PENDING_VALIDATION',
    'REJECTED'
];
var Header = /*#__PURE__*/ function(Component1) {
    "use strict";
    Header_inherits(Header, Component1);
    var _super = Header_createSuper(Header);
    function Header(props) {
        Header_classCallCheck(this, Header);
        var _this;
        _this = _super.call(this, props);
        Header_defineProperty(Header_assertThisInitialized(_this), "getUserAvatarStyles", function() {
            var avatar = _this.props.userInfo.avatar;
            if (!avatar) {
                return {};
            }
            return {
                backgroundImage: "url(\"".concat(services/* utils.getThumbnail */.P6.getThumbnail({
                    file: avatar,
                    sizeName: 'avatar'
                }), "\")"),
                backgroundSize: 'cover'
            };
        });
        Header_defineProperty(Header_assertThisInitialized(_this), "getUserInitials", function() {
            var _userInfo = _this.props.userInfo, firstName = _userInfo.firstName, lastName = _userInfo.lastName, avatar = _userInfo.avatar;
            if (avatar) {
                return null;
            }
            if (!firstName || !lastName) {
                return 'KG';
            }
            return("".concat(firstName.substr(0, 1)).concat(lastName.substr(0, 1)).toUpperCase());
        });
        Header_defineProperty(Header_assertThisInitialized(_this), "closeModal", function() {
            return(_this.setState({
                openModal: false
            }));
        });
        Header_defineProperty(Header_assertThisInitialized(_this), "exit", function() {
            return(_this.setState({
                openModal: true
            }));
        });
        Header_defineProperty(Header_assertThisInitialized(_this), "logout", function() {
            window.location.assign('/salir');
        });
        _this.state = {
            openModal: false
        };
        return _this;
    }
    Header_createClass(Header, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _state = this.state, openModal = _state.openModal, closeModal = _state.closeModal;
                var canSeeMenu = this.props.canSeeMenu;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Modal */.u_, {
                            isOpen: openModal,
                            onClose: this.closeModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    textAlign: 'center',
                                    padding: '2rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "\xbfEsta seguro que desea salir? "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                xs: 6,
                                                sm: 4,
                                                smOffset: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                    color: "primary",
                                                    fullWidth: true,
                                                    outline: true,
                                                    onClick: this.closeModal,
                                                    children: "Cancelar"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                xs: 6,
                                                sm: 4,
                                                smOffset: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                    color: "primary",
                                                    fullWidth: true,
                                                    outline: true,
                                                    onClick: this.logout,
                                                    children: "Aceptar"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            className: "jsx-".concat(header.__hash),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "jsx-".concat(header.__hash) + " " + "menus",
                                    children: [
                                        (0,app_config.checkFeatureFlag)('show-on-hl-integration') && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/dashboard/calendar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "jsx-".concat(header.__hash) + " " + "hide-text-on-mobile",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            size: "small",
                                                            icon: "md-calendar"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-".concat(header.__hash),
                                                            children: "Calendario"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SogoEmailLink, {
                                                hideTextOnMobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper_TeamAssistantInfoRemainder, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                    className: "hideOnMobile hide-text-on-mobile",
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexWrap: 'wrap',
                                                        height: 'auto'
                                                    },
                                                    size: "tiny",
                                                    href: "/dashboard/team-assistant",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            size: "small",
                                                            icon: "md-help-buoy",
                                                            className: "hideOnMobile"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-".concat(header.__hash),
                                                            children: "Soporte"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrmHighLevelLink, {
                                                hideTextOnMobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HestiaLink, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NexicreditLink, {
                                                hideTextOnMobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "jsx-".concat(header.__hash) + " " + "hideOnMobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NexiShopLink, {
                                                hideOnMobile: true,
                                                hideTextOnMobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "jsx-".concat(header.__hash),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "jsx-".concat(header.__hash),
                                                    children: "|"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NotificationMenu, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "jsx-".concat(header.__hash),
                                                    children: "|"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContractFeaturesFlag/* default */.Z, {
                                            contractFeature: contractFeatures/* CONTRACT_FEATURES.PROPERTY_HIGHLIGHT_ON_DEMAND */.Q.PROPERTY_HIGHLIGHT_ON_DEMAND,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-".concat(header.__hash),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyHighlight_ShoppingCardIcon, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "jsx-".concat(header.__hash),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: this.getUserAvatarStyles(),
                                                    className: "jsx-".concat(header.__hash) + " " + "user-initials",
                                                    children: this.getUserInitials()
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                    size: "small",
                                                    icon: "ios-arrow-down"
                                                }),
                                                canSeeMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "jsx-".concat(header.__hash),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            onClick: function() {
                                                                return next_router["default"].push('/dashboard/profile');
                                                            },
                                                            className: "jsx-".concat(header.__hash),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                    size: "small",
                                                                    icon: "md-person"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: "Mi Perfil"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "showOnMobile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "https://www.hestiaplp.com.mx",
                                                                target: "_blank",
                                                                className: "jsx-".concat(header.__hash),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                        size: "small",
                                                                        icon: "ios-bookmarks"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "jsx-".concat(header.__hash),
                                                                        children: "P\xf3liza Hestia"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "showOnMobile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                href: "/dashboard/team-assistant",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                            size: "small",
                                                                            icon: "md-help-buoy"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "jsx-".concat(header.__hash),
                                                                            children: "Soporte"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + 'showOnMobile',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SogoEmailLink, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "showOnMobile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrmHighLevelLink, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            onClick: function() {
                                                                return next_router["default"].push('/dashboard/payments');
                                                            },
                                                            className: "jsx-".concat(header.__hash),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                    size: "small",
                                                                    icon: "md-bookmarks"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: "Pagos y facturaci\xf3n"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "faqs",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                href: "/help/legal",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: (0,services/* image */.BH)('/icons/question.svg'),
                                                                            alt: "Hestia",
                                                                            style: {
                                                                                marginLeft: '1rem',
                                                                                maxWidth: '1.1rem'
                                                                            },
                                                                            className: "jsx-".concat(header.__hash)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "jsx-".concat(header.__hash),
                                                                            children: "FAQs"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "contract",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                                href: "dashboard/myPropertyDocument",
                                                                as: "/dashboard/property-document/my-documents",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                            size: "small",
                                                                            icon: "ios-book"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "jsx-".concat(header.__hash),
                                                                            children: "Mis Documentos"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "jsx-".concat(header.__hash) + " " + "showOnMobile",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NexicreditLink, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            onClick: this.exit,
                                                            className: "jsx-".concat(header.__hash),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                    size: "small",
                                                                    icon: "ios-log-out"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "jsx-".concat(header.__hash),
                                                                    children: "Cerrar Sesi\xf3n"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0,jsx_runtime.jsx)(style["default"], {
                                    id: header.__hash,
                                    children: header
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return Header;
}(react.Component);
var Header_mapStateToProps = function(state) {
    return {
        userInfo: state.auth.profile,
        canSeeMenu: !ON_BOARDING_STATUS.includes(state.auth.profile.status)
    };
};
/* harmony default export */ var ContentWrapper_Header = ((0,es/* connect */.$j)(Header_mapStateToProps)(Header));

// EXTERNAL MODULE: ./components/Layout/ContentWrapper/Menu/index.js + 8 modules
var Menu = __webpack_require__(8250);
// EXTERNAL MODULE: ./components/Layout/Container.js
var Container = __webpack_require__(42924);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Title.js






var Title = function(param) {
    var children = param.children, subtitle = param.subtitle;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("section", {
        className: /*#__PURE__*/ "jsx-".concat(title.__hash) + " " + "title",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                children: children
            }),
            subtitle,
            (0,jsx_runtime.jsx)(style["default"], {
                id: title.__hash,
                children: title
            })
        ]
    }));
};
Title.propTypes = {
    children: (prop_types_default()).any,
    subtitle: (prop_types_default()).any
};
/* harmony default export */ var ContentWrapper_Title = (Title);

// EXTERNAL MODULE: ./app/reducers/AuthRedux.js
var AuthRedux = __webpack_require__(45228);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/PaymentRemainder.js









var PaymentRemainder = function(param) {
    var isPaymentRemainderOpen = param.isPaymentRemainderOpen, finishedPlan = param.finishedPlan, hidePaymentRemainder = param.actions.hidePaymentRemainder;
    if (!isPaymentRemainderOpen) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: /*#__PURE__*/ "jsx-".concat(paymentRemainder.__hash) + " " + "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                icon: "ios-mail",
                size: "small",
                className: "icon-warning"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                icon: "md-close",
                size: "small",
                className: "icon-close",
                onClick: hidePaymentRemainder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: "jsx-".concat(paymentRemainder.__hash),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    className: "jsx-".concat(paymentRemainder.__hash),
                    children: "Tu fecha de corte se acerca"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-".concat(paymentRemainder.__hash),
                children: [
                    "Asegurate de tener habilitado un m\xe9todo de pago, pr\xf3xima fecha:",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        className: "jsx-".concat(paymentRemainder.__hash),
                        children: moment_default()(finishedPlan).format('DD-MM-YYYY')
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: paymentRemainder.__hash,
                children: paymentRemainder
            })
        ]
    }));
};
var PaymentRemainder_mapStateToProps = function(state) {
    return {
        isPaymentRemainderOpen: state.auth.isPaymentRemainderOpen,
        finishedPlan: state.auth.finishedPlan
    };
};
var PaymentRemainder_mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            hidePaymentRemainder: AuthRedux/* AuthActionCreators.hidePaymentRemainder */.jQ.hidePaymentRemainder
        }, dispatch)
    };
};
/* harmony default export */ var ContentWrapper_PaymentRemainder = ((0,es/* connect */.$j)(PaymentRemainder_mapStateToProps, PaymentRemainder_mapDispatchToProps)(PaymentRemainder));

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/index.js












var Dashboard = function(param) {
    var children = param.children, title = param.title, hasPaid = param.hasPaid, userStatus = param.userStatus, _hideModal = param.hideModal, hideModal = _hideModal === void 0 ? false : _hideModal, _hideLateralMenu = param.hideLateralMenu, hideLateralMenu = _hideLateralMenu === void 0 ? false : _hideLateralMenu, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? null : _subtitle, _hideSessionModal = param.hideSessionModal, hideSessionModal = _hideSessionModal === void 0 ? hideModal : _hideSessionModal;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        className: /*#__PURE__*/ "jsx-".concat(content.__hash) + " " + (classnames_default()('container', {
            'hide-lateral-menu': hideLateralMenu
        }) || ""),
        children: [
            !hideModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* NotYetPaidModal */.rQ, {}),
            !hideSessionModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* UserSessionModal */.y6, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordAuditModal/* default */.Z, {}),
            !hideLateralMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                initialExpanded: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "jsx-".concat(content.__hash) + " " + "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper_Header, {}),
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper_Title, {
                        subtitle: subtitle,
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper_PaymentRemainder, {}),
                    children
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: content.__hash,
                children: content
            })
        ]
    }));
};
Dashboard.propTypes = {
    children: (prop_types_default()).any,
    title: (prop_types_default()).string,
    hideModal: (prop_types_default()).bool,
    subtitle: (prop_types_default()).any
};
/* harmony default export */ var ContentWrapper = (Dashboard);

// EXTERNAL MODULE: ./app/selectors/index.js
var selectors = __webpack_require__(11256);
// EXTERNAL MODULE: ./globalConfigApp/index.js + 1 modules
var globalConfigApp = __webpack_require__(19169);
;// CONCATENATED MODULE: ./components/Auth/ContractVersionNotAllowedPageMessage/styles.js

var contractVersionNotAllowedMessageCss = new String(/*#__PURE__*/ ".general-not-allowed-page-message.jsx-3935d67e488377c9{margin:1rem auto;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n.general-not-allowed-page-message-content.jsx-3935d67e488377c9{max-width:30rem;\nmargin:0 auto}\n.general-not-allowed-page-message-content.jsx-3935d67e488377c9 h3.jsx-3935d67e488377c9{margin:0 0.5rem}\n.link.jsx-3935d67e488377c9{color:".concat(theme/* colors.primary */.O9.primary, "}"));
contractVersionNotAllowedMessageCss.__hash = "3935d67e488377c9";

;// CONCATENATED MODULE: ./components/Auth/ContractVersionNotAllowedPageMessage/index.js









var ContractVersionNotAllowedPageMessage = function() {
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        className: /*#__PURE__*/ "jsx-".concat(contractVersionNotAllowedMessageCss.__hash) + " " + "general-not-allowed-page-message",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Card */.Zb, {
                bordered: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash) + " " + "general-not-allowed-page-message-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash),
                            children: "\xa1Lo sentimos! tu actual versi\xf3n de contrato no tiene acceso a este p\xe1gina"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                            className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,services/* image */.BH)('icono-admin-fullservice.png'),
                                alt: "".concat(globalConfigApp/* companyConfig.name */.p2.name, " full service"),
                                className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash),
                            children: [
                                "Consulta con el equipo de ",
                                globalConfigApp/* companyConfig.name */.p2.name,
                                " para obtener m\xe1s detalle de las capacidades de tu contrato."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash),
                            children: [
                                "Env\xeda un email a",
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:info@".concat(globalConfigApp/* companyConfig.companyDomain */.p2.companyDomain, "?Subject=Acceso a p\xe1gina no permitido"),
                                    target: "_top",
                                    className: "jsx-".concat(contractVersionNotAllowedMessageCss.__hash) + " " + "link",
                                    children: "info@".concat(globalConfigApp/* companyConfig.companyDomain */.p2.companyDomain)
                                }),
                                ' ',
                                "para obtener m\xe1s informaci\xf3n"
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: contractVersionNotAllowedMessageCss.__hash,
                children: contractVersionNotAllowedMessageCss
            })
        ]
    }));
};
/* harmony default export */ var Auth_ContractVersionNotAllowedPageMessage = (ContractVersionNotAllowedPageMessage);

;// CONCATENATED MODULE: ./components/Auth/PageAccessVerification.js








var PageAccessVerification = function(param1) {
    var children = param1.children, currentUrlData1 = param1.currentUrlData, availablePages1 = param1.availablePages;
    var ref = (0,react.useState)(false), isAllowed = ref[0], setIsAllowed = ref[1];
    var ref1 // Add loading state
     = (0,react.useState)(true), isChecking = ref1[0], setIsChecking = ref1[1];
    var userPages = (0,es/* useSelector */.v9)(selectors/* getUserAccesiblePages */.ce);
    var router = (0,next_router.useRouter)();
    // Helper function to extract current page from pathname
    var getCurrentPageFromPath = function(pathname) {
        return pathname.substring(1);
    };
    // Helper function to find the current page object
    var findCurrentPageObject = function(currentPage, availablePages) {
        return availablePages.find(function(page) {
            return page.page === currentPage;
        });
    };
    var hasPageAccess = function(currentPage, availablePages) {
        var currentPageObject = findCurrentPageObject(currentPage, availablePages);
        if (!currentPageObject) {
            return false;
        }
        if ((currentPageObject === null || currentPageObject === void 0 ? void 0 : currentPageObject.privacy) === 'PUBLIC' || (currentPageObject === null || currentPageObject === void 0 ? void 0 : currentPageObject.privacy) === 'PRIVATE' && (currentPageObject === null || currentPageObject === void 0 ? void 0 : currentPageObject.skipContractVersionVerification)) {
            return true;
        }
        return userPages.find(function(page) {
            return page.name === currentPageObject.pageName;
        });
    };
    var checkUserPageAccess = function(param) {
        var _availablePages = param.availablePages, availablePages = _availablePages === void 0 ? [] : _availablePages, _currentUrlData = param.currentUrlData, currentUrlData = _currentUrlData === void 0 ? {} : _currentUrlData;
        var pathname = currentUrlData.pathname;
        var currentPage = getCurrentPageFromPath(pathname);
        return availablePages.length === 0 ? true : hasPageAccess(currentPage, availablePages);
    };
    var isPageHiddenByFeatureFlag = function(currentPage, availablePages) {
        var currentPageObject = findCurrentPageObject(currentPage, availablePages);
        if (!currentPageObject) {
            return false;
        }
        // Check if page has feature flag conditions
        if (currentPageObject.ff && Array.isArray(currentPageObject.ff) && currentPageObject.ff.length > 0) {
            // Check if any feature flag condition is not met
            return currentPageObject.ff.some(function(featureFlagConfig) {
                var actualFeatureFlagValue = (0,app_config.checkFeatureFlag)(featureFlagConfig.name);
                // Page should be hidden if the actual value doesn't match the expected value
                return actualFeatureFlagValue !== featureFlagConfig.value;
            });
        }
        return false;
    };
    (0,react.useEffect)(function() {
        var pathname = currentUrlData1.pathname;
        var currentPage = getCurrentPageFromPath(pathname);
        // Check if page should be hidden based on feature flags
        if (isPageHiddenByFeatureFlag(currentPage, availablePages1)) {
            router.push('/404');
            return;
        }
        setIsAllowed(checkUserPageAccess({
            availablePages: availablePages1,
            currentUrlData: currentUrlData1
        }));
        setIsChecking(false) // Mark checking as complete
        ;
    }, [
        currentUrlData1,
        availablePages1,
        router
    ]);
    // Don't render anything while checking to prevent flash of error message
    if (isChecking) {
        return null // or return a loading spinner if preferred
        ;
    }
    return isAllowed ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth_ContractVersionNotAllowedPageMessage, {});
};
PageAccessVerification.propTypes = {
    children: (prop_types_default()).any,
    currentUrlData: (prop_types_default()).object,
    availablePages: (prop_types_default()).array
};
/* harmony default export */ var Auth_PageAccessVerification = (PageAccessVerification);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/redux-form/es/Field.js + 8 modules
var Field = __webpack_require__(44515);
// EXTERNAL MODULE: ./node_modules/redux-form/es/FieldArray.js + 3 modules
var FieldArray = __webpack_require__(57252);
// EXTERNAL MODULE: ./node_modules/redux-form/es/formValueSelector.js + 1 modules
var formValueSelector = __webpack_require__(31767);
// EXTERNAL MODULE: ./node_modules/redux-form/es/reduxForm.js + 13 modules
var reduxForm = __webpack_require__(78938);
// EXTERNAL MODULE: ./controls/DropDown/index.js + 1 modules
var DropDown = __webpack_require__(34291);
// EXTERNAL MODULE: ./app/reducers/FiscalInfoRedux.js
var FiscalInfoRedux = __webpack_require__(33780);
// EXTERNAL MODULE: ./app/utils/fiscalProgressStorage.js
var fiscalProgressStorage = __webpack_require__(71638);
// EXTERNAL MODULE: ./app/validators/fiscalInfoValidator.js
var validators_fiscalInfoValidator = __webpack_require__(60987);
// EXTERNAL MODULE: ./node_modules/react-pdf/dist/esm/entry.js + 39 modules
var entry = __webpack_require__(47872);
;// CONCATENATED MODULE: ./components/PDFViewer/styles.js

var styles_defaultExport = new String(".pdf-viewer-container.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nheight:65vh;\nwidth:100%;\nmax-width:95vw;\nmargin:0 auto;\nbackground:".concat(theme/* colors.white */.O9.white, ";\nborder-radius:8px;\nbox-shadow:0 4px 20px rgba(0, 0, 0, 0.15);\noverflow:hidden}\n.pdf-viewer-container.fullscreen.jsx-8ee10e96954c68d5{position:fixed;\ntop:0;\nleft:0;\nright:0;\nbottom:0;\nz-index:1101;\nheight:100%;\nwidth:100%;\nmax-width:100%;\nmax-height:100%;\nmin-width:100%;\nmin-height:100%;\nborder-radius:0}\n.pdf-viewer-container.jsx-8ee10e96954c68d5:-webkit-full-screen{height:100vh;\nwidth:100vw;\nmax-width:100vw;\nborder-radius:0}\n.pdf-viewer-container.jsx-8ee10e96954c68d5:-moz-full-screen{height:100vh;\nwidth:100vw;\nmax-width:100vw;\nborder-radius:0}\n.pdf-viewer-container.jsx-8ee10e96954c68d5:-ms-fullscreen{height:100vh;\nwidth:100vw;\nmax-width:100vw;\nborder-radius:0}\n.pdf-viewer-controls.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\npadding:12px 16px;\nborder-bottom:1px solid #e1e5e9;\nbackground-color:#f8f9fa}\n.pdf-viewer-actions.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:8px;\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.pdf-viewer-zoom.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:0.5rem}\n.pdf-viewer-zoom.jsx-8ee10e96954c68d5 .pdf-viewer-percentage.jsx-8ee10e96954c68d5{font-size:").concat(theme/* fontSizes.small */.CH.small, "}\n.pdf-viewer-actions.jsx-8ee10e96954c68d5 .pdf-viewer-action-button-text.jsx-8ee10e96954c68d5{margin-left:0.5rem}\n.pdf-viewer-content.jsx-8ee10e96954c68d5{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\noverflow:hidden;\nposition:relative}\n.pdf-viewer-loading.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nheight:100%;\ngap:12px;\ncolor:#6c757d}\n.pdf-viewer-error.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nheight:100%;\ngap:16px;\ncolor:#dc3545;\ntext-align:center;\npadding:20px}\n.error-actions.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:12px;\nmargin-top:16px}\n.pdf-document-container.jsx-8ee10e96954c68d5{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nwidth:100%;\nheight:100%;\noverflow:hidden}\n.pdf-iframe.jsx-8ee10e96954c68d5{width:100%;\nheight:100%;\nborder:none;\nbackground-color:#fff}\n.pdf-object.jsx-8ee10e96954c68d5{width:100%;\nheight:100%;\nborder:none}\n.pdf-fallback.jsx-8ee10e96954c68d5{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nheight:100%;\ngap:16px;\npadding:20px;\ntext-align:center;\ncolor:#6c757d}\n@media (max-width:768px) {.pdf-viewer-container.jsx-8ee10e96954c68d5{height:85vh;\nmax-width:100vw}\n.pdf-viewer-actions.jsx-8ee10e96954c68d5{flex-wrap:wrap;\ngap:6px}\n.error-actions.jsx-8ee10e96954c68d5{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\ngap:8px}\n.pdf-viewer-zoom.jsx-8ee10e96954c68d5 .pdf-viewer-percentage.jsx-8ee10e96954c68d5{display:none}}\n@media (max-width:576px) {.pdf-viewer-actions.jsx-8ee10e96954c68d5{gap:1rem}\n.pdf-viewer-actions.jsx-8ee10e96954c68d5 .pdf-viewer-action-button-text.jsx-8ee10e96954c68d5{display:none}}"));
styles_defaultExport.__hash = "8ee10e96954c68d5";
/* harmony default export */ var styles = (styles_defaultExport);

;// CONCATENATED MODULE: ./components/PDFViewer/index.js


/* eslint-disable react/jsx-filename-extension */ 





function PDFViewer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PDFViewer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
entry/* pdfjs.GlobalWorkerOptions.workerSrc */.v0.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@".concat(entry/* pdfjs.version */.v0.version, "/build/pdf.worker.min.js");
var SCALE_STEP = 0.05;
var PDFViewer = function(param1) {
    var file = param1.file, onCompleteScroll = param1.onCompleteScroll, children = param1.children, onCustomFullscreen = param1.onCustomFullscreen;
    var onDocumentLoadSuccess = function onDocumentLoadSuccess(param) {
        var pagesCount = param.numPages;
        setNumPages(pagesCount);
        setHasFullyLoaded(true);
    };
    var onLoadProgress = function onLoadProgress(progressData) {
    // Optional: Handle load progress if needed
    // console.log('Loading progress:', progressData);
    };
    var increasePageSize = function increasePageSize() {
        if (pageSize >= 2) {
            return;
        }
        setPageSize(function(prev) {
            return prev + SCALE_STEP;
        });
    };
    var decreasePageSize = function decreasePageSize() {
        if (pageSize <= 0.3) {
            return;
        }
        setPageSize(function(prev) {
            return prev - SCALE_STEP;
        });
    };
    var ref8 = (0,react.useState)(function() {
        return {
            loading: true,
            error: null,
            originalURL: file,
            pdfBlobUrl: null
        };
    }), /*#__PURE__*/ state = ref8[0], setState = ref8[1];
    var loading = state.loading, error = state.error, pdfBlobUrl = state.pdfBlobUrl;
    var ref1 = (0,react.useState)(null), numPages = ref1[0], setNumPages = ref1[1];
    var ref2 = (0,react.useState)(1), pageSize = ref2[0], setPageSize = ref2[1];
    var ref3 = (0,react.useState)(false), isFullscreen = ref3[0], setIsFullscreen = ref3[1];
    var ref4 = (0,react.useState)(false), hasScrollCompleted = ref4[0], setHasScrollCompleted = ref4[1];
    var ref5 = (0,react.useState)(false), hasFullyLoaded = ref5[0], setHasFullyLoaded = ref5[1];
    var pdfViewerContainerRef = (0,react.useRef)(null);
    var pdfContentRef = (0,react.useRef)(null);
    var calculatePageSize = (0,react.useCallback)(function() {
        var ref, ref6, ref7;
        var containerWidth = pdfViewerContainerRef === null || pdfViewerContainerRef === void 0 ? void 0 : (ref = pdfViewerContainerRef.current) === null || ref === void 0 ? void 0 : ref.querySelector('.pdf-viewer-content > div').getBoundingClientRect().width;
        var canvasWidth = (ref7 = pdfViewerContainerRef === null || pdfViewerContainerRef === void 0 ? void 0 : (ref6 = pdfViewerContainerRef.current) === null || ref6 === void 0 ? void 0 : ref6.querySelector('canvas')) === null || ref7 === void 0 ? void 0 : ref7.getBoundingClientRect().width;
        if (containerWidth && canvasWidth) {
            var rawScale = containerWidth / canvasWidth;
            var fittedScale = Number((Math.floor(rawScale / SCALE_STEP) * SCALE_STEP).toFixed(2));
            setPageSize(Number(fittedScale));
        }
    }, []);
    var onPageLoadSuccess = function(page) {
        if (page._pageIndex !== 0) {
            return;
        }
        calculatePageSize();
    };
    var checkPDFLoad = (0,react.useCallback)(function() {
        setPageSize(1);
        setState(function(prev) {
            return _objectSpread({}, prev, {
                loading: true,
                error: null
            });
        });
        fetch(file, {
            method: 'GET'
        }).then(function(response) {
            if (response.ok) {
                return response.blob();
            }
            throw new Error('PDF not accessible');
        }).then(function(blob) {
            var blobUrl = URL.createObjectURL(blob);
            setState(function(prev) {
                return _objectSpread({}, prev, {
                    loading: false,
                    error: null,
                    pdfBlobUrl: blobUrl
                });
            });
        }).catch(function() {
            setState(function(prev) {
                return _objectSpread({}, prev, {
                    loading: false,
                    error: 'No se pudo cargar el documento PDF'
                });
            });
        });
    }, [
        file
    ]);
    var refreshPDF = (0,react.useCallback)(function() {
        setHasFullyLoaded(false);
        setState(function(prev) {
            return _objectSpread({}, prev, {
                loading: true
            });
        });
        var isDesktop = window.innerWidth > 992;
        setTimeout(checkPDFLoad, isDesktop ? 1000 : 500);
    }, [
        checkPDFLoad
    ]);
    (0,react.useEffect)(function() {
        var handleOrientationChange = function() {
            refreshPDF();
        };
        window.addEventListener('orientationchange', handleOrientationChange);
        return function() {
            window.removeEventListener('orientationchange', handleOrientationChange);
        };
    }, [
        checkPDFLoad
    ]);
    var downloadPDF = (0,react.useCallback)(function() {
        var fileUrl = pdfBlobUrl || file;
        var link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'documento.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, [
        pdfBlobUrl,
        file
    ]);
    var openInNewWindow = (0,react.useCallback)(function() {
        var fileUrl = pdfBlobUrl || file;
        window.open(fileUrl, '_blank');
    }, [
        pdfBlobUrl,
        file
    ]);
    var toggleFullscreen = (0,react.useCallback)(function() {
        var newFullscreenState = !isFullscreen;
        setIsFullscreen(newFullscreenState);
        if (onCustomFullscreen) {
            onCustomFullscreen(newFullscreenState);
        }
        refreshPDF();
    }, [
        isFullscreen,
        onCustomFullscreen,
        checkPDFLoad
    ]);
    // Function to check if scroll is at the end or no scrollbar exists
    var checkScrollComplete = (0,react.useCallback)(function() {
        var contentElement = pdfContentRef.current;
        if (!contentElement || !onCompleteScroll || hasScrollCompleted || !hasFullyLoaded) return;
        var scrollTop = contentElement.scrollTop, scrollHeight = contentElement.scrollHeight, clientHeight = contentElement.clientHeight;
        // Check if there's no scrollbar (content fits in container)
        var hasNoScrollbar = scrollHeight <= clientHeight;
        // Check if scrolled to the end (with 1px tolerance for rounding)
        var isScrolledToEnd = scrollTop + clientHeight >= scrollHeight - 1;
        if (hasNoScrollbar || isScrolledToEnd) {
            setHasScrollCompleted(true);
            onCompleteScroll();
        }
    }, [
        onCompleteScroll,
        hasScrollCompleted,
        hasFullyLoaded
    ]);
    // Handle scroll events
    var handleScroll = (0,react.useCallback)(function() {
        checkScrollComplete();
    }, [
        checkScrollComplete
    ]);
    // Effect for file changes and initial load
    (0,react.useEffect)(function() {
        // Clean up previous blob URL when file changes
        setState(function(prevState) {
            if (prevState.pdfBlobUrl) {
                URL.revokeObjectURL(prevState.pdfBlobUrl);
            }
            return _objectSpread({}, prevState, {
                loading: true,
                error: null,
                pdfBlobUrl: null
            });
        });
        // Reset scroll completion state when file changes
        setHasScrollCompleted(false);
        setHasFullyLoaded(false);
        checkPDFLoad();
    }, [
        file,
        checkPDFLoad
    ]);
    // Effect to handle scroll events
    (0,react.useEffect)(function() {
        var contentElement = pdfContentRef.current;
        if (!contentElement) return;
        contentElement.addEventListener('scroll', handleScroll);
        return function() {
            contentElement.removeEventListener('scroll', handleScroll);
        };
    }, [
        handleScroll
    ]);
    // Effect to check scroll complete when PDF loads or changes
    (0,react.useEffect)(function() {
        if (!loading && !error && numPages && hasFullyLoaded) {
            // Use setTimeout to ensure DOM is fully rendered
            var timeoutId = setTimeout(function() {
                checkScrollComplete();
            }, 200);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        loading,
        error,
        numPages,
        hasFullyLoaded,
        checkScrollComplete
    ]);
    // Cleanup effect on unmount
    (0,react.useEffect)(function() {
        return function() {
            // Clean up blob URL to prevent memory leaks
            if (pdfBlobUrl) {
                URL.revokeObjectURL(pdfBlobUrl);
            }
        };
    }, [
        pdfBlobUrl
    ]);
    var displayUrl = pdfBlobUrl || file;
    var pageSizeToDisplay = Math.round(pageSize * 100);
    var dimensionSize = 0;
    if (window.innerHeight > window.innerWidth) {
        dimensionSize = window.innerHeight;
    } else if (window.innerWidth > 1400) {
        dimensionSize = window.innerWidth * 0.5;
    } else if (window.innerWidth > 1000) {
        dimensionSize = window.innerWidth * 0.75;
    } else {
        dimensionSize = window.innerWidth;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: pdfViewerContainerRef,
        className: "jsx-".concat(styles.__hash) + " " + (classnames_default()("pdf-viewer-container", {
            "fullscreen": isFullscreen
        }) || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-controls",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-actions",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                size: "small",
                                outline: true,
                                onClick: downloadPDF,
                                className: "pdf-viewer-action-button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        size: "small",
                                        icon: "ios-download"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-action-button-text",
                                        children: "Descargar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                size: "small",
                                outline: true,
                                onClick: openInNewWindow,
                                className: "pdf-viewer-action-button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        size: "small",
                                        icon: "ios-open"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-action-button-text",
                                        children: "Abrir en nueva ventana"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                size: "small",
                                outline: true,
                                onClick: checkPDFLoad,
                                className: "pdf-viewer-action-button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        size: "small",
                                        icon: "ios-refresh"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-action-button-text",
                                        children: "Recargar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                size: "small",
                                outline: true,
                                onClick: toggleFullscreen,
                                className: "pdf-viewer-action-button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        size: "small",
                                        icon: isFullscreen ? 'ios-contract' : 'ios-expand'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-action-button-text",
                                        children: isFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'
                                    })
                                ]
                            })
                        ]
                    }),
                    !loading && !error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-zoom",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                size: "small",
                                color: "tertiary",
                                onClick: decreasePageSize,
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "jsx-".concat(styles.__hash) + " " + 'pdf-viewer-percentage',
                                children: [
                                    pageSizeToDisplay,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                size: "small",
                                color: "tertiary",
                                onClick: increasePageSize,
                                children: "+"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    overflow: 'auto'
                },
                ref: pdfContentRef,
                className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-content",
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-loading",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-".concat(styles.__hash),
                                children: "Cargando documento..."
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(styles.__hash) + " " + "pdf-viewer-error",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: "ios-alert"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-".concat(styles.__hash),
                                children: error
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(styles.__hash) + " " + "error-actions",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                        type: "button",
                                        size: "small",
                                        onClick: openInNewWindow,
                                        children: "Abrir en nueva ventana"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                        type: "button",
                                        size: "small",
                                        outline: true,
                                        onClick: downloadPDF,
                                        children: "Descargar PDF"
                                    })
                                ]
                            })
                        ]
                    }),
                    !loading && !error && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(styles.__hash),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entry/* Document */.BB, {
                                file: displayUrl,
                                onLoadSuccess: onDocumentLoadSuccess,
                                onLoadProgress: onLoadProgress,
                                children: Array.from(new Array(numPages), function(el, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(entry/* Page */.T3, {
                                        height: dimensionSize,
                                        width: dimensionSize,
                                        scale: pageSize,
                                        pageNumber: index + 1,
                                        onLoadSuccess: onPageLoadSuccess
                                    }, "page_".concat(index + 1));
                                })
                            })
                        })
                    })
                ]
            }),
            children,
            (0,jsx_runtime.jsx)(style["default"], {
                id: styles.__hash,
                children: styles
            })
        ]
    }));
};
PDFViewer.propTypes = {
    file: (prop_types_default()).string.isRequired,
    onCompleteScroll: (prop_types_default()).func,
    children: (prop_types_default()).node,
    onCustomFullscreen: (prop_types_default()).func
};
/* harmony default export */ var components_PDFViewer = (PDFViewer);

// EXTERNAL MODULE: ./components/Tour/StepContainer/index.js
var StepContainer = __webpack_require__(43080);
;// CONCATENATED MODULE: ./components/Layout/Admin/FiscalInfoModal/Tour/steps.js



var steps = [
    {
        selector: '',
        content: function(param) {
            var goTo = param.goTo, step = param.step;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StepContainer/* default */.Z, {
                goTo: goTo,
                nextStep: step,
                title: "Bienvenido",
                description: "Te guiaremos por los campos importantes de este formulario de informaci\xf3n fiscal."
            });
        }
    },
    {
        selector: '[data-tour="fiscal-rfc"]',
        content: function(param) {
            var goTo = param.goTo, step = param.step;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StepContainer/* default */.Z, {
                goTo: goTo,
                nextStep: step,
                title: "RFC",
                description: "Registro Federal del contribuyente, para integraci\xf3n de expediente y como parte de los requisitos de la Ley de Prevenci\xf3n de Lavado de Dinero."
            });
        }
    },
    {
        selector: '[data-tour="fiscal-curp"]',
        content: function(param) {
            var goTo = param.goTo, step = param.step;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StepContainer/* default */.Z, {
                goTo: goTo,
                nextStep: step,
                title: "CURP",
                description: "La Clave \xdanica de Registro de Poblaci\xf3n, para integraci\xf3n de expediente y generaci\xf3n de contrato."
            });
        }
    },
    {
        selector: '[data-tour="fiscal-beneficiarios"]',
        content: function(param) {
            var goTo = param.goTo, step = param.step, close = param.close;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StepContainer/* default */.Z, {
                isLastStep: true,
                onClose: close,
                goTo: goTo,
                nextStep: step,
                title: "Beneficiarios",
                description: "Es necesaria la asignaci\xf3n de m\xednimo 1 o m\xe1ximo 3 personas como beneficiarios en caso de muerte del titular de la cuenta, estos beneficiarios ser\xe1n quienes reciban comisiones pendientes de cobro (de transacciones o de red)."
            });
        }
    }
];
/* harmony default export */ var Tour_steps = (steps);

;// CONCATENATED MODULE: ./components/Layout/Admin/FiscalInfoModal/Tour/index.js




function Tour_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tour_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tour_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FiscalInfoModalTour = function(props) {
    /*#__PURE__*/ return((0,jsx_runtime.jsx)(components/* ConnectedSimpleTour */.c8, Tour_objectSpread({
        steps: Tour_steps,
        disableKeyboardNavigation: [],
        tracingTourName: "fiscal-info-modal-tour"
    }, props)));
};
/* harmony default export */ var Tour = (FiscalInfoModalTour);

// EXTERNAL MODULE: ./app/selectors/config.js
var selectors_config = __webpack_require__(11131);
// EXTERNAL MODULE: ./app/selectors/user.js
var user = __webpack_require__(53584);
// EXTERNAL MODULE: ./components/utils/index.js + 1 modules
var utils = __webpack_require__(25164);
;// CONCATENATED MODULE: ./components/Layout/Admin/FiscalInfoModal/styles.js

var sequentialDocuments = new String(".sequential-documents.jsx-fa794b7eb9ff8ae3 .document-progress.jsx-fa794b7eb9ff8ae3{margin:1rem;\ntext-align:center}\n.sequential-documents.jsx-fa794b7eb9ff8ae3 .document-actions.jsx-fa794b7eb9ff8ae3{width:100%;\nmax-width:30rem;\nmargin:0.5rem auto;\npadding-right:1rem;\npadding-left:1rem}\n@media (max-width:992px) {.document-progress.jsx-fa794b7eb9ff8ae3{display:none}\n.sequential-documents.jsx-fa794b7eb9ff8ae3 .document-actions.jsx-fa794b7eb9ff8ae3 button.large.fullWidth.primary{height:2.375rem}}");
sequentialDocuments.__hash = "fa794b7eb9ff8ae3";
var documentsCompletedStyles = new String(".documents-completed.jsx-ab012e17bf607768{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nheight:100%;\nmin-height:400px}\n.completion-content.jsx-ab012e17bf607768{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ntext-align:center;\npadding:2rem 1rem}\n.success-icon-wrapper.jsx-ab012e17bf607768{position:relative;\nmargin-bottom:2rem}\n.success-icon-circle.jsx-ab012e17bf607768{width:100px;\nheight:100px;\nborder-radius:50%;\nbackground:".concat(theme/* colors.success */.O9.success, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nbox-shadow:0 4px 12px ").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.success */.O9.success, 0.3), ";\nposition:relative}\n.success-icon-circle.jsx-ab012e17bf607768 .success-checkmark{font-size:60px;\ncolor:").concat(theme/* colors.white */.O9.white, ";\nfont-weight:bold}\n.completion-main-title.jsx-ab012e17bf607768{font-size:2rem;\nfont-weight:700;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0 0 0.5rem 0}\n.completion-message-box.jsx-ab012e17bf607768{background:").concat(theme/* colors.white */.O9.white, ";\nborder-radius:16px;\npadding:2rem;\nbox-shadow:0 2px 8px ").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.black */.O9.black, 0.08), ";\nborder:2px solid ").concat(theme/* colors.border */.O9.border, ";\nmax-width:600px;\nwidth:100%}\n.message-item.jsx-ab012e17bf607768{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start;\ngap:1rem;\nmargin-bottom:1.5rem;\ntext-align:left;\npadding:1rem;\nborder-radius:12px;\nbackground:").concat(theme/* colors.lightGray */.O9.lightGray, "}\n.message-item.jsx-ab012e17bf607768:last-child{margin-bottom:0}\n.message-icon.jsx-ab012e17bf607768{font-size:1.5rem;\n-webkit-flex-shrink:0;\n-ms-flex-negative:0;\nflex-shrink:0;\nline-height:1;\nmargin-top:2px}\n.message-item.jsx-ab012e17bf607768 p.jsx-ab012e17bf607768{color:").concat(theme/* colors.text */.O9.text, ";\nfont-size:1rem;\nline-height:1.6;\nmargin:0}\n.message-item.jsx-ab012e17bf607768 p.jsx-ab012e17bf607768 strong.jsx-ab012e17bf607768{color:").concat(theme/* colors.primary */.O9.primary, ";\nfont-weight:600}\n.completion-actions.jsx-ab012e17bf607768{max-width:400px;\nwidth:100%;\nmargin:2rem 0;\npadding:0 1rem}\n.completion-actions.jsx-ab012e17bf607768 .button{font-size:1.125rem;\nfont-weight:600;\npadding:1rem 2rem;\nborder-radius:8px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\n.processing-acceptance.jsx-ab012e17bf607768{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmin-height:400px;\ntext-align:center}\n.processing-content.jsx-ab012e17bf607768{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:24px}\n.acceptance-error.jsx-ab012e17bf607768{text-align:center;\npadding:60px 40px;\nmargin:40px;\nmin-height:300px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.error-content.jsx-ab012e17bf607768{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-bottom:30px}\n.error-content.jsx-ab012e17bf607768 .ion-icon{font-size:48px;\nmargin-bottom:20px}\n.error-content.jsx-ab012e17bf607768 h2.jsx-ab012e17bf607768{font-size:28px;\nmargin:0 0 16px 0;\nfont-weight:600}\n.error-content.jsx-ab012e17bf607768 p.jsx-ab012e17bf607768{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:16px;\nmargin:0;\nline-height:1.5;\nmax-width:400px}\n.error-actions.jsx-ab012e17bf607768{max-width:300px;\nwidth:100%}"));
documentsCompletedStyles.__hash = "ab012e17bf607768";
var FiscalInfoModal_styles_defaultExport = new String(".modal-overlay.jsx-a190f20f1ae986e1{position:fixed;\ntop:0;\nleft:0;\nright:0;\nbottom:0;\nbackground-color:".concat(theme/* colors.alpha */.O9.alpha(theme/* colors.black */.O9.black, 0.8), ";\nz-index:1050;\nvisibility:hidden;\nopacity:0;\n-webkit-transition:opacity 300ms ease-in-out;\ntransition:opacity 300ms ease-in-out;\npointer-events:none}\n.fiscal-info-container.jsx-a190f20f1ae986e1 .modal{width:90%;\nmax-width:900px}\n.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .overlay{padding:0}\n.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1{height:100vh;\nmax-height:100%;\npadding:0}\n.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1 .sequential-documents, .fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1 .current-document, .fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1 .document-viewer, .fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1 .pdf-viewer-container{height:100%}\n.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .overlay .modal{width:100%;\nmax-width:100%;\npadding:0;\nmargin:0;\nmargin-top:0;\nheight:100%;\nborder-radius:0}\n.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .modal .pdf-viewer-container{margin:0;\nmax-width:100%}\n.modal-overlay.visible.jsx-a190f20f1ae986e1{visibility:visible;\nopacity:1;\npointer-events:all}\n.fiscal-modal-container.jsx-a190f20f1ae986e1{max-height:90vh;\noverflow-y:scroll;\nbackground:").concat(theme/* colors.white */.O9.white, ";\nborder-radius:8px;\nposition:relative;\nz-index:1051;\npadding:2rem}\n.fiscal-modal-container.has-documents.jsx-a190f20f1ae986e1{padding:0}\n.fiscal-modal-container.generation-loading.jsx-a190f20f1ae986e1{overflow:hidden;\nscroll-behavior:none}\n.modal-header.jsx-a190f20f1ae986e1{text-align:center;\nmargin-bottom:2rem;\npadding-bottom:1rem;\nborder-bottom:1px solid ").concat(theme/* colors.border */.O9.border, "}\n.modal-header.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.bold */.Rq.bold, ";\nfont-size:").concat(theme/* fontSizes.h3 */.CH.h3, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0 0 0.5rem 0}\n.modal-header-content.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:row;\n-ms-flex-direction:row;\nflex-direction:row;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\nmargin-right:1rem;\ngap:1rem;\n-webkit-align-items:flex-end;\n-webkit-box-align:flex-end;\n-ms-flex-align:flex-end;\nalign-items:flex-end}\n.modal-header-content.jsx-a190f20f1ae986e1 .tracing-tour-container{margin-bottom:0}\n.modal-subtitle.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.body */.CH.body, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0}\n.fiscal-form.jsx-a190f20f1ae986e1{width:100%}\n.form-content.jsx-a190f20f1ae986e1{margin-bottom:2rem}\n.form-content.jsx-a190f20f1ae986e1 .form-input-margin{margin-bottom:1.5rem}\n.beneficiaries-container.jsx-a190f20f1ae986e1{margin-top:2rem;\npadding-top:2rem;\nborder-top:1px solid ").concat(theme/* colors.border */.O9.border, "}\n.beneficiaries-header.jsx-a190f20f1ae986e1{margin-bottom:1.5rem}\n.beneficiaries-title.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between}\n.beneficiaries-header.jsx-a190f20f1ae986e1 h4.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.h4 */.CH.h4, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0 0 0.5rem 0}\n.beneficiaries-subtitle.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0}\n.beneficiaries-error.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.medium */.Rq.medium, ";\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncolor:").concat(theme/* colors.danger */.O9.danger, ";\ndisplay:block;\nmargin-top:0.5rem}\n.beneficiaries-content.jsx-a190f20f1ae986e1{margin-bottom:1rem}\n.beneficiary-group.jsx-a190f20f1ae986e1{margin-bottom:2rem;\npadding:1.5rem;\nbackground-color:").concat(theme/* colors.lightGray */.O9.lightGray, ";\nborder-radius:8px;\nborder:1px solid ").concat(theme/* colors.border */.O9.border, ";\nposition:relative}\n.beneficiary-header.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-bottom:1rem;\npadding-bottom:0.5rem;\nborder-bottom:1px solid ").concat(theme/* colors.borderInput */.O9.borderInput, "}\n.beneficiary-header.jsx-a190f20f1ae986e1 h5.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.h5 */.CH.h5, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0}\n.remove-beneficiary-btn.jsx-a190f20f1ae986e1{background:").concat(theme/* colors.danger */.O9.danger, ";\ncolor:").concat(theme/* colors.white */.O9.white, ";\nborder:none;\nborder-radius:50%;\nwidth:30px;\nheight:30px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ncursor:pointer;\n-webkit-transition:all 0.2s ease;\ntransition:all 0.2s ease;\nfont-size:").concat(theme/* fontSizes.body */.CH.body, "}\n.remove-beneficiary-btn.jsx-a190f20f1ae986e1:hover{background:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.danger */.O9.danger, 0.8), ";\n-webkit-transform:scale(1.1);\n-moz-transform:scale(1.1);\n-ms-transform:scale(1.1);\ntransform:scale(1.1)}\n.beneficiary-errors.jsx-a190f20f1ae986e1{margin-top:1rem;\npadding:1rem;\nbackground-color:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.danger */.O9.danger, 0.1), ";\nborder-radius:4px;\nborder-left:4px solid ").concat(theme/* colors.danger */.O9.danger, "}\n.beneficiary-field-error.jsx-a190f20f1ae986e1{display:block;\nfont:").concat(theme/* fonts.medium */.Rq.medium, ";\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncolor:").concat(theme/* colors.danger */.O9.danger, ";\nmargin-bottom:0.25rem}\n.beneficiary-field-error.jsx-a190f20f1ae986e1:last-child{margin-bottom:0}\n.add-beneficiary-container.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center;\nmargin-top:1.5rem}\n.add-beneficiary-btn.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:0.5rem;\npadding:0.75rem 1.5rem;\nfont:").concat(theme/* fonts.medium */.Rq.medium, ";\nfont-size:").concat(theme/* fontSizes.body */.CH.body, "}\n.add-beneficiary-btn.jsx-a190f20f1ae986e1 .ion-icon{font-size:").concat(theme/* fontSizes.h5 */.CH.h5, "}\n.beneficiary-group.jsx-a190f20f1ae986e1 h5.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.h5 */.CH.h5, ";\ncolor:").concat(theme/* colors.text */.O9.text, ";\nmargin:0 0 1rem 0;\npadding-bottom:0.5rem;\nborder-bottom:1px solid ").concat(theme/* colors.borderInput */.O9.borderInput, "}\n.modal-actions.jsx-a190f20f1ae986e1{padding-top:2rem;\nborder-top:1px solid ").concat(theme/* colors.border */.O9.border, "}\n.modal-actions.jsx-a190f20f1ae986e1 .button{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.body */.CH.body, ";\npadding:1rem 2rem}\n@media (min-width:1024px) {button#fiscal-logout-button-mobile.jsx-a190f20f1ae986e1{display:none!important}\nbutton#fiscal-logout-button-desktop.jsx-a190f20f1ae986e1{display:block!important}}\n@media (max-width:1023px) {#fiscal-logout-button-mobile.jsx-a190f20f1ae986e1{display:block!important}\n#fiscal-logout-button-desktop.jsx-a190f20f1ae986e1{display:none!important}}\n@media (max-width:992px) {.fiscal-info-container.jsx-a190f20f1ae986e1 .modal{width:100%}\n.fiscal-info-container.jsx-a190f20f1ae986e1 .overlay{padding:0.5rem}\n.beneficiaries-header.jsx-a190f20f1ae986e1{padding:0 0.5rem}\n.fiscal-info-container.jsx-a190f20f1ae986e1 .modal .fiscal-modal-container{padding:0.5rem 0}\n.fiscal-info-container.jsx-a190f20f1ae986e1 .modal .fiscal-modal-container .fiscal-form .fiscal-form-row{width:100%;\nmargin-left:0;\nmargin-right:0}}\n@media (max-width:768px) {.fiscal-info-container.full-screen.jsx-a190f20f1ae986e1 .fiscal-modal-container.jsx-a190f20f1ae986e1{height:100%}\n.fiscal-modal-container.jsx-a190f20f1ae986e1{padding:1rem;\nmax-height:90dvh;\noverflow-y:scroll}\n.modal-header.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{font-size:").concat(theme/* fontSizes.h4 */.CH.h4, "}\n.beneficiary-group.jsx-a190f20f1ae986e1{padding:1rem}\n.remove-beneficiary-btn.jsx-a190f20f1ae986e1{width:28px;\nheight:28px;\nfont-size:").concat(theme/* fontSizes.small */.CH.small, "}\n.add-beneficiary-btn.jsx-a190f20f1ae986e1{padding:0.5rem 1rem;\nfont-size:").concat(theme/* fontSizes.small */.CH.small, "}}\n@media (max-width:548px) {.fiscal-info-container.jsx-a190f20f1ae986e1 .overlay{padding:0}}\n@media (max-width:480px) {.modal-header.jsx-a190f20f1ae986e1{margin-bottom:1.5rem}\n.form-content.jsx-a190f20f1ae986e1 .form-input-margin{margin-bottom:1rem}\n.beneficiaries-container.jsx-a190f20f1ae986e1{margin-top:1.5rem;\npadding-top:1.5rem}\n.beneficiary-group.jsx-a190f20f1ae986e1{margin-bottom:1.5rem;\npadding:0.75rem}\n.beneficiary-header.jsx-a190f20f1ae986e1{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start;\ngap:0.5rem}\n.remove-beneficiary-btn.jsx-a190f20f1ae986e1{-webkit-align-self:flex-end;\n-ms-flex-item-align:flex-end;\nalign-self:flex-end}}\n.documents-section.jsx-a190f20f1ae986e1{padding:30px}\n.documents-section.jsx-a190f20f1ae986e1 h4.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.primary */.O9.primary, ";\nfont-size:20px;\nmargin-bottom:8px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:8px}\n.documents-subtitle.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:14px;\nmargin-bottom:24px;\nline-height:1.5}\n.documents-list.jsx-a190f20f1ae986e1{background:").concat(theme/* colors.lightGray */.O9.lightGray, ";\nborder-radius:8px;\npadding:16px;\nmargin-bottom:24px}\n.document-item.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-box-pack:justify;\n-webkit-justify-content:space-between;\njustify-content:space-between;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\npadding:16px;\nbackground:").concat(theme/* colors.white */.O9.white, ";\nborder-radius:6px;\nborder:1px solid ").concat(theme/* colors.border */.O9.border, ";\nmargin-bottom:12px;\n-webkit-transition:all 0.2s ease;\ntransition:all 0.2s ease}\n.document-item.jsx-a190f20f1ae986e1:last-child{margin-bottom:0}\n.document-item.jsx-a190f20f1ae986e1:hover{border-color:").concat(theme/* colors.primary */.O9.primary, ";\nbox-shadow:0 2px 8px rgba(0, 0, 0, 0.1)}\n.document-info.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:12px}\n.document-info.jsx-a190f20f1ae986e1 .ion-icon{font-size:20px;\ncolor:").concat(theme/* colors.primary */.O9.primary, "}\n.document-name.jsx-a190f20f1ae986e1{font-weight:500;\ncolor:").concat(theme/* colors.text */.O9.text, ";\nfont-size:15px}\n.document-actions.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:8px}\n.documents-actions.jsx-a190f20f1ae986e1{border-top:1px solid ").concat(theme/* colors.border */.O9.border, ";\npadding-top:20px}\n@media (max-width:768px) {.document-item.jsx-a190f20f1ae986e1{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\ngap:12px;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start}\n.document-actions.jsx-a190f20f1ae986e1{width:100%;\n-webkit-box-pack:end;\n-ms-flex-pack:end;\n-webkit-justify-content:flex-end;\njustify-content:flex-end}\n.documents-section.jsx-a190f20f1ae986e1{padding:20px}}\n.sequential-documents.jsx-a190f20f1ae986e1{padding:30px}\n.progress-counter.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:14px;\nfont-weight:500;\ndisplay:block;\nmargin-bottom:12px}\n.progress-bar.jsx-a190f20f1ae986e1{width:100%;\nheight:8px;\nbackground-color:").concat(theme/* colors.lightGray */.O9.lightGray, ";\nborder-radius:4px;\noverflow:hidden}\n.progress-fill.jsx-a190f20f1ae986e1{height:100%;\nbackground-color:").concat(theme/* colors.primary */.O9.primary, ";\n-webkit-transition:width 0.3s ease;\ntransition:width 0.3s ease}\n.current-document.jsx-a190f20f1ae986e1{background-color:").concat(theme/* colors.white */.O9.white, ";\nborder:1px solid ").concat(theme/* colors.border */.O9.border, ";\nborder-radius:12px;\noverflow:hidden;\nbox-shadow:0 4px 16px rgba(0, 0, 0, 0.1)}\n.document-viewer.jsx-a190f20f1ae986e1{min-height:500px;\nmax-height:700px;\noverflow:hidden}\n.document-actions.jsx-a190f20f1ae986e1{padding:24px;\nbackground-color:").concat(theme/* colors.lightGray */.O9.lightGray, ";\nmargin-top:1rem}\n.document-actions.jsx-a190f20f1ae986e1 .button{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:8px;\nfont-size:16px;\nfont-weight:600;\npadding:14px 24px}\n.document-actions.jsx-a190f20f1ae986e1 .ion-icon{font-size:20px}\n.documents-completed.jsx-a190f20f1ae986e1{text-align:center;\npadding:80px 40px;\nbackground-color:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.success */.O9.success || theme/* colors.primary */.O9.primary, 0.05), ";\nborder:1px solid ").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.success */.O9.success || theme/* colors.primary */.O9.primary, 0.2), ";\nborder-radius:16px;\nmargin:40px;\nmin-height:400px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nposition:relative;\nz-index:5}\n.completion-content.jsx-a190f20f1ae986e1{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-bottom:40px}\n.completion-content.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.primary */.O9.primary, ";\nfont-size:36px;\nmargin:0 0 20px 0;\nfont-weight:700;\nfont-family:").concat(theme/* fonts.display */.Rq.display || theme/* fonts.regular */.Rq.regular, "}\n.completion-content.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:18px;\nmargin:0;\nline-height:1.5;\nmax-width:500px}\n.completion-actions.jsx-a190f20f1ae986e1{max-width:350px;\nwidth:100%;\nposition:relative;\nz-index:10}\n.completion-actions.jsx-a190f20f1ae986e1 .button{position:relative;\nz-index:11;\npointer-events:auto;\ncursor:pointer}\n.processing-message.jsx-a190f20f1ae986e1{margin-top:20px}\n.processing-message.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:16px;\nmargin:0;\nfont-style:italic}\n.processing-acceptance.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmin-height:400px;\ntext-align:center}\n.processing-content.jsx-a190f20f1ae986e1{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:24px}\n.processing-content.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.primary */.O9.primary, ";\nfont-size:28px;\nmargin:0;\nfont-weight:600}\n.processing-content.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:16px;\nmargin:0;\nline-height:1.5;\nmax-width:400px}\n.document-actions.jsx-a190f20f1ae986e1 .button:disabled{opacity:0.7;\ncursor:not-allowed}\n.document-actions.jsx-a190f20f1ae986e1 .button .spinner{margin-right:8px}\n.generation-loading-content.jsx-a190f20f1ae986e1{text-align:center;\npadding:5rem;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\n.generation-loading-content.jsx-a190f20f1ae986e1 h3.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.semiBold */.Rq.semiBold, ";\nfont-size:").concat(theme/* fontSizes.h4 */.CH.h4, ";\ncolor:").concat(theme/* colors.primary */.O9.primary, ";\nmargin:20px 0 16px 0}\n.generation-loading-content.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{font:").concat(theme/* fonts.regular */.Rq.regular, ";\nfont-size:").concat(theme/* fontSizes.body */.CH.body, ";\ncolor:").concat(theme/* colors.lightText */.O9.lightText, ";\nmargin:0;\nline-height:1.5}\n.acceptance-error.jsx-a190f20f1ae986e1{text-align:center;\npadding:60px 40px;\nbackground-color:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.danger */.O9.danger || theme/* colors.red */.O9.red, 0.05), ";\nborder:1px solid ").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.danger */.O9.danger || theme/* colors.red */.O9.red, 0.2), ";\nborder-radius:16px;\nmargin:40px;\nmin-height:300px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.error-content.jsx-a190f20f1ae986e1{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-justify-content:center;\njustify-content:center;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-bottom:30px}\n.error-content.jsx-a190f20f1ae986e1 .ion-icon{font-size:48px;\ncolor:").concat(theme/* colors.danger */.O9.danger || theme/* colors.red */.O9.red, ";\nmargin-bottom:20px}\n.error-content.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.danger */.O9.danger || theme/* colors.red */.O9.red, ";\nfont-size:28px;\nmargin:0 0 16px 0;\nfont-weight:600}\n.error-content.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.lightText */.O9.lightText, ";\nfont-size:16px;\nmargin:0;\nline-height:1.5;\nmax-width:400px}\n.error-actions.jsx-a190f20f1ae986e1{max-width:300px;\nwidth:100%}\n@media (max-width:768px) {.acceptance-error.jsx-a190f20f1ae986e1{padding:40px 20px;\nmargin:20px;\nmin-height:250px}\n.error-content.jsx-a190f20f1ae986e1 h2.jsx-a190f20f1ae986e1{font-size:24px}\n.error-content.jsx-a190f20f1ae986e1 .ion-icon{font-size:40px}\n.document-progress.jsx-a190f20f1ae986e1{display:none}\n.completion-main-title.jsx-a190f20f1ae986e1{font-size:1.5rem}\n.success-icon-circle.jsx-a190f20f1ae986e1{width:80px;\nheight:80px}\n.success-icon-circle.jsx-a190f20f1ae986e1 .success-checkmark{font-size:48px}\n.completion-message-box.jsx-a190f20f1ae986e1{padding:1.5rem}\n.message-item.jsx-a190f20f1ae986e1{padding:0.75rem;\ngap:0.75rem}\n.message-icon.jsx-a190f20f1ae986e1{font-size:1.25rem}\n.message-item.jsx-a190f20f1ae986e1 p.jsx-a190f20f1ae986e1{font-size:0.9rem}}\n@media (max-width:768px) {.sequential-documents.jsx-a190f20f1ae986e1{padding:20px}\n.document-header.jsx-a190f20f1ae986e1{padding:20px 16px}\n.document-actions.jsx-a190f20f1ae986e1{padding:20px 16px}\n.documents-completed.jsx-a190f20f1ae986e1{padding:40px 20px;\nmargin:20px;\nmin-height:300px}\n.completion-content.jsx-a190f20f1ae986e1{padding:1rem 0.5rem}\n.completion-header.jsx-a190f20f1ae986e1 .ion-icon{font-size:48px}}\n.percentage-indicator.jsx-a190f20f1ae986e1{text-align:center;\nmargin:15px 0;\npadding:10px;\nborder-radius:4px;\nbackground-color:").concat(theme/* colors.lightGray */.O9.lightGray, "}\n.percentage-total.jsx-a190f20f1ae986e1{font-weight:600;\nfont-size:14px}\n.percentage-total.valid.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.success */.O9.success, "}\n.percentage-total.invalid.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.danger */.O9.danger, "}\n.field-error.jsx-a190f20f1ae986e1{color:").concat(theme/* colors.danger */.O9.danger, ";\nfont-size:12px;\nmargin-top:4px;\nfont-weight:500}\n.form-errors.jsx-a190f20f1ae986e1{margin:15px 0;\npadding:12px;\nbackground-color:").concat(theme/* colors.alpha */.O9.alpha(theme/* colors.danger */.O9.danger, 0.1), ";\nborder:1px solid ").concat(theme/* colors.danger */.O9.danger, ";\nborder-radius:4px;\ncolor:").concat(theme/* colors.danger */.O9.danger, "}\n.form-error.jsx-a190f20f1ae986e1{margin-bottom:5px;\nfont-size:14px}\n.form-error.jsx-a190f20f1ae986e1:last-child{margin-bottom:0}\n.external-logout-container.jsx-a190f20f1ae986e1{position:fixed;\ntop:20px;\nright:20px;\nz-index:99999;\nbackground:rgba(255, 255, 255, 0.9);\npadding:8px;\nborder-radius:6px;\nbox-shadow:0 2px 10px rgba(0, 0, 0, 0.2)}\n@media screen and (max-width:768px) {.external-logout-container.jsx-a190f20f1ae986e1{top:10px;\nright:10px}}\n.fiscal-info-modal .overlay.top .modal{margin-top:3.5rem!important}"));
FiscalInfoModal_styles_defaultExport.__hash = "a190f20f1ae986e1";
/* harmony default export */ var FiscalInfoModal_styles = (FiscalInfoModal_styles_defaultExport);

;// CONCATENATED MODULE: ./components/Layout/Admin/FiscalInfoModal/index.js





















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function FiscalInfoModal_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function FiscalInfoModal_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function FiscalInfoModal_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function FiscalInfoModal_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) FiscalInfoModal_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) FiscalInfoModal_defineProperties(Constructor, staticProps);
    return Constructor;
}
function FiscalInfoModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FiscalInfoModal_getPrototypeOf(o) {
    FiscalInfoModal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return FiscalInfoModal_getPrototypeOf(o);
}
function FiscalInfoModal_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) FiscalInfoModal_setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FiscalInfoModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FiscalInfoModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FiscalInfoModal_possibleConstructorReturn(self, call) {
    if (call && (FiscalInfoModal_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return FiscalInfoModal_assertThisInitialized(self);
}
function FiscalInfoModal_setPrototypeOf(o, p) {
    FiscalInfoModal_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return FiscalInfoModal_setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var FiscalInfoModal_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function FiscalInfoModal_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function FiscalInfoModal_createSuper(Derived) {
    var hasNativeReflectConstruct = FiscalInfoModal_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = FiscalInfoModal_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = FiscalInfoModal_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return FiscalInfoModal_possibleConstructorReturn(this, result);
    };
}
var SERVICE_CONTRACT = 'service-contract';
var BENEFICIARY_DECLARATION = 'beneficiary-declaration';
var BUSINESS_STRATEGY_CONTRACT = 'business-strategy-contract';
var _obj;
var DOCUMENT_NAMES = (_obj = {}, FiscalInfoModal_defineProperty(_obj, SERVICE_CONTRACT, 'Contrato de prestaci\xf3n de servicios'), FiscalInfoModal_defineProperty(_obj, BENEFICIARY_DECLARATION, 'Declaraci\xf3n de beneficiarios'), FiscalInfoModal_defineProperty(_obj, BUSINESS_STRATEGY_CONTRACT, 'Estrategia comercial de marketing y remuneraci\xf3n'), _obj);
var PercentageIndicator = function(param) {
    var beneficiaries = param.beneficiaries;
    var calculateTotal = function() {
        if (!beneficiaries || !Array.isArray(beneficiaries)) return 0;
        return beneficiaries.reduce(function(total, beneficiary) {
            if (!beneficiary) return total;
            var hasName = beneficiary.nombre && beneficiary.nombre.trim();
            var hasRelationship = beneficiary.parentesco && beneficiary.parentesco.trim();
            var hasAddress = beneficiary.domicilio && beneficiary.domicilio.trim();
            var hasPercentage = beneficiary.porcentaje && beneficiary.porcentaje.toString().trim() && !isNaN(Number(beneficiary.porcentaje)) && Number(beneficiary.porcentaje) > 0;
            // Only count complete beneficiaries
            var isComplete = hasName && hasRelationship && hasAddress && hasPercentage;
            if (isComplete) {
                var percentage = Number(beneficiary.porcentaje);
                if (percentage >= 1 && percentage <= 100) {
                    return total + percentage;
                }
            }
            return total;
        }, 0);
    };
    var total1 = calculateTotal();
    var isValid = total1 === 100;
    var hasAnyPercentage = total1 > 0;
    if (!hasAnyPercentage) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-a20ac38dc7457d06" + " " + "percentage-indicator",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "jsx-a20ac38dc7457d06" + " " + "percentage-total ".concat(isValid ? 'valid' : 'invalid'),
                children: [
                    "Total de porcentajes: ",
                    total1,
                    "% ",
                    isValid ? '✓' : "(requiere 100%)"
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: "a20ac38dc7457d06",
                children: ".percentage-indicator.jsx-a20ac38dc7457d06{text-align:center;\nmargin:15px 0;\npadding:10px;\nborder-radius:4px;\nbackground-color:#f5f7fa;\nborder:1px solid #e0e5ee}\n.percentage-total.jsx-a20ac38dc7457d06{font-weight:600;\nfont-size:14px}\n.percentage-total.valid.jsx-a20ac38dc7457d06{color:#27ae60}\n.percentage-total.invalid.jsx-a20ac38dc7457d06{color:#e8011b}"
            })
        ]
    }));
};
var BeneficiaryFields = function(param) {
    var fields = param.fields, _meta = param.meta, touched = _meta.touched, error = _meta.error;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
        "data-tour": "fiscal-beneficiarios",
        className: /*#__PURE__*/ "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                            children: "Beneficiarios"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-subtitle",
                        children: "Debe completar al menos 1 beneficiario. La suma de porcentajes debe ser exactamente 100%"
                    }),
                    touched && error && error._error && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-error",
                        children: error._error
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiaries-content",
                children: [
                    fields.map(function(member, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiary-group",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiary-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                                            children: [
                                                "Beneficiario ",
                                                index + 1
                                            ]
                                        }),
                                        fields.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                return fields.remove(index);
                                            },
                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "remove-beneficiary-btn",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-close"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                    className: "fiscal-form-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: 12,
                                            md: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                name: "".concat(member, ".nombre"),
                                                id: "beneficiary-name-".concat(index),
                                                component: controls/* InputForm */.M5,
                                                placeholder: "Nombre completo",
                                                label: "Nombre completo",
                                                className: "form-input-margin"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: 12,
                                            md: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                name: "".concat(member, ".parentesco"),
                                                id: "beneficiary-relationship-".concat(index),
                                                component: controls/* InputForm */.M5,
                                                placeholder: "Parentesco",
                                                label: "Parentesco",
                                                className: "form-input-margin"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                    className: "fiscal-form-row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: 12,
                                            md: 8,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                name: "".concat(member, ".domicilio"),
                                                id: "beneficiary-address-".concat(index),
                                                component: controls/* InputForm */.M5,
                                                placeholder: "Domicilio completo",
                                                label: "Domicilio completo",
                                                className: "form-input-margin"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                            xs: 12,
                                            md: 4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                name: "".concat(member, ".porcentaje"),
                                                id: "beneficiary-percentage-".concat(index),
                                                component: controls/* InputForm */.M5,
                                                type: "number",
                                                min: "1",
                                                max: "100",
                                                step: "1",
                                                placeholder: "Porcentaje (1-100)",
                                                label: "Porcentaje (%)",
                                                className: "form-input-margin"
                                            })
                                        })
                                    ]
                                }),
                                touched && error && error[index] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiary-errors",
                                    children: Object.keys(error[index]).map(function(fieldName) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "beneficiary-field-error",
                                            children: error[index][fieldName]
                                        }, fieldName);
                                    })
                                })
                            ]
                        }, index);
                    }),
                    fields.length < 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "add-beneficiary-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                            type: "button",
                            color: "primary",
                            outline: true,
                            onClick: function() {
                                return fields.push({});
                            },
                            className: "add-beneficiary-btn",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "ios-add"
                                }),
                                "Agregar Beneficiario"
                            ]
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: FiscalInfoModal_styles.__hash,
                children: FiscalInfoModal_styles
            })
        ]
    }));
};
var GeneratingDocuments = function(param) {
    var isSubmitting = param.isSubmitting, children = param.children;
    if (!isSubmitting) {
        return children;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "generation-loading-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                        size: 50
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                        children: "Generando documentos..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                        children: "Por favor, espere mientras procesamos su informaci\xf3n y generamos los documentos necesarios."
                    })
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: FiscalInfoModal_styles.__hash,
                children: FiscalInfoModal_styles
            })
        ]
    }));
};
var FiscalInfoModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    FiscalInfoModal_inherits(FiscalInfoModal, Component1);
    var _super = FiscalInfoModal_createSuper(FiscalInfoModal);
    function FiscalInfoModal(props) {
        FiscalInfoModal_classCallCheck(this, FiscalInfoModal);
        var _this;
        _this = _super.call(this, props);
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "handleFormSubmit", function(values) {
            // Save form data to SessionStorage for persistence
            (0,fiscalProgressStorage/* saveFormData */.lg)(values);
            // Transform form data to match API structure
            var transformedData = {
                CURP: values.curp || '',
                RFC: values.rfc,
                nationality: values.nationality,
                notification_address: values.notificationAddress || '',
                beneficiaries: (values.beneficiaries || []).filter(function(beneficiary) {
                    return beneficiary && beneficiary.nombre && beneficiary.parentesco && beneficiary.domicilio && beneficiary.porcentaje;
                }).map(function(beneficiary) {
                    return {
                        full_name: beneficiary.nombre,
                        address: beneficiary.domicilio,
                        percentage: beneficiary.porcentaje,
                        relationship: beneficiary.parentesco
                    };
                })
            };
            // Call the saga action - wrap data in the format the saga expects
            _this.props.generateInitialDocuments(transformedData);
        });
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "handleAcceptDocument", function() {
            var _props = _this.props, fiscalDocuments = _props.fiscalDocuments, acceptDocument = _props.acceptDocument, acceptContracts = _props.acceptContracts;
            var _state = _this.state, currentDocumentIndex = _state.currentDocumentIndex, acceptedDocuments = _state.acceptedDocuments;
            // Set loading state
            _this.setState({
                isAcceptingDocument: true
            });
            var currentDocumentKey = fiscalDocuments[currentDocumentIndex].key;
            var newAcceptedDocuments = _toConsumableArray(acceptedDocuments).concat([
                currentDocumentKey, 
            ]);
            // Simulate processing delay for better UX
            setTimeout(function() {
                // Check if there are more documents
                if (currentDocumentIndex + 1 < fiscalDocuments.length) {
                    // Move to next document and persist progress
                    var nextIndex = currentDocumentIndex + 1;
                    acceptDocument(currentDocumentKey, nextIndex);
                    _this.setState({
                        currentDocumentIndex: nextIndex,
                        acceptedDocuments: newAcceptedDocuments,
                        isAcceptingDocument: false,
                        currentDocumentAcceptButtonDisabled: true
                    });
                } else {
                    // All documents accepted, call the acceptance endpoint
                    acceptDocument(currentDocumentKey, currentDocumentIndex);
                    _this.setState({
                        acceptedDocuments: newAcceptedDocuments
                    });
                    // Call the acceptance API (keep loading state until API responds)
                    acceptContracts();
                }
            }, 800) // Small delay to show loading state
            ;
        });
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "handleViewPDF", function(pdfUrl, documentName) {
            _this.setState({
                showPDFViewer: true,
                currentPDF: pdfUrl,
                currentPDFName: documentName
            });
        });
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "handleClosePDFViewer", function() {
            _this.setState({
                showPDFViewer: false,
                currentPDF: null,
                currentPDFName: null
            });
        });
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "handleCloseModal", function() {
            // Clear SessionStorage when modal is closed after completion
            (0,fiscalProgressStorage/* clearFiscalProgress */.Ao)();
            // Call the original onClose prop
            _this.props.onClose();
        });
        FiscalInfoModal_defineProperty(FiscalInfoModal_assertThisInitialized(_this), "renderSequentialDocuments", function() {
            var _props = _this.props, fiscalDocuments = _props.fiscalDocuments, acceptanceFeedback = _props.acceptanceFeedback, reduxAcceptedDocuments = _props.acceptedDocuments;
            var _state = _this.state, currentDocumentIndex = _state.currentDocumentIndex, localAcceptedDocuments = _state.acceptedDocuments, isAcceptingDocument = _state.isAcceptingDocument, currentDocumentAcceptButtonDisabled = _state.currentDocumentAcceptButtonDisabled;
            if (!fiscalDocuments || fiscalDocuments.length === 0) {
                return null;
            }
            var totalDocuments = fiscalDocuments.length;
            // Use Redux state for accepted documents, fallback to local state
            var acceptedDocuments = reduxAcceptedDocuments && reduxAcceptedDocuments.length > 0 ? reduxAcceptedDocuments : localAcceptedDocuments;
            // Check if all documents have been accepted
            var allDocumentsAccepted = acceptedDocuments.length === totalDocuments;
            var isProcessingAcceptance = acceptanceFeedback === null || acceptanceFeedback === void 0 ? void 0 : acceptanceFeedback.loading;
            var hasAcceptanceError = (acceptanceFeedback === null || acceptanceFeedback === void 0 ? void 0 : acceptanceFeedback.error) || (acceptanceFeedback === null || acceptanceFeedback === void 0 ? void 0 : acceptanceFeedback.errors) && Object.keys(acceptanceFeedback.errors).length > 0;
            if (allDocumentsAccepted) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "documents-completed",
                    children: [
                        isProcessingAcceptance ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "processing-acceptance",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "processing-content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                        size: 60
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "jsx-".concat(documentsCompletedStyles.__hash),
                                        children: "Procesando aceptaci\xf3n..."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(documentsCompletedStyles.__hash),
                                        children: "Estamos registrando la aceptaci\xf3n de sus documentos. Por favor, espere un momento."
                                    })
                                ]
                            })
                        }) : hasAcceptanceError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "acceptance-error",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "error-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                            icon: "ios-warning"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "jsx-".concat(documentsCompletedStyles.__hash),
                                            children: "Error al procesar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "jsx-".concat(documentsCompletedStyles.__hash),
                                            children: "Hubo un error al registrar la aceptaci\xf3n de los documentos. Por favor, int\xe9ntelo nuevamente."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "error-actions",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                        type: "button",
                                        color: "danger",
                                        outline: true,
                                        fullWidth: true,
                                        onClick: function() {
                                            // Reset state to allow retry
                                            _this.setState({
                                                currentDocumentIndex: fiscalDocuments.length - 1,
                                                acceptedDocuments: acceptedDocuments.slice(0, -1)
                                            });
                                        },
                                        children: "Reintentar"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "completion-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "success-icon-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "success-icon-circle",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                    icon: "ios-checkmark",
                                                    className: "success-checkmark"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "completion-main-title",
                                            children: "Documentos Aceptados 🎊"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "completion-message-box",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-icon",
                                                            children: "✅"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash),
                                                            children: "Has completado exitosamente la revisi\xf3n y aceptaci\xf3n de todos los documentos."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-icon",
                                                            children: "📧"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash),
                                                            children: "Te hemos enviado un correo con los datos de acceso a tu email y dashboard de iad."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "message-icon",
                                                            children: "🚀"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "jsx-".concat(documentsCompletedStyles.__hash),
                                                            children: [
                                                                "A continuaci\xf3n ser\xe1s redirigido a ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                    className: "jsx-".concat(documentsCompletedStyles.__hash),
                                                                    children: "Tu Perfil"
                                                                }),
                                                                ", donde podr\xe1s completar los datos faltantes y descubrir todas las funcionalidades que iad Inmobiliaria tiene para ti."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(documentsCompletedStyles.__hash) + " " + "completion-actions",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                        type: "button",
                                        color: "primary",
                                        fullWidth: true,
                                        onClick: _this.handleCloseModal,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(documentsCompletedStyles.__hash),
                                                children: "Continuar con el proceso"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-arrow-forward",
                                                style: {
                                                    marginLeft: '8px'
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: documentsCompletedStyles.__hash,
                            children: documentsCompletedStyles
                        })
                    ]
                }));
            }
            var _currentDocumentIndex = fiscalDocuments[currentDocumentIndex], currentPdfUrl = _currentDocumentIndex.url, currentKey = _currentDocumentIndex.key;
            var currentDocumentName = DOCUMENT_NAMES[currentKey] || currentKey;
            var documentNumber = currentDocumentIndex + 1;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(sequentialDocuments.__hash) + " " + "sequential-documents",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(sequentialDocuments.__hash) + " " + "current-document",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(sequentialDocuments.__hash) + " " + "document-viewer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PDFViewer, {
                                file: currentPdfUrl,
                                documentName: currentDocumentName,
                                onClose: function() {},
                                onCompleteScroll: function() {
                                    _this.setState({
                                        currentDocumentAcceptButtonDisabled: false
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(sequentialDocuments.__hash) + " " + "document-progress",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "jsx-".concat(sequentialDocuments.__hash) + " " + "progress-counter",
                                                children: [
                                                    "Documento ",
                                                    documentNumber,
                                                    " de ",
                                                    totalDocuments
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(sequentialDocuments.__hash) + " " + "progress-bar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: "".concat(acceptedDocuments.length / totalDocuments * 100, "%")
                                                    },
                                                    className: "jsx-".concat(sequentialDocuments.__hash) + " " + "progress-fill"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-".concat(sequentialDocuments.__hash) + " " + "document-actions",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                            fullWidth: true,
                                            type: "button",
                                            color: "primary",
                                            size: "large",
                                            disabled: isAcceptingDocument || currentDocumentAcceptButtonDisabled,
                                            loading: isAcceptingDocument,
                                            onClick: _this.handleAcceptDocument,
                                            children: isAcceptingDocument ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                                        size: 20
                                                    }),
                                                    "Procesando..."
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    "Acepto",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                        style: {
                                                            marginLeft: '8px'
                                                        },
                                                        icon: "ios-checkmark"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: sequentialDocuments.__hash,
                        children: sequentialDocuments
                    })
                ]
            }));
        });
        // Initialize state with persisted progress or defaults
        _this.state = {
            showPDFViewer: false,
            currentPDF: null,
            currentPDFName: null,
            currentDocumentIndex: props.currentDocumentIndex || 0,
            acceptedDocuments: props.acceptedDocuments || [],
            isAcceptingDocument: false,
            currentDocumentAcceptButtonDisabled: true,
            isFullscreenFallback: false
        };
        return _this;
    }
    FiscalInfoModal_createClass(FiscalInfoModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Fetch initial broker data when component mounts
                var getInitialInfoBroker = this.props.getInitialInfoBroker;
                if (getInitialInfoBroker) {
                    getInitialInfoBroker();
                }
                // Initialize form with stored data or broker data
                var _props = this.props, initialBrokerData = _props.initialBrokerData, initialize = _props.initialize;
                var storedFormData = (0,fiscalProgressStorage/* getStoredFormData */.fI)();
                if (initialize) {
                    if (storedFormData) {
                        // If we have stored form data, use it directly
                        initialize(storedFormData);
                    } else {
                        var hasValidBrokerData = initialBrokerData && (initialBrokerData.nationality || initialBrokerData.rfc || initialBrokerData.curp || initialBrokerData.notificationAddress);
                        if (hasValidBrokerData) {
                            // If we have broker data but no stored data, use broker data
                            var initialValues = getInitialFormValues(initialBrokerData);
                            initialize(initialValues);
                        }
                    }
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var ref, ref1, ref2, ref3, ref4;
                // Sync local state with Redux state when progress changes
                if (prevProps.acceptedDocuments !== this.props.acceptedDocuments || prevProps.currentDocumentIndex !== this.props.currentDocumentIndex) {
                    this.setState({
                        acceptedDocuments: this.props.acceptedDocuments || [],
                        currentDocumentIndex: this.props.currentDocumentIndex || 0
                    });
                }
                // Clear loading state when acceptance API finishes (success or failure)
                if (((ref = prevProps.acceptanceFeedback) === null || ref === void 0 ? void 0 : ref.loading) && !((ref1 = this.props.acceptanceFeedback) === null || ref1 === void 0 ? void 0 : ref1.loading)) {
                    this.setState({
                        isAcceptingDocument: false
                    });
                // Don't clear SessionStorage here - let the user see the completion message first
                // SessionStorage will be cleared when they close the modal manually
                }
                // Clear loading state if document generation fails
                if (((ref2 = prevProps.fiscalInfoFeedback) === null || ref2 === void 0 ? void 0 : ref2.loading) && !((ref3 = this.props.fiscalInfoFeedback) === null || ref3 === void 0 ? void 0 : ref3.loading) && ((ref4 = this.props.fiscalInfoFeedback) === null || ref4 === void 0 ? void 0 : ref4.error)) {
                    this.setState({
                        isAcceptingDocument: false
                    });
                }
                // Initialize form with broker data when it becomes available
                var hasValidBrokerData = function(data) {
                    return data && (data.nationality || data.rfc || data.curp || data.notificationAddress);
                };
                var prevHadValidData = hasValidBrokerData(prevProps.initialBrokerData);
                var currentHasValidData = hasValidBrokerData(this.props.initialBrokerData);
                if (!prevHadValidData && currentHasValidData && this.props.initialize && !(0,fiscalProgressStorage/* getStoredFormData */.fI)()) {
                    var initialValues = getInitialFormValues(this.props.initialBrokerData);
                    this.props.initialize(initialValues);
                }
            // Note: Intentionally NOT auto-closing modal to allow user to read completion message
            // The user must manually close the modal using the "Continuar con el proceso" button
            // This gives them time to read the success message and understand the process is complete
            }
        },
        {
            key: "render",
            value: function render() {
                var ref, ref5;
                var _props = this.props, isOpen = _props.isOpen, onClose = _props.onClose, handleSubmit = _props.handleSubmit, invalid = _props.invalid, loading = _props.loading, fiscalInfoFeedback = _props.fiscalInfoFeedback, fiscalDocuments = _props.fiscalDocuments;
                var _state = this.state, showPDFViewer = _state.showPDFViewer, currentPDF = _state.currentPDF, currentPDFName = _state.currentPDFName, isFullscreenFallback = _state.isFullscreenFallback;
                var isSubmitting = fiscalInfoFeedback && fiscalInfoFeedback.loading;
                var hasDocuments = fiscalDocuments && fiscalDocuments.length > 0;
                if (showPDFViewer && currentPDF) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "modal-overlay ".concat(isOpen ? 'visible' : '')
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
                                isOpen: isOpen,
                                onClose: this.handleClosePDFViewer,
                                showCloseButton: false,
                                closeOnOutClick: false,
                                width: "95%",
                                maxWidth: "1200px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PDFViewer, {
                                        file: currentPDF,
                                        documentName: currentPDFName,
                                        onClose: this.handleClosePDFViewer
                                    }),
                                    (0,jsx_runtime.jsx)(style["default"], {
                                        id: FiscalInfoModal_styles.__hash,
                                        children: FiscalInfoModal_styles
                                    })
                                ]
                            })
                        ]
                    }));
                }
                var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "fiscal-info-container ".concat(isFullscreenFallback ? 'full-screen' : ''),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "viewport",
                                content: "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no",
                                className: "jsx-".concat(FiscalInfoModal_styles.__hash)
                            })
                        }),
                        !hasDocuments && isOpen && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: 'fixed',
                                top: '10px',
                                right: '20px',
                                zIndex: 1100
                            },
                            className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                id: "fiscal-logout-button-desktop",
                                type: "button",
                                color: "danger",
                                size: "small",
                                onClick: function() {
                                    return window.location.assign('/salir');
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-log-out",
                                        style: {
                                            marginRight: '1rem'
                                        }
                                    }),
                                    "Cerrar Sesi\xf3n"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Modal */.u_, {
                            isOpen: isOpen,
                            onClose: onClose,
                            showCloseButton: false,
                            closeOnOutClick: false,
                            className: "fiscal-info-modal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneratingDocuments, {
                                isSubmitting: isSubmitting,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + (classnames_default()("fiscal-modal-container", {
                                        'has-documents': hasDocuments
                                    }) || ""),
                                    children: [
                                        !hasDocuments && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "modal-header",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                                                    children: "Informaci\xf3n Fiscal Requerida"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "modal-header-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "modal-subtitle",
                                                            children: "Complete la siguiente informaci\xf3n para continuar usando la plataforma"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tour, {})
                                                    ]
                                                })
                                            ]
                                        }),
                                        hasDocuments ? this.renderSequentialDocuments() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            onSubmit: handleSubmit(this.handleFormSubmit),
                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "fiscal-form",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "form-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                                            className: "fiscal-form-row",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    "data-tour": "fiscal-rfc",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                                        required: true,
                                                                        name: "rfc",
                                                                        id: "rfc",
                                                                        component: controls/* InputForm */.M5,
                                                                        placeholder: "RFC (Registro Federal de Contribuyentes)",
                                                                        label: "RFC *",
                                                                        className: "form-input-margin"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                                    xs: 12,
                                                                    md: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                                        required: true,
                                                                        name: "nationality",
                                                                        id: "nationality",
                                                                        component: DropDown.SimpleDropDownForm,
                                                                        label: "Nacionalidad *",
                                                                        children: this.props.nationalitiesOptions
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                                                            className: "fiscal-form-row",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Col, {
                                                                xs: 12,
                                                                "data-tour": "fiscal-curp",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                                        name: "curp",
                                                                        id: "curp",
                                                                        component: controls/* InputForm */.M5,
                                                                        placeholder: "CURP (Clave \xdanica de Registro de Poblaci\xf3n)",
                                                                        label: this.props.nationality === 'MX' ? 'CURP *' : 'CURP',
                                                                        className: "form-input-margin",
                                                                        required: this.props.nationality === 'MX'
                                                                    }),
                                                                    (fiscalInfoFeedback === null || fiscalInfoFeedback === void 0 ? void 0 : fiscalInfoFeedback.error) && (fiscalInfoFeedback === null || fiscalInfoFeedback === void 0 ? void 0 : (ref = fiscalInfoFeedback.errors) === null || ref === void 0 ? void 0 : ref.curp) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "field-error",
                                                                        children: typeof fiscalInfoFeedback.errors.curp === 'string' ? fiscalInfoFeedback.errors.curp : ((ref5 = fiscalInfoFeedback.errors.curp) === null || ref5 === void 0 ? void 0 : ref5.message) || Object.values(fiscalInfoFeedback.errors.curp)[0] || 'Error en CURP'
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Row, {
                                                            className: "fiscal-form-row",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                                xs: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Field/* default */.Z, {
                                                                    name: "notificationAddress",
                                                                    id: "notification-address",
                                                                    component: controls/* InputForm */.M5,
                                                                    placeholder: "Domicilio de notificaci\xf3n",
                                                                    label: "Domicilio de notificaci\xf3n *",
                                                                    className: "form-input-margin",
                                                                    required: true
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldArray/* default */.Z, {
                                                            name: "beneficiaries",
                                                            component: BeneficiaryFields
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "modal-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PercentageIndicator, {
                                                            beneficiaries: this.props.beneficiaries
                                                        }),
                                                        (fiscalInfoFeedback === null || fiscalInfoFeedback === void 0 ? void 0 : fiscalInfoFeedback.error) && (fiscalInfoFeedback === null || fiscalInfoFeedback === void 0 ? void 0 : fiscalInfoFeedback.errors) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "form-errors",
                                                            children: Object.entries(fiscalInfoFeedback.errors).filter(function(param) {
                                                                var _param = _slicedToArray(param, 2), field = _param[0], error = _param[1];
                                                                return field !== 'errorResponseStatus' && field !== 'errorCodes';
                                                            }) // Skip status codes and error codes summary
                                                            .map(function(param) {
                                                                var _param = _slicedToArray(param, 2), field = _param[0], error = _param[1];
                                                                // Field name mapping for user-friendly display
                                                                var fieldLabels = {
                                                                    notificationAddress: 'Domicilio de notificaci\xf3n',
                                                                    rfc: 'RFC',
                                                                    curp: 'CURP',
                                                                    nationality: 'Nacionalidad'
                                                                };
                                                                // Get user-friendly field name
                                                                var fieldLabel = fieldLabels[field] || field;
                                                                // Extract the actual error message
                                                                var errorMessage = error;
                                                                if (typeof error === 'object' && error !== null) {
                                                                    // If it's an object, get the first value or the message property
                                                                    errorMessage = error.message || Object.values(error)[0] || JSON.stringify(error);
                                                                } else if (Array.isArray(error)) {
                                                                    errorMessage = error.join(', ');
                                                                }
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "jsx-".concat(FiscalInfoModal_styles.__hash) + " " + "form-error",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                            className: "jsx-".concat(FiscalInfoModal_styles.__hash),
                                                                            children: [
                                                                                fieldLabel,
                                                                                ":"
                                                                            ]
                                                                        }),
                                                                        " ",
                                                                        errorMessage
                                                                    ]
                                                                }, field));
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_flexbox_grid.Row, {
                                                            className: "fiscal-form-row",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                                        type: "submit",
                                                                        color: "primary",
                                                                        fullWidth: true,
                                                                        disabled: invalid || isSubmitting,
                                                                        loading: isSubmitting,
                                                                        children: isSubmitting ? 'Generando documentos...' : 'Guardar informaci\xf3n'
                                                                    })
                                                                }),
                                                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flexbox_grid.Col, {
                                                                    xs: 12,
                                                                    style: {
                                                                        marginTop: '1rem',
                                                                        marginBottom: '5rem'
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                                        id: "fiscal-logout-button-mobile",
                                                                        type: "button",
                                                                        color: "danger",
                                                                        fullWidth: true,
                                                                        onClick: function() {
                                                                            return window.location.assign('/salir');
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                                                icon: "ios-log-out",
                                                                                style: {
                                                                                    marginRight: '1rem'
                                                                                }
                                                                            }),
                                                                            "Cerrar Sesi\xf3n"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: FiscalInfoModal_styles.__hash,
                            children: FiscalInfoModal_styles
                        })
                    ]
                }));
            }
        }
    ]);
    return FiscalInfoModal;
}(react.Component);
FiscalInfoModal_defineProperty(FiscalInfoModal, "propTypes", {
    isOpen: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func.isRequired,
    handleSubmit: (prop_types_default()).func.isRequired,
    initialize: (prop_types_default()).func,
    invalid: (prop_types_default()).bool,
    loading: (prop_types_default()).bool,
    generateInitialDocuments: (prop_types_default()).func.isRequired,
    acceptContracts: (prop_types_default()).func.isRequired,
    acceptDocument: (prop_types_default()).func.isRequired,
    updateDocumentProgress: (prop_types_default()).func.isRequired,
    getInitialInfoBroker: (prop_types_default()).func,
    fiscalInfoFeedback: (prop_types_default()).object,
    fiscalDocuments: prop_types_default().arrayOf(prop_types_default().shape({
        key: (prop_types_default()).string,
        url: (prop_types_default()).string
    })),
    acceptanceFeedback: (prop_types_default()).object,
    acceptedDocuments: (prop_types_default()).array,
    currentDocumentIndex: (prop_types_default()).number,
    initialBrokerData: (prop_types_default()).object
});
FiscalInfoModal_defineProperty(FiscalInfoModal, "defaultProps", {
    isOpen: true,
    loading: false,
    invalid: false
});
// Get persisted form data or use defaults with broker data preloading
var getInitialFormValues = function() {
    var initialBrokerData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storedFormData = (0,fiscalProgressStorage/* getStoredFormData */.fI)();
    // Base form values from broker data
    var brokerFormValues = {
        nationality: initialBrokerData.nationality || '',
        rfc: initialBrokerData.rfc || '',
        curp: initialBrokerData.curp || '',
        notificationAddress: initialBrokerData.notificationAddress || '',
        beneficiaries: [
            {}
        ]
    };
    if (storedFormData) {
        var finalValues = FiscalInfoModal_objectSpread({}, brokerFormValues, storedFormData, {
            // Ensure beneficiaries array exists and has at least one item
            beneficiaries: storedFormData.beneficiaries && storedFormData.beneficiaries.length > 0 ? storedFormData.beneficiaries : [
                {}
            ]
        });
        return finalValues;
    }
    return brokerFormValues;
};
var getFormConfig = function(initialBrokerData) {
    return {
        form: 'fiscalInfoForm',
        validate: fiscalInfoValidator,
        enableReinitialize: true,
        initialValues: getInitialFormValues(initialBrokerData)
    };
};
var selector = (0,formValueSelector/* default */.Z)('fiscalInfoForm');
var FiscalInfoModal_mapStateToProps = function(state) {
    var fiscalDocuments = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = [
            BENEFICIARY_DECLARATION,
            SERVICE_CONTRACT,
            BUSINESS_STRATEGY_CONTRACT
        ][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var documentKey = _step.value;
            if (!state.fiscalInfo.documents[documentKey]) {
                continue;
            }
            fiscalDocuments.push({
                key: documentKey,
                url: state.fiscalInfo.documents[documentKey]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var nationalities = (0,selectors_config/* getNationalities */.cl)(state);
    var nationalitiesOptions = (0,utils/* optionsForSelect */.s0)(nationalities.map(function(nationality) {
        return {
            value: nationality.code,
            label: nationality.name
        };
    }));
    // Get initial broker data for form preloading
    var initialBrokerData = (0,user/* getInitialInfoBrokerDataSelector */.xs)(state);
    return {
        beneficiaries: selector(state, 'beneficiaries'),
        nationality: selector(state, 'nationality'),
        fiscalInfoFeedback: state.fiscalInfo.feedback,
        fiscalDocuments: fiscalDocuments,
        acceptanceFeedback: state.fiscalInfo.acceptanceFeedback,
        nationalitiesOptions: nationalitiesOptions,
        // Add progress tracking from state
        acceptedDocuments: state.fiscalInfo.acceptedDocuments || [],
        currentDocumentIndex: state.fiscalInfo.currentDocumentIndex || 0,
        // Add initial broker data for preloading
        initialBrokerData: initialBrokerData
    };
};
var FiscalInfoModal_mapDispatchToProps = {
    generateInitialDocuments: FiscalInfoRedux/* FiscalInfoActionCreators.generateInitialDocuments */.Ov.generateInitialDocuments,
    acceptContracts: FiscalInfoRedux/* FiscalInfoActionCreators.acceptContracts */.Ov.acceptContracts,
    acceptDocument: FiscalInfoRedux/* FiscalInfoActionCreators.acceptDocument */.Ov.acceptDocument,
    updateDocumentProgress: FiscalInfoRedux/* FiscalInfoActionCreators.updateDocumentProgress */.Ov.updateDocumentProgress,
    getInitialInfoBroker: services/* store.getInitialInfoBroker */.h.getInitialInfoBroker('user').action
};
var formConfig = {
    form: 'fiscalInfoForm',
    validate: validators_fiscalInfoValidator/* default */.Z,
    enableReinitialize: false,
    touchOnBlur: true,
    touchOnChange: true,
    initialValues: {
        nationality: '',
        rfc: '',
        curp: '',
        notificationAddress: '',
        beneficiaries: [
            {}
        ]
    }
};
var ConnectedFiscalInfoModal = (0,es/* connect */.$j)(FiscalInfoModal_mapStateToProps, FiscalInfoModal_mapDispatchToProps)((0,reduxForm/* default */.Z)(formConfig)(FiscalInfoModal));
/* harmony default export */ var Admin_FiscalInfoModal = (ConnectedFiscalInfoModal);

// EXTERNAL MODULE: ./app/reducers/NetworkContractRedux.js
var NetworkContractRedux = __webpack_require__(55039);
// EXTERNAL MODULE: ./app/reducers/ContractVersionRedux.js
var ContractVersionRedux = __webpack_require__(83688);
// EXTERNAL MODULE: ./app/selectors/contractVersion.js
var contractVersion = __webpack_require__(79872);
;// CONCATENATED MODULE: ./components/Layout/Admin/NetworkContractModal/styles.js
var networkContractModalStyles = new String(".modal-overlay.jsx-5ad73236ab0e67f{position:fixed;\ntop:0;\nleft:0;\nright:0;\nbottom:0;\nbackground-color:rgba(0, 0, 0, 0.7);\nz-index:1000;\nopacity:0;\nvisibility:hidden;\n-webkit-transition:opacity 0.3s ease, visibility 0.3s ease;\ntransition:opacity 0.3s ease, visibility 0.3s ease}\n.modal-overlay.visible.jsx-5ad73236ab0e67f{opacity:1;\nvisibility:visible}\n.network-modal-container.jsx-5ad73236ab0e67f{position:relative;\nmin-height:400px;\nmax-height:90vh;\noverflow-y:auto}\n.network-modal-loading.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px}\n.loading-content.jsx-5ad73236ab0e67f{text-align:center;\nmax-width:400px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\n.loading-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:20px 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.loading-content.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.network-modal-error.jsx-5ad73236ab0e67f, .network-modal-acceptance-error.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px;\ntext-align:center}\n.error-content.jsx-5ad73236ab0e67f{margin-bottom:30px;\nmax-width:400px}\n.error-content.jsx-5ad73236ab0e67f .ion-icon{font-size:4rem;\ncolor:#e74c3c;\nmargin-bottom:20px}\n.error-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:0 0 15px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.error-content.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.error-actions.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:15px;\nflex-wrap:wrap;\n-webkit-justify-content:center;\njustify-content:center}\n.network-modal-todo.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px;\ntext-align:center}\n.todo-content.jsx-5ad73236ab0e67f{margin-bottom:30px;\nmax-width:500px}\n.todo-content.jsx-5ad73236ab0e67f .ion-icon{font-size:4rem;\ncolor:#f39c12;\nmargin-bottom:20px}\n.todo-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:0 0 15px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.todo-content.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0 0 15px 0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.todo-note.jsx-5ad73236ab0e67f{background-color:#fff3cd;\nborder:1px solid #ffeaa7;\nborder-radius:6px;\npadding:15px;\ncolor:#856404!important;\nfont-style:italic}\n.todo-actions.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n.network-modal-accepting.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px}\n.accepting-content.jsx-5ad73236ab0e67f{text-align:center;\nmax-width:400px}\n.accepting-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:20px 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#27ae60}\n.accepting-content.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.network-contract-viewer.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nheight:100%;\nmin-height:600px}\n.contract-header.jsx-5ad73236ab0e67f{padding:20px 20px 15px 20px;\nborder-bottom:1px solid #ecf0f1;\nbackground-color:#f8f9fa;\ntext-align:center}\n.contract-header.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:0 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.contract-header.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0;\ncolor:#7f8c8d;\nfont-size:0.95rem;\nline-height:1.5}\n.contract-document.jsx-5ad73236ab0e67f{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\nmin-height:500px;\npadding:0;\nbackground-color:#ffffff}\n.contract-actions.jsx-5ad73236ab0e67f{padding:20px;\nborder-top:1px solid #ecf0f1;\nbackground-color:#f8f9fa}\n.network-modal-no-document.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px;\ntext-align:center}\n.no-document-content.jsx-5ad73236ab0e67f{margin-bottom:30px;\nmax-width:400px}\n.no-document-content.jsx-5ad73236ab0e67f .ion-icon{font-size:4rem;\ncolor:#95a5a6;\nmargin-bottom:20px}\n.no-document-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{margin:0 0 15px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.no-document-content.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.no-document-actions.jsx-5ad73236ab0e67f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n@media (max-width:768px) {.network-modal-container.jsx-5ad73236ab0e67f{max-height:95vh}\n.contract-header.jsx-5ad73236ab0e67f{padding:15px;\ntext-align:center}\n.contract-header.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{font-size:1.25rem}\n.contract-header.jsx-5ad73236ab0e67f p.jsx-5ad73236ab0e67f{font-size:0.9rem}\n.contract-document.jsx-5ad73236ab0e67f{min-height:400px}\n.contract-actions.jsx-5ad73236ab0e67f{padding:15px}\n.loading-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f, .error-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f, .todo-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f, .accepting-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f, .no-document-content.jsx-5ad73236ab0e67f h3.jsx-5ad73236ab0e67f{font-size:1.25rem}\n.error-actions.jsx-5ad73236ab0e67f{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.error-actions.jsx-5ad73236ab0e67f button{width:100%;\nmax-width:200px}}\n@media (max-width:480px) {.network-modal-loading.jsx-5ad73236ab0e67f, .network-modal-error.jsx-5ad73236ab0e67f, .network-modal-todo.jsx-5ad73236ab0e67f, .network-modal-accepting.jsx-5ad73236ab0e67f, .network-modal-no-document.jsx-5ad73236ab0e67f{padding:20px 15px}\n.contract-header.jsx-5ad73236ab0e67f{padding:12px;\ntext-align:center}\n.contract-actions.jsx-5ad73236ab0e67f{padding:12px}\n.contract-document.jsx-5ad73236ab0e67f{min-height:350px}}");
networkContractModalStyles.__hash = "5ad73236ab0e67f";
var oldVersionNetworkModalStyles = new String(".network-modal-old-version.jsx-3651214db2c76da7{padding:2rem;\ntext-align:center;\nmax-width:600px;\nmargin:0 auto}\n.old-version-header.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmargin-bottom:1.5rem}\n.old-version-icon.jsx-3651214db2c76da7{font-size:2.5rem;\ncolor:#f39c12;\nmargin-right:1rem}\n.old-version-header.jsx-3651214db2c76da7 h3.jsx-3651214db2c76da7{margin:0;\ncolor:#2c3e50;\nfont-size:1.5rem;\nfont-weight:600}\n.old-version-message.jsx-3651214db2c76da7{margin-bottom:2rem}\n.main-message.jsx-3651214db2c76da7{font-size:1.1rem;\ncolor:#34495e;\nmargin-bottom:1.5rem;\nline-height:1.6}\n.loading-message.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#3498db;\nfont-weight:500}\n.error-message.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#e74c3c;\nbackground:#ffeaea;\npadding:1rem;\nborder-radius:8px;\nborder-left:4px solid #e74c3c}\n.contract-action.jsx-3651214db2c76da7 p.jsx-3651214db2c76da7{font-size:1.1rem;\nmargin-bottom:1.5rem;\ncolor:#2c3e50}\n.contract-link.jsx-3651214db2c76da7{color:#3498db;\n-webkit-text-decoration:none;\ntext-decoration:none;\nfont-weight:600;\nborder-bottom:2px solid #3498db;\n-webkit-transition:all 0.3s ease;\ntransition:all 0.3s ease}\n.contract-link.jsx-3651214db2c76da7:hover{color:#2980b9;\nborder-bottom-color:#2980b9}\n.action-buttons.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:1rem;\n-webkit-justify-content:center;\njustify-content:center;\nflex-wrap:wrap}\n.action-buttons.jsx-3651214db2c76da7 button.jsx-3651214db2c76da7{min-width:160px}\n.fallback-message.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#95a5a6;\nbackground:#f8f9fa;\npadding:1rem;\nborder-radius:8px}\n.old-version-note.jsx-3651214db2c76da7{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start;\ngap:0.5rem;\nbackground:#f8f9fa;\npadding:1rem;\nborder-radius:8px;\nborder-left:4px solid #f39c12;\ntext-align:left;\nfont-size:0.9rem;\ncolor:#7f8c8d;\nmargin-top:2rem}\n.old-version-note.jsx-3651214db2c76da7 ion-icon.jsx-3651214db2c76da7{color:#f39c12;\nmargin-top:2px;\n-webkit-flex-shrink:0;\n-ms-flex-negative:0;\nflex-shrink:0}\n@media{\n      flex-direction: column;\n      align-items: center;\n    }\n.refresh-button-container.jsx-3651214db2c76da7{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-top:1rem}\n.action-buttons.jsx-3651214db2c76da7 button.jsx-3651214db2c76da7{width:100%;\nmax-width:300px}");
oldVersionNetworkModalStyles.__hash = "3651214db2c76da7";

;// CONCATENATED MODULE: ./components/Layout/Admin/NetworkContractModal/index.js











function NetworkContractModal_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function NetworkContractModal_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function NetworkContractModal_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function NetworkContractModal_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) NetworkContractModal_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) NetworkContractModal_defineProperties(Constructor, staticProps);
    return Constructor;
}
function NetworkContractModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NetworkContractModal_getPrototypeOf(o) {
    NetworkContractModal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return NetworkContractModal_getPrototypeOf(o);
}
function NetworkContractModal_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) NetworkContractModal_setPrototypeOf(subClass, superClass);
}
function NetworkContractModal_possibleConstructorReturn(self, call) {
    if (call && (NetworkContractModal_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return NetworkContractModal_assertThisInitialized(self);
}
function NetworkContractModal_setPrototypeOf(o, p) {
    NetworkContractModal_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return NetworkContractModal_setPrototypeOf(o, p);
}
var NetworkContractModal_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function NetworkContractModal_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function NetworkContractModal_createSuper(Derived) {
    var hasNativeReflectConstruct = NetworkContractModal_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = NetworkContractModal_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = NetworkContractModal_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return NetworkContractModal_possibleConstructorReturn(this, result);
    };
}
var NetworkContractModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    NetworkContractModal_inherits(NetworkContractModal, Component1);
    var _super = NetworkContractModal_createSuper(NetworkContractModal);
    function NetworkContractModal() {
        NetworkContractModal_classCallCheck(this, NetworkContractModal);
        var _this;
        _this = _super.apply(this, arguments);
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "state", {
            hasScrollCompleted: false
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "handleAcceptContract", function() {
            _this.props.acceptNetworkContract();
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "handleScrollComplete", function() {
            _this.setState({
                hasScrollCompleted: true
            });
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "renderLoadingState", function() {
            /*#__PURE__*/ return((0,jsx_runtime.jsxs)("div", {
                className: /*#__PURE__*/ "jsx-".concat(networkContractModalStyles.__hash) + " " + "network-modal-loading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "loading-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "jsx-".concat(networkContractModalStyles.__hash),
                                children: "Cargando informaci\xf3n del contrato..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-".concat(networkContractModalStyles.__hash),
                                children: "Por favor, espere mientras verificamos su informaci\xf3n."
                            })
                        ]
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: networkContractModalStyles.__hash,
                        children: networkContractModalStyles
                    })
                ]
            }));
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "renderErrorState", function() {
            var networkContractFeedback = _this.props.networkContractFeedback;
            var error = (networkContractFeedback === null || networkContractFeedback === void 0 ? void 0 : networkContractFeedback.error) || 'Error desconocido';
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "network-modal-error",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: "ios-warning"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Error al cargar el contrato"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-actions",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                color: "primary",
                                outline: true,
                                onClick: function() {
                                    return _this.props.checkConsentType();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-refresh"
                                    }),
                                    "Reintentar"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                type: "button",
                                color: "danger",
                                outline: true,
                                onClick: _this.props.onClose,
                                children: "Cerrar"
                            })
                        ]
                    })
                ]
            }));
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "renderOldVersionTodo", function() {
            var ref;
            var contractUrlData = _this.props.contractUrlData;
            var contractUrl = contractUrlData === null || contractUrlData === void 0 ? void 0 : contractUrlData.url;
            var contractFeedback = contractUrlData === null || contractUrlData === void 0 ? void 0 : contractUrlData.feedback;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "network-modal-old-version",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "old-version-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "old-version-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                    children: "Contrato de Red"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "old-version-message",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "main-message",
                                        children: "Para seguir creciendo tu red, te pedimos firmes el contrato."
                                    }),
                                    (contractFeedback === null || contractFeedback === void 0 ? void 0 : contractFeedback.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "loading-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                                size: 20
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                                children: "Cargando informaci\xf3n del contrato..."
                                            })
                                        ]
                                    }) : (contractFeedback === null || contractFeedback === void 0 ? void 0 : contractFeedback.error) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "error-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-warning"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                                children: ((ref = contractFeedback.errors) === null || ref === void 0 ? void 0 : ref.errors) || 'Pregunta a tu equipo de soporte por \xe9l.'
                                            })
                                        ]
                                    }) : contractUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "contract-action",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "sign-button-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                    type: "button",
                                                    color: "primary",
                                                    size: "large",
                                                    onClick: function() {
                                                        return window.open(contractUrl, '_blank');
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-create",
                                                            style: {
                                                                marginRight: '8px'
                                                            }
                                                        }),
                                                        "Firmar Contrato"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "refresh-button-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                    type: "button",
                                                    color: "secondary",
                                                    outline: true,
                                                    onClick: function() {
                                                        return window.location.reload();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-refresh",
                                                            style: {
                                                                marginRight: '8px'
                                                            }
                                                        }),
                                                        "Ya firm\xe9, recargar"
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "fallback-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-help-circle"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                                children: "Pregunta a tu equipo de soporte por \xe9l."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash) + " " + "old-version-note",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-information-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "jsx-".concat(oldVersionNetworkModalStyles.__hash),
                                                children: "IMPORTANTE:"
                                            }),
                                            " Es necesario firmar este documento para poder dar de alta tu segundo ahijado."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: oldVersionNetworkModalStyles.__hash,
                        children: oldVersionNetworkModalStyles
                    })
                ]
            }));
        });
        NetworkContractModal_defineProperty(NetworkContractModal_assertThisInitialized(_this), "renderContractViewer", function() {
            var _props = _this.props, documentUrl = _props.documentUrl, isAccepting = _props.isAccepting, networkContractFeedback = _props.networkContractFeedback;
            var hasScrollCompleted = _this.state.hasScrollCompleted;
            var hasAcceptanceError = networkContractFeedback === null || networkContractFeedback === void 0 ? void 0 : networkContractFeedback.acceptanceError;
            var isProcessingAcceptance = networkContractFeedback === null || networkContractFeedback === void 0 ? void 0 : networkContractFeedback.acceptanceLoading;
            if (isProcessingAcceptance) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "network-modal-accepting",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "accepting-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 60
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Procesando aceptaci\xf3n..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Estamos registrando la aceptaci\xf3n de su contrato de red. Por favor, espere un momento."
                            })
                        ]
                    })
                }));
            }
            if (hasAcceptanceError) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "network-modal-acceptance-error",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "error-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "ios-warning"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "Error al procesar aceptaci\xf3n"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Hubo un error al registrar la aceptaci\xf3n del contrato. Por favor, int\xe9ntelo nuevamente."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "error-actions",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                type: "button",
                                color: "primary",
                                outline: true,
                                onClick: _this.handleAcceptContract,
                                children: "Reintentar"
                            })
                        })
                    ]
                }));
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "network-contract-viewer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "contract-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "jsx-".concat(networkContractModalStyles.__hash),
                                children: "Contrato de Red"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-".concat(networkContractModalStyles.__hash),
                                children: "Para seguir creciendo tu red, te pedimos aceptes sus terminos y condiciones"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "contract-document",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PDFViewer, {
                            file: documentUrl,
                            documentName: "Contrato de Red",
                            onCompleteScroll: _this.handleScrollComplete,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "contract-actions",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                    type: "button",
                                    color: "primary",
                                    size: "large",
                                    fullWidth: true,
                                    disabled: isAccepting || !hasScrollCompleted,
                                    loading: isAccepting,
                                    onClick: _this.handleAcceptContract,
                                    children: isAccepting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                                size: 20
                                            }),
                                            "Procesando..."
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Acepto el Contrato de Red",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                style: {
                                                    marginLeft: '8px'
                                                },
                                                icon: "ios-checkmark"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: networkContractModalStyles.__hash,
                        children: networkContractModalStyles
                    })
                ]
            }));
        });
        return _this;
    }
    NetworkContractModal_createClass(NetworkContractModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check consent type when component mounts
                if (this.props.isOpen) {
                    this.props.checkConsentType();
                    // Also fetch the signing URL for old version workflow
                    this.props.getUrlByContract({
                        contract_type: 'network-contract'
                    });
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var ref, ref1, ref2;
                // Check consent type when modal opens
                if (!prevProps.isOpen && this.props.isOpen) {
                    // Reset scroll completion state when modal opens
                    this.setState({
                        hasScrollCompleted: false
                    });
                    this.props.checkConsentType();
                    // Also fetch the signing URL for old version workflow
                    this.props.getUrlByContract({
                        contract_type: 'network-contract'
                    });
                }
                // Handle successful acceptance - close modal
                if (((ref = prevProps.networkContractFeedback) === null || ref === void 0 ? void 0 : ref.acceptanceLoading) && !((ref1 = this.props.networkContractFeedback) === null || ref1 === void 0 ? void 0 : ref1.acceptanceLoading) && !((ref2 = this.props.networkContractFeedback) === null || ref2 === void 0 ? void 0 : ref2.acceptanceError)) {
                    var _this = this;
                    // Success - close modal after a brief delay to show success state
                    setTimeout(function() {
                        _this.props.onClose();
                    }, 1000);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, isOpen = _props.isOpen, onClose = _props.onClose, networkContractFeedback = _props.networkContractFeedback, consentType = _props.consentType, documentUrl = _props.documentUrl;
                var isLoading = networkContractFeedback === null || networkContractFeedback === void 0 ? void 0 : networkContractFeedback.loading;
                var hasError = networkContractFeedback === null || networkContractFeedback === void 0 ? void 0 : networkContractFeedback.error;
                var isOldVersion = consentType === 'SIGNATURE';
                var isNewVersion = consentType === 'ACCEPTANCE';
                var hasDocumentUrl = documentUrl && documentUrl.length > 0;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-overlay ".concat(isOpen ? 'visible' : '')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
                            isOpen: isOpen,
                            onClose: onClose,
                            showCloseButton: false,
                            closeOnOutClick: false,
                            width: "95%",
                            maxWidth: "1100px",
                            className: "network-contract-modal",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "network-modal-container",
                                    children: [
                                        isLoading && this.renderLoadingState(),
                                        hasError && this.renderErrorState(),
                                        isOldVersion && this.renderOldVersionTodo(),
                                        isNewVersion && hasDocumentUrl && this.renderContractViewer(),
                                        isNewVersion && !hasDocumentUrl && !isLoading && !hasError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "network-modal-no-document",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "no-document-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-document"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "jsx-".concat(networkContractModalStyles.__hash),
                                                            children: "Documento no disponible"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-".concat(networkContractModalStyles.__hash),
                                                            children: "No se pudo obtener el documento del contrato de red."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-".concat(networkContractModalStyles.__hash) + " " + "no-document-actions",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                        type: "button",
                                                        color: "primary",
                                                        outline: true,
                                                        onClick: function() {
                                                            return _this.props.checkConsentType();
                                                        },
                                                        children: "Reintentar"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0,jsx_runtime.jsx)(style["default"], {
                                    id: networkContractModalStyles.__hash,
                                    children: networkContractModalStyles
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return NetworkContractModal;
}(react.Component);
NetworkContractModal_defineProperty(NetworkContractModal, "propTypes", {
    isOpen: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func.isRequired,
    checkConsentType: (prop_types_default()).func.isRequired,
    acceptNetworkContract: (prop_types_default()).func.isRequired,
    getUrlByContract: (prop_types_default()).func.isRequired,
    networkContractFeedback: (prop_types_default()).object,
    consentType: (prop_types_default()).string,
    documentUrl: (prop_types_default()).string,
    isAccepting: (prop_types_default()).bool,
    contractUrlData: (prop_types_default()).object
});
NetworkContractModal_defineProperty(NetworkContractModal, "defaultProps", {
    isOpen: false,
    networkContractFeedback: null,
    consentType: null,
    documentUrl: null,
    isAccepting: false,
    contractUrlData: null
});
var NetworkContractModal_mapStateToProps = function(state) {
    return {
        networkContractFeedback: state.networkContract.feedback,
        consentType: state.networkContract.consentType,
        documentUrl: state.networkContract.documentUrl,
        isAccepting: state.networkContract.acceptanceLoading,
        contractUrlData: (0,contractVersion/* urlForContractSelector */.hH)(state)
    };
};
var NetworkContractModal_mapDispatchToProps = {
    checkConsentType: NetworkContractRedux/* NetworkContractActionCreators.checkConsentType */.I7.checkConsentType,
    acceptNetworkContract: NetworkContractRedux/* NetworkContractActionCreators.acceptNetworkContract */.I7.acceptNetworkContract,
    getUrlByContract: ContractVersionRedux/* ContractVersionActionCreators.getUrlByContract */.zn.getUrlByContract
};
/* harmony default export */ var Admin_NetworkContractModal = ((0,es/* connect */.$j)(NetworkContractModal_mapStateToProps, NetworkContractModal_mapDispatchToProps)(NetworkContractModal));

// EXTERNAL MODULE: ./app/reducers/CodeConductRedux.js
var CodeConductRedux = __webpack_require__(60881);
;// CONCATENATED MODULE: ./components/Layout/Admin/CodeConductModal/styles.js
var codeConductModalStyles = new String(".modal-overlay.jsx-87366e3a77c1dd91{position:fixed;\ntop:0;\nleft:0;\nright:0;\nbottom:0;\nbackground-color:rgba(0, 0, 0, 0.7);\nz-index:1000;\nopacity:0;\nvisibility:hidden;\n-webkit-transition:opacity 0.3s ease, visibility 0.3s ease;\ntransition:opacity 0.3s ease, visibility 0.3s ease}\n.modal-overlay.visible.jsx-87366e3a77c1dd91{opacity:1;\nvisibility:visible}\n.code-conduct-modal-container.jsx-87366e3a77c1dd91{position:relative;\nmin-height:400px;\nmax-height:90vh;\noverflow-y:auto}\n.code-conduct-modal-loading.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px}\n.loading-content.jsx-87366e3a77c1dd91{text-align:center;\nmax-width:400px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center}\n.loading-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{margin:20px 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.loading-content.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.code-conduct-modal-error.jsx-87366e3a77c1dd91, .code-conduct-modal-acceptance-error.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px;\ntext-align:center}\n.error-content.jsx-87366e3a77c1dd91{margin-bottom:30px;\nmax-width:400px}\n.error-content.jsx-87366e3a77c1dd91 .ion-icon{font-size:4rem;\ncolor:#e74c3c;\nmargin-bottom:20px}\n.error-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{margin:0 0 15px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.error-content.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.error-actions.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:15px;\nflex-wrap:wrap;\n-webkit-justify-content:center;\njustify-content:center}\n.code-conduct-modal-accepting.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px}\n.accepting-content.jsx-87366e3a77c1dd91{text-align:center;\nmax-width:400px}\n.accepting-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{margin:20px 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#27ae60}\n.accepting-content.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.code-conduct-contract-viewer.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\nheight:100%;\nmin-height:600px}\n.contract-header.jsx-87366e3a77c1dd91{padding:20px 20px 15px 20px;\nborder-bottom:1px solid #ecf0f1;\nbackground-color:#f8f9fa;\ntext-align:center}\n.contract-header.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{margin:0 0 10px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.contract-header.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{margin:0;\ncolor:#7f8c8d;\nfont-size:0.95rem;\nline-height:1.5}\n.contract-document.jsx-87366e3a77c1dd91{-webkit-flex:1;\n-ms-flex:1;\nflex:1;\nmin-height:500px;\npadding:0;\nbackground-color:#ffffff}\n.contract-actions.jsx-87366e3a77c1dd91{padding:20px;\nborder-top:1px solid #ecf0f1;\nbackground-color:#f8f9fa}\n.code-conduct-modal-no-document.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmin-height:400px;\npadding:40px 20px;\ntext-align:center}\n.no-document-content.jsx-87366e3a77c1dd91{margin-bottom:30px;\nmax-width:400px}\n.no-document-content.jsx-87366e3a77c1dd91 .ion-icon{font-size:4rem;\ncolor:#95a5a6;\nmargin-bottom:20px}\n.no-document-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{margin:0 0 15px 0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#2c3e50}\n.no-document-content.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{margin:0;\ncolor:#7f8c8d;\nfont-size:1rem;\nline-height:1.5}\n.no-document-actions.jsx-87366e3a77c1dd91{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-justify-content:center;\njustify-content:center}\n@media (max-width:768px) {.code-conduct-modal-container.jsx-87366e3a77c1dd91{max-height:95vh}\n.contract-header.jsx-87366e3a77c1dd91{padding:15px;\ntext-align:center}\n.contract-header.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{font-size:1.25rem}\n.contract-header.jsx-87366e3a77c1dd91 p.jsx-87366e3a77c1dd91{font-size:0.9rem}\n.contract-document.jsx-87366e3a77c1dd91{min-height:400px}\n.contract-actions.jsx-87366e3a77c1dd91{padding:15px}\n.loading-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91, .error-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91, .accepting-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91, .no-document-content.jsx-87366e3a77c1dd91 h3.jsx-87366e3a77c1dd91{font-size:1.25rem}\n.error-actions.jsx-87366e3a77c1dd91{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\n.error-actions.jsx-87366e3a77c1dd91 button{width:100%;\nmax-width:200px}}\n@media (max-width:480px) {.code-conduct-modal-loading.jsx-87366e3a77c1dd91, .code-conduct-modal-error.jsx-87366e3a77c1dd91, .code-conduct-modal-accepting.jsx-87366e3a77c1dd91, .code-conduct-modal-no-document.jsx-87366e3a77c1dd91{padding:20px 15px}\n.contract-header.jsx-87366e3a77c1dd91{padding:12px;\ntext-align:center}\n.contract-actions.jsx-87366e3a77c1dd91{padding:12px}\n.contract-document.jsx-87366e3a77c1dd91{min-height:350px}}");
codeConductModalStyles.__hash = "87366e3a77c1dd91";
var oldVersionCodeConductModalStyles = new String(".code-conduct-modal-old-version.jsx-9c5110cecd91661d{padding:2rem;\ntext-align:center;\nmax-width:600px;\nmargin:0 auto}\n.old-version-header.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\nmargin-bottom:1.5rem}\n.old-version-icon.jsx-9c5110cecd91661d{font-size:2.5rem;\ncolor:#f39c12;\nmargin-right:1rem}\n.old-version-header.jsx-9c5110cecd91661d h3.jsx-9c5110cecd91661d{margin:0;\ncolor:#2c3e50;\nfont-size:1.5rem;\nfont-weight:600}\n.old-version-message.jsx-9c5110cecd91661d{margin-bottom:2rem}\n.main-message.jsx-9c5110cecd91661d{font-size:1.1rem;\ncolor:#34495e;\nmargin-bottom:1.5rem;\nline-height:1.6}\n.loading-message.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#3498db;\nfont-weight:500}\n.error-message.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#e74c3c;\nbackground:#ffeaea;\npadding:1rem;\nborder-radius:8px;\nborder-left:4px solid #e74c3c}\n.contract-action.jsx-9c5110cecd91661d p.jsx-9c5110cecd91661d{font-size:1.1rem;\nmargin-bottom:1.5rem;\ncolor:#2c3e50}\n.contract-link.jsx-9c5110cecd91661d{color:#3498db;\n-webkit-text-decoration:none;\ntext-decoration:none;\nfont-weight:600;\nborder-bottom:2px solid #3498db;\n-webkit-transition:all 0.3s ease;\ntransition:all 0.3s ease}\n.contract-link.jsx-9c5110cecd91661d:hover{color:#2980b9;\nborder-bottom-color:#2980b9}\n.action-buttons.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:1rem;\n-webkit-justify-content:center;\njustify-content:center;\nflex-wrap:wrap}\n.action-buttons.jsx-9c5110cecd91661d button.jsx-9c5110cecd91661d{min-width:160px}\n.fallback-message.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ngap:0.5rem;\ncolor:#95a5a6;\nbackground:#f8f9fa;\npadding:1rem;\nborder-radius:8px}\n.old-version-note.jsx-9c5110cecd91661d{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:flex-start;\n-webkit-box-align:flex-start;\n-ms-flex-align:flex-start;\nalign-items:flex-start;\ngap:0.5rem;\nbackground:#f8f9fa;\npadding:1rem;\nborder-radius:8px;\nborder-left:4px solid #f39c12;\ntext-align:left;\nfont-size:0.9rem;\ncolor:#7f8c8d;\nmargin-top:2rem}\n.old-version-note.jsx-9c5110cecd91661d ion-icon.jsx-9c5110cecd91661d{color:#f39c12;\nmargin-top:2px;\n-webkit-flex-shrink:0;\n-ms-flex-negative:0;\nflex-shrink:0}\n@media{\n      flex-direction: column;\n      align-items: center;\n    }\n.refresh-button-container.jsx-9c5110cecd91661d{-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nmargin-top:1rem}\n.action-buttons.jsx-9c5110cecd91661d button.jsx-9c5110cecd91661d{width:100%;\nmax-width:300px}");
oldVersionCodeConductModalStyles.__hash = "9c5110cecd91661d";

;// CONCATENATED MODULE: ./components/Layout/Admin/CodeConductModal/index.js











function CodeConductModal_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function CodeConductModal_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function CodeConductModal_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function CodeConductModal_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) CodeConductModal_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) CodeConductModal_defineProperties(Constructor, staticProps);
    return Constructor;
}
function CodeConductModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CodeConductModal_getPrototypeOf(o) {
    CodeConductModal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return CodeConductModal_getPrototypeOf(o);
}
function CodeConductModal_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) CodeConductModal_setPrototypeOf(subClass, superClass);
}
function CodeConductModal_possibleConstructorReturn(self, call) {
    if (call && (CodeConductModal_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return CodeConductModal_assertThisInitialized(self);
}
function CodeConductModal_setPrototypeOf(o, p) {
    CodeConductModal_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return CodeConductModal_setPrototypeOf(o, p);
}
var CodeConductModal_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function CodeConductModal_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function CodeConductModal_createSuper(Derived) {
    var hasNativeReflectConstruct = CodeConductModal_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = CodeConductModal_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = CodeConductModal_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return CodeConductModal_possibleConstructorReturn(this, result);
    };
}
var CodeConductModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    CodeConductModal_inherits(CodeConductModal, Component1);
    var _super = CodeConductModal_createSuper(CodeConductModal);
    function CodeConductModal() {
        CodeConductModal_classCallCheck(this, CodeConductModal);
        var _this;
        _this = _super.apply(this, arguments);
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "state", {
            hasScrollCompleted: false
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "handleAcceptContract", function() {
            _this.props.acceptCodeConductContract();
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "handleScrollComplete", function() {
            _this.setState({
                hasScrollCompleted: true
            });
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "renderLoadingState", function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "code-conduct-modal-loading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "loading-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "jsx-".concat(codeConductModalStyles.__hash),
                                children: "Cargando informaci\xf3n del contrato..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-".concat(codeConductModalStyles.__hash),
                                children: "Por favor, espere mientras verificamos su informaci\xf3n."
                            })
                        ]
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: codeConductModalStyles.__hash,
                        children: codeConductModalStyles
                    })
                ]
            });
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "renderErrorState", function() {
            var codeConductFeedback = _this.props.codeConductFeedback;
            var error = (codeConductFeedback === null || codeConductFeedback === void 0 ? void 0 : codeConductFeedback.error) || 'Error desconocido';
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "code-conduct-modal-error",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: "ios-warning"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Error al cargar el contrato"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-actions",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                type: "button",
                                color: "primary",
                                outline: true,
                                onClick: function() {
                                    return _this.props.checkConsentType();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-refresh"
                                    }),
                                    "Reintentar"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                type: "button",
                                color: "danger",
                                outline: true,
                                onClick: _this.props.onClose,
                                children: "Cerrar"
                            })
                        ]
                    })
                ]
            }));
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "renderOldVersionTodo", function() {
            var ref;
            var contractUrlData = _this.props.contractUrlData;
            var contractUrl = contractUrlData === null || contractUrlData === void 0 ? void 0 : contractUrlData.url;
            var contractFeedback = contractUrlData === null || contractUrlData === void 0 ? void 0 : contractUrlData.feedback;
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "code-conduct-modal-old-version",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "old-version-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "old-version-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                    children: "C\xf3digo de \xc9tica"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "old-version-message",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "main-message",
                                        children: "Para continuar operando en la plataforma, te pedimos firmes el c\xf3digo de \xe9tica."
                                    }),
                                    (contractFeedback === null || contractFeedback === void 0 ? void 0 : contractFeedback.loading) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "loading-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                                size: 20
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                                children: "Cargando informaci\xf3n del contrato..."
                                            })
                                        ]
                                    }) : (contractFeedback === null || contractFeedback === void 0 ? void 0 : contractFeedback.error) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "error-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-warning"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                                children: ((ref = contractFeedback.errors) === null || ref === void 0 ? void 0 : ref.errors) || 'Pregunta a tu equipo de soporte por \xe9l.'
                                            })
                                        ]
                                    }) : contractUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "contract-action",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "sign-button-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                    type: "button",
                                                    color: "primary",
                                                    size: "large",
                                                    onClick: function() {
                                                        return window.open(contractUrl, '_blank');
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-create",
                                                            style: {
                                                                marginRight: '8px'
                                                            }
                                                        }),
                                                        "Firmar C\xf3digo de \xc9tica"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "refresh-button-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                                                    type: "button",
                                                    color: "secondary",
                                                    outline: true,
                                                    onClick: function() {
                                                        return window.location.reload();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-refresh",
                                                            style: {
                                                                marginRight: '8px'
                                                            }
                                                        }),
                                                        "Ya firm\xe9, recargar"
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "fallback-message",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                icon: "ios-help-circle"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                                children: "Pregunta a tu equipo de soporte por \xe9l."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash) + " " + "old-version-note",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-information-circle"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "jsx-".concat(oldVersionCodeConductModalStyles.__hash),
                                                children: "IMPORTANTE:"
                                            }),
                                            " Es necesario firmar este documento para poder continuar operando en la plataforma."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: oldVersionCodeConductModalStyles.__hash,
                        children: oldVersionCodeConductModalStyles
                    })
                ]
            }));
        });
        CodeConductModal_defineProperty(CodeConductModal_assertThisInitialized(_this), "renderContractViewer", function() {
            var _props = _this.props, documentUrl = _props.documentUrl, isAccepting = _props.isAccepting, codeConductFeedback = _props.codeConductFeedback;
            var hasScrollCompleted = _this.state.hasScrollCompleted;
            var hasAcceptanceError = codeConductFeedback === null || codeConductFeedback === void 0 ? void 0 : codeConductFeedback.acceptanceError;
            var isProcessingAcceptance = codeConductFeedback === null || codeConductFeedback === void 0 ? void 0 : codeConductFeedback.acceptanceLoading;
            if (isProcessingAcceptance) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "code-conduct-modal-accepting",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "accepting-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                size: 60
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Procesando aceptaci\xf3n..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Estamos registrando la aceptaci\xf3n de su c\xf3digo de conducta. Por favor, espere un momento."
                            })
                        ]
                    })
                }));
            }
            if (hasAcceptanceError) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "code-conduct-modal-acceptance-error",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "error-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "ios-warning"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: "Error al procesar aceptaci\xf3n"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Hubo un error al registrar la aceptaci\xf3n del c\xf3digo de conducta. Por favor, int\xe9ntelo nuevamente."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "error-actions",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                type: "button",
                                color: "primary",
                                outline: true,
                                onClick: _this.handleAcceptContract,
                                children: "Reintentar"
                            })
                        })
                    ]
                }));
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "code-conduct-contract-viewer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "contract-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "jsx-".concat(codeConductModalStyles.__hash),
                                children: "C\xf3digo de \xc9tica"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "jsx-".concat(codeConductModalStyles.__hash),
                                children: "Para continuar operando en la plataforma, te pedimos aceptes sus t\xe9rminos y condiciones"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "contract-document",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PDFViewer, {
                            file: documentUrl,
                            documentName: "C\xf3digo de \xc9tica",
                            onCompleteScroll: _this.handleScrollComplete,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "contract-actions",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                    type: "button",
                                    color: "primary",
                                    size: "large",
                                    fullWidth: true,
                                    disabled: isAccepting || !hasScrollCompleted,
                                    loading: isAccepting,
                                    onClick: _this.handleAcceptContract,
                                    children: isAccepting ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                                                size: 20
                                            }),
                                            "Procesando..."
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Acepto el C\xf3digo de \xc9tica",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                style: {
                                                    marginLeft: '8px'
                                                },
                                                icon: "ios-checkmark"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: codeConductModalStyles.__hash,
                        children: codeConductModalStyles
                    })
                ]
            }));
        });
        return _this;
    }
    CodeConductModal_createClass(CodeConductModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check consent type when component mounts
                if (this.props.isOpen) {
                    this.props.checkConsentType();
                    // Also fetch the signing URL for old version workflow
                    this.props.getUrlByContract({
                        contract_type: 'code-conduct'
                    });
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var ref, ref1, ref2;
                // Check consent type when modal opens
                if (!prevProps.isOpen && this.props.isOpen) {
                    // Reset scroll completion state when modal opens
                    this.setState({
                        hasScrollCompleted: false
                    });
                    this.props.checkConsentType();
                    // Also fetch the signing URL for old version workflow
                    this.props.getUrlByContract({
                        contract_type: 'code-conduct'
                    });
                }
                // Handle successful acceptance - close modal
                if (((ref = prevProps.codeConductFeedback) === null || ref === void 0 ? void 0 : ref.acceptanceLoading) && !((ref1 = this.props.codeConductFeedback) === null || ref1 === void 0 ? void 0 : ref1.acceptanceLoading) && !((ref2 = this.props.codeConductFeedback) === null || ref2 === void 0 ? void 0 : ref2.acceptanceError)) {
                    var _this = this;
                    // Success - close modal after a brief delay to show success state
                    setTimeout(function() {
                        _this.props.onClose();
                    }, 1000);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, isOpen = _props.isOpen, onClose = _props.onClose, codeConductFeedback = _props.codeConductFeedback, consentType = _props.consentType, documentUrl = _props.documentUrl;
                var isLoading = codeConductFeedback === null || codeConductFeedback === void 0 ? void 0 : codeConductFeedback.loading;
                var hasError = codeConductFeedback === null || codeConductFeedback === void 0 ? void 0 : codeConductFeedback.error;
                var isOldVersion = consentType === 'SIGNATURE';
                var isNewVersion = consentType === 'ACCEPTANCE';
                var hasDocumentUrl = documentUrl && documentUrl.length > 0;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-overlay ".concat(isOpen ? 'visible' : '')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Modal */.u_, {
                            isOpen: isOpen,
                            onClose: onClose,
                            showCloseButton: false,
                            closeOnOutClick: false,
                            width: "95%",
                            maxWidth: "1100px",
                            className: "code-conduct-modal",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "code-conduct-modal-container",
                                    children: [
                                        isLoading && this.renderLoadingState(),
                                        hasError && this.renderErrorState(),
                                        isOldVersion && this.renderOldVersionTodo(),
                                        isNewVersion && hasDocumentUrl && this.renderContractViewer(),
                                        isNewVersion && !hasDocumentUrl && !isLoading && !hasError && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "code-conduct-modal-no-document",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "no-document-content",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                                            icon: "ios-document"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "jsx-".concat(codeConductModalStyles.__hash),
                                                            children: "Documento no disponible"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "jsx-".concat(codeConductModalStyles.__hash),
                                                            children: "No se pudo obtener el documento del c\xf3digo de conducta."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-".concat(codeConductModalStyles.__hash) + " " + "no-document-actions",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                                                        type: "button",
                                                        color: "primary",
                                                        outline: true,
                                                        onClick: function() {
                                                            return _this.props.checkConsentType();
                                                        },
                                                        children: "Reintentar"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (0,jsx_runtime.jsx)(style["default"], {
                                    id: codeConductModalStyles.__hash,
                                    children: codeConductModalStyles
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return CodeConductModal;
}(react.Component);
CodeConductModal_defineProperty(CodeConductModal, "propTypes", {
    isOpen: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func.isRequired,
    checkConsentType: (prop_types_default()).func.isRequired,
    acceptCodeConductContract: (prop_types_default()).func.isRequired,
    getUrlByContract: (prop_types_default()).func.isRequired,
    codeConductFeedback: (prop_types_default()).object,
    consentType: (prop_types_default()).string,
    documentUrl: (prop_types_default()).string,
    isAccepting: (prop_types_default()).bool,
    contractUrlData: (prop_types_default()).object
});
CodeConductModal_defineProperty(CodeConductModal, "defaultProps", {
    isOpen: false,
    codeConductFeedback: null,
    consentType: null,
    documentUrl: null,
    isAccepting: false,
    contractUrlData: null
});
var CodeConductModal_mapStateToProps = function(state) {
    return {
        codeConductFeedback: state.codeConduct.feedback,
        consentType: state.codeConduct.consentType,
        documentUrl: state.codeConduct.documentUrl,
        isAccepting: state.codeConduct.acceptanceLoading,
        contractUrlData: (0,contractVersion/* urlForContractSelector */.hH)(state)
    };
};
var CodeConductModal_mapDispatchToProps = {
    checkConsentType: CodeConductRedux/* CodeConductActionCreators.checkConsentType */.yA.checkConsentType,
    acceptCodeConductContract: CodeConductRedux/* CodeConductActionCreators.acceptCodeConductContract */.yA.acceptCodeConductContract,
    getUrlByContract: ContractVersionRedux/* ContractVersionActionCreators.getUrlByContract */.zn.getUrlByContract
};
/* harmony default export */ var Admin_CodeConductModal = ((0,es/* connect */.$j)(CodeConductModal_mapStateToProps, CodeConductModal_mapDispatchToProps)(CodeConductModal));

// EXTERNAL MODULE: ./app/reducers/TentativeParentsRedux.js
var TentativeParentsRedux = __webpack_require__(82802);
// EXTERNAL MODULE: ./app/selectors/TentativeParentsSelectors.js
var TentativeParentsSelectors = __webpack_require__(30422);
// EXTERNAL MODULE: ./components/Forms/Profile/ParentSelector.js + 2 modules
var ParentSelector = __webpack_require__(38302);
;// CONCATENATED MODULE: ./components/Layout/Admin/ParentSelectorModal/styles.js
var parentSelectorModalStyles = new String(".parent-selector-modal-container.jsx-c2d17a73d7f70c95{padding:24px;\nmax-width:900px;\nwidth:100%;\nmax-height:90vh;\noverflow-y:auto}\n.parent-modal-loading.jsx-c2d17a73d7f70c95, .parent-modal-error.jsx-c2d17a73d7f70c95{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\npadding:60px 40px;\ntext-align:center;\nmin-height:300px}\n.loading-content.jsx-c2d17a73d7f70c95, .error-content.jsx-c2d17a73d7f70c95{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-flex-direction:column;\n-ms-flex-direction:column;\nflex-direction:column;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ngap:16px}\n.loading-content.jsx-c2d17a73d7f70c95 h3.jsx-c2d17a73d7f70c95, .error-content.jsx-c2d17a73d7f70c95 h3.jsx-c2d17a73d7f70c95{margin:0;\nfont-size:1.5rem;\nfont-weight:600;\ncolor:#1a1a1a}\n.loading-content.jsx-c2d17a73d7f70c95 p.jsx-c2d17a73d7f70c95, .error-content.jsx-c2d17a73d7f70c95 p.jsx-c2d17a73d7f70c95{margin:0;\nfont-size:1rem;\ncolor:#6b7280;\nline-height:1.5}\n.error-content.jsx-c2d17a73d7f70c95 .ion-icon{font-size:48px;\ncolor:#ef4444}\n.error-actions.jsx-c2d17a73d7f70c95{margin-top:24px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\ngap:12px}\n.parent-modal-content.jsx-c2d17a73d7f70c95{padding:24px}\n.modal-header.jsx-c2d17a73d7f70c95{padding:32px 24px 24px 24px;\nborder-bottom:1px solid #e5e7eb;\nbackground:#f9fafb}\n.modal-header.jsx-c2d17a73d7f70c95 h2.jsx-c2d17a73d7f70c95{margin:0 0 8px 0;\nfont-size:1.875rem;\nfont-weight:700;\ncolor:#1a1a1a;\ntext-align:center}\n.modal-subtitle.jsx-c2d17a73d7f70c95{margin:0;\nfont-size:1rem;\ncolor:#6b7280;\nline-height:1.6;\ntext-align:center;\nmax-width:600px;\nmargin-left:auto;\nmargin-right:auto}\n.urgent-message.jsx-c2d17a73d7f70c95{color:#dc2626!important;\nfont-weight:600!important;\nfont-size:1.1rem!important}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95{padding:24px}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95 .parent-selector{background:transparent;\npadding:0;\nborder:none;\nbox-shadow:none}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95 .selector-leyend{display:none}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95 .suggested-parents{margin-top:0}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95 .parent-option{border:1px solid #e5e7eb;\nborder-radius:12px;\npadding:20px;\nmargin-bottom:16px;\nbackground:white;\n-webkit-transition:all 0.2s ease;\ntransition:all 0.2s ease}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95 .parent-option:hover{border-color:#3b82f6;\nbox-shadow:0 4px 12px rgba(59, 130, 246, 0.1)}\n@media (max-width:768px) {.parent-selector-modal-container.jsx-c2d17a73d7f70c95{max-height:95vh}\n.modal-header.jsx-c2d17a73d7f70c95{padding:20px}\n.modal-header.jsx-c2d17a73d7f70c95 h2.jsx-c2d17a73d7f70c95{font-size:1.5rem}\n.parent-selector-wrapper.jsx-c2d17a73d7f70c95{padding:20px}}");
parentSelectorModalStyles.__hash = "c2d17a73d7f70c95";

;// CONCATENATED MODULE: ./components/Layout/Admin/ParentSelectorModal/index.js










function ParentSelectorModal_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ParentSelectorModal_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ParentSelectorModal_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function ParentSelectorModal_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ParentSelectorModal_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ParentSelectorModal_defineProperties(Constructor, staticProps);
    return Constructor;
}
function ParentSelectorModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParentSelectorModal_getPrototypeOf(o) {
    ParentSelectorModal_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ParentSelectorModal_getPrototypeOf(o);
}
function ParentSelectorModal_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) ParentSelectorModal_setPrototypeOf(subClass, superClass);
}
function ParentSelectorModal_possibleConstructorReturn(self, call) {
    if (call && (ParentSelectorModal_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return ParentSelectorModal_assertThisInitialized(self);
}
function ParentSelectorModal_setPrototypeOf(o, p) {
    ParentSelectorModal_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ParentSelectorModal_setPrototypeOf(o, p);
}
var ParentSelectorModal_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function ParentSelectorModal_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ParentSelectorModal_createSuper(Derived) {
    var hasNativeReflectConstruct = ParentSelectorModal_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ParentSelectorModal_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ParentSelectorModal_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ParentSelectorModal_possibleConstructorReturn(this, result);
    };
}
var ParentSelectorModal = /*#__PURE__*/ function(Component1) {
    "use strict";
    ParentSelectorModal_inherits(ParentSelectorModal, Component1);
    var _super = ParentSelectorModal_createSuper(ParentSelectorModal);
    function ParentSelectorModal() {
        ParentSelectorModal_classCallCheck(this, ParentSelectorModal);
        var _this;
        _this = _super.apply(this, arguments);
        ParentSelectorModal_defineProperty(ParentSelectorModal_assertThisInitialized(_this), "handleParentSelected", function(parent) {
            // Close modal immediately after parent selection
            // The saga will handle the success message and page reload
            _this.props.onClose();
        });
        ParentSelectorModal_defineProperty(ParentSelectorModal_assertThisInitialized(_this), "renderLoadingState", function() {
            /*#__PURE__*/ return((0,jsx_runtime.jsx)("div", {
                className: "parent-modal-loading",
                /*#__PURE__*/ children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "loading-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Spinner */.$j, {
                            size: 50
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: "Cargando padrinos disponibles..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Por favor, espere mientras buscamos los mejores padrinos para usted."
                        })
                    ]
                })
            }));
        });
        ParentSelectorModal_defineProperty(ParentSelectorModal_assertThisInitialized(_this), "renderErrorState", function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "parent-modal-error",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                icon: "ios-warning"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Error al cargar padrinos"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "No pudimos cargar la lista de padrinos disponibles."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "error-actions",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
                            type: "button",
                            color: "primary",
                            outline: true,
                            onClick: function() {
                                return _this.props.loadTentativeParents();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                    icon: "ios-refresh"
                                }),
                                "Reintentar"
                            ]
                        })
                    })
                ]
            });
        });
        ParentSelectorModal_defineProperty(ParentSelectorModal_assertThisInitialized(_this), "renderContent", function() {
            var _props = _this.props, isLoading = _props.isLoading, error = _props.error, tentativeParents = _props.tentativeParents;
            if (isLoading) {
                return _this.renderLoadingState();
            }
            if (error && tentativeParents.length === 0) {
                return _this.renderErrorState();
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "parent-modal-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Selecciona tu padrino"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "parent-selector-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParentSelector/* default */.Z, {
                            onParentSelected: _this.handleParentSelected,
                            subtitleComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "modal-subtitle urgent-message",
                                style: {
                                    color: '#dc2626'
                                },
                                children: "\xa1Ya no hay m\xe1s tiempo!. Hoy es tu \xfaltimo d\xeda para seleccionar padrino"
                            })
                        })
                    })
                ]
            }));
        });
        return _this;
    }
    ParentSelectorModal_createClass(ParentSelectorModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Load tentative parents when component mounts
                if (this.props.isOpen) {
                    this.props.loadTentativeParents();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Load tentative parents when modal opens
                if (!prevProps.isOpen && this.props.isOpen) {
                    this.props.loadTentativeParents();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, isOpen = _props.isOpen, onClose = _props.onClose;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Modal */.u_, {
                    isOpen: isOpen,
                    onClose: onClose,
                    size: "large",
                    showCloseButton: false,
                    className: "parent-selector-modal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(parentSelectorModalStyles.__hash) + " " + "parent-selector-modal-container",
                        children: [
                            this.renderContent(),
                            (0,jsx_runtime.jsx)(style["default"], {
                                id: parentSelectorModalStyles.__hash,
                                children: parentSelectorModalStyles
                            })
                        ]
                    })
                }));
            }
        }
    ]);
    return ParentSelectorModal;
}(react.Component);
ParentSelectorModal_defineProperty(ParentSelectorModal, "propTypes", {
    isOpen: (prop_types_default()).bool.isRequired,
    onClose: (prop_types_default()).func.isRequired,
    // ParentSelector props
    tentativeParents: (prop_types_default()).array.isRequired,
    isLoading: (prop_types_default()).bool.isRequired,
    error: (prop_types_default()).bool.isRequired,
    loadTentativeParents: (prop_types_default()).func.isRequired,
    showParentErrorModal: (prop_types_default()).bool,
    showParentConfirmModal: (prop_types_default()).bool,
    selectedParentForConfirmation: (prop_types_default()).object
});
ParentSelectorModal_defineProperty(ParentSelectorModal, "defaultProps", {
    isOpen: false,
    showParentErrorModal: false,
    showParentConfirmModal: false,
    selectedParentForConfirmation: null
});
var ParentSelectorModal_mapStateToProps = function(state) {
    return {
        tentativeParents: (0,TentativeParentsSelectors/* getTentativeParents */.VY)(state),
        isLoading: (0,TentativeParentsSelectors/* getTentativeParentsLoading */.j0)(state),
        error: (0,TentativeParentsSelectors/* getTentativeParentsError */.ae)(state),
        showParentErrorModal: (0,TentativeParentsSelectors/* getShowParentErrorModal */.cp)(state),
        showParentConfirmModal: (0,TentativeParentsSelectors/* getShowParentConfirmModal */.LI)(state),
        selectedParentForConfirmation: (0,TentativeParentsSelectors/* getSelectedParentForConfirmation */.Yr)(state)
    };
};
var ParentSelectorModal_mapDispatchToProps = function(dispatch) {
    return {
        loadTentativeParents: function(params) {
            return dispatch(TentativeParentsRedux/* TentativeParentsActionCreators.all */.Lz.all(params));
        }
    };
};
/* harmony default export */ var Admin_ParentSelectorModal = ((0,es/* connect */.$j)(ParentSelectorModal_mapStateToProps, ParentSelectorModal_mapDispatchToProps)(ParentSelectorModal));

// EXTERNAL MODULE: ./app/commonRoutes.json
var commonRoutes = __webpack_require__(20615);
;// CONCATENATED MODULE: ./components/Layout/Admin/index.js



















function Admin_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Admin_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Admin_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function Admin_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) Admin_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) Admin_defineProperties(Constructor, staticProps);
    return Constructor;
}
function Admin_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Admin_getPrototypeOf(o) {
    Admin_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Admin_getPrototypeOf(o);
}
function Admin_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Admin_setPrototypeOf(subClass, superClass);
}
function Admin_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Admin_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Admin_possibleConstructorReturn(self, call) {
    if (call && (Admin_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Admin_assertThisInitialized(self);
}
function Admin_setPrototypeOf(o, p) {
    Admin_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Admin_setPrototypeOf(o, p);
}
var Admin_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Admin_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Admin_createSuper(Derived) {
    var hasNativeReflectConstruct = Admin_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Admin_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Admin_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Admin_possibleConstructorReturn(this, result);
    };
}
var COUNTRY = (0,app_config["default"])('COUNTRY');
var NODE_ENV = (0,app_config["default"])('NODE_ENV');
var LayoutAdmin = /*#__PURE__*/ function(Component1) {
    "use strict";
    Admin_inherits(LayoutAdmin, Component1);
    var _super = Admin_createSuper(LayoutAdmin);
    function LayoutAdmin() {
        Admin_classCallCheck(this, LayoutAdmin);
        var _this;
        _this = _super.apply(this, arguments);
        Admin_defineProperty(Admin_assertThisInitialized(_this), "handleFiscalModalClose", function() {
            _this.props.closeFiscalModal();
        });
        Admin_defineProperty(Admin_assertThisInitialized(_this), "handleNetworkModalClose", function() {
            _this.props.closeNetworkModal();
        });
        Admin_defineProperty(Admin_assertThisInitialized(_this), "handleCodeConductModalClose", function() {
            _this.props.closeCodeConductModal();
        });
        Admin_defineProperty(Admin_assertThisInitialized(_this), "handleParentSelectorModalClose", function() {
            _this.props.closeParentSelectorModal();
        });
        return _this;
    }
    Admin_createClass(LayoutAdmin, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isAuthenticated && this.props.token) {
                    var _this = this;
                    // Load profile info first (needed for ParentSelector permissions)
                    this.props.getProfileInfo();
                    this.props.checkFiscalPermissions();
                    this.props.checkAddNewChildPermission();
                    this.props.checkCodeConductPermission();
                    // Check ParentSelector permissions after a delay to allow profile info to load
                    setTimeout(function() {
                        _this.props.checkParentSelectorPermissions();
                    }, 1500);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!prevProps.isAuthenticated && this.props.isAuthenticated && this.props.token) {
                    var _this = this;
                    // Load profile info first (needed for ParentSelector permissions)
                    this.props.getProfileInfo();
                    this.props.checkFiscalPermissions();
                    this.props.checkAddNewChildPermission();
                    this.props.checkCodeConductPermission();
                    // Check ParentSelector permissions after a delay to allow profile info to load
                    setTimeout(function() {
                        _this.props.checkParentSelectorPermissions();
                    }, 1500);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, title = _props.title, subtitle = _props.subtitle, hideModal = _props.hideModal, hideLateralMenu = _props.hideLateralMenu, pageRoles = _props.pageRoles, pagePlans = _props.pagePlans, notMatch = _props.notMatch, breadcrumbs = _props.breadcrumbs, shouldShowFiscalModal = _props.shouldShowFiscalModal, shouldShowNetworkModal = _props.shouldShowNetworkModal, shouldShowCodeConductModal = _props.shouldShowCodeConductModal, shouldShowParentSelectorModal = _props.shouldShowParentSelectorModal, permissionCheckFeedback = _props.permissionCheckFeedback, userSession = _props.userSession, rest = _objectWithoutProperties(_props, [
                    "children",
                    "title",
                    "subtitle",
                    "hideModal",
                    "hideLateralMenu",
                    "pageRoles",
                    "pagePlans",
                    "notMatch",
                    "breadcrumbs",
                    "shouldShowFiscalModal",
                    "shouldShowNetworkModal",
                    "shouldShowCodeConductModal",
                    "shouldShowParentSelectorModal",
                    "permissionCheckFeedback",
                    "userSession"
                ]);
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, Admin_objectSpread({}, rest, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                        title: title,
                        subtitle: subtitle,
                        hideModal: hideModal,
                        hideLateralMenu: hideLateralMenu,
                        hideSessionModal: this.props.hideSessionModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthByRoles/* default */.Z, {
                            roles: pageRoles,
                            plans: pagePlans,
                            notMatch: notMatch,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Auth_PageAccessVerification, {
                                availablePages: commonRoutes,
                                currentUrlData: rest.urlData,
                                children: [
                                    shouldShowFiscalModal && !userSession.newDevice && !userSession.excededDevices && !userSession.shouldBeRevalidated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Admin_FiscalInfoModal, {
                                        isOpen: shouldShowFiscalModal,
                                        onClose: this.handleFiscalModalClose
                                    }),
                                    shouldShowNetworkModal && !shouldShowFiscalModal && !userSession.newDevice && !userSession.excededDevices && !userSession.shouldBeRevalidated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Admin_NetworkContractModal, {
                                        isOpen: shouldShowNetworkModal,
                                        onClose: this.handleNetworkModalClose
                                    }),
                                    shouldShowCodeConductModal && !shouldShowFiscalModal && !shouldShowNetworkModal && !userSession.newDevice && !userSession.excededDevices && !userSession.shouldBeRevalidated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Admin_CodeConductModal, {
                                        isOpen: shouldShowCodeConductModal,
                                        onClose: this.handleCodeConductModalClose
                                    }),
                                    shouldShowParentSelectorModal && !shouldShowFiscalModal && !shouldShowNetworkModal && !shouldShowCodeConductModal && !userSession.newDevice && !userSession.excededDevices && !userSession.shouldBeRevalidated && /*#__PURE__*/ (0,jsx_runtime.jsx)(Admin_ParentSelectorModal, {
                                        isOpen: shouldShowParentSelectorModal,
                                        onClose: this.handleParentSelectorModalClose
                                    }),
                                    breadcrumbs,
                                    children
                                ]
                            })
                        })
                    })
                })));
            }
        }
    ]);
    return LayoutAdmin;
}(react.Component);
Admin_defineProperty(LayoutAdmin, "propTypes", {
    children: (prop_types_default()).any,
    title: (prop_types_default()).any,
    hideModal: (prop_types_default()).bool,
    hideLateralMenu: (prop_types_default()).bool,
    subtitle: (prop_types_default()).any,
    shouldShowFiscalModal: (prop_types_default()).bool,
    shouldShowNetworkModal: (prop_types_default()).bool,
    shouldShowCodeConductModal: (prop_types_default()).bool,
    shouldShowParentSelectorModal: (prop_types_default()).bool,
    checkFiscalPermissions: (prop_types_default()).func.isRequired,
    checkAddNewChildPermission: (prop_types_default()).func.isRequired,
    checkCodeConductPermission: (prop_types_default()).func.isRequired,
    checkParentSelectorPermissions: (prop_types_default()).func.isRequired,
    permissionCheckFeedback: (prop_types_default()).object,
    isAuthenticated: (prop_types_default()).bool,
    token: (prop_types_default()).string,
    userSession: (prop_types_default()).object
});
Admin_defineProperty(LayoutAdmin, "defaultProps", {
    hideModal: false,
    hideLateralMenu: false,
    pageRoles: [],
    pagePlans: [],
    shouldShowFiscalModal: false,
    shouldShowNetworkModal: false,
    shouldShowCodeConductModal: false,
    shouldShowParentSelectorModal: false
});
var Admin_mapStateToProps = function(state) {
    return {
        shouldShowFiscalModal: state.fiscalInfo.shouldShowModal,
        shouldShowNetworkModal: state.networkContract.shouldShowModal,
        shouldShowCodeConductModal: state.codeConduct.shouldShowModal,
        shouldShowParentSelectorModal: state.tentativeParents.shouldShowParentSelectorModal,
        permissionCheckFeedback: state.fiscalInfo.permissionCheckFeedback,
        isAuthenticated: state.auth.isAuthenticated,
        token: state.auth.token,
        userSession: state.userSession
    };
};
var Admin_mapDispatchToProps = {
    checkFiscalPermissions: FiscalInfoRedux/* FiscalInfoActionCreators.checkFiscalPermissions */.Ov.checkFiscalPermissions,
    closeFiscalModal: FiscalInfoRedux/* FiscalInfoActionCreators.closeFiscalModal */.Ov.closeFiscalModal,
    closeNetworkModal: NetworkContractRedux/* NetworkContractActionCreators.closeNetworkModal */.I7.closeNetworkModal,
    checkAddNewChildPermission: NetworkContractRedux/* NetworkContractActionCreators.checkAddNewChildPermission */.I7.checkAddNewChildPermission,
    closeCodeConductModal: CodeConductRedux/* CodeConductActionCreators.closeCodeConductModal */.yA.closeCodeConductModal,
    checkCodeConductPermission: CodeConductRedux/* CodeConductActionCreators.checkCodeConductPermission */.yA.checkCodeConductPermission,
    checkParentSelectorPermissions: TentativeParentsRedux/* TentativeParentsActionCreators.checkParentSelectorPermissions */.Lz.checkParentSelectorPermissions,
    closeParentSelectorModal: TentativeParentsRedux/* TentativeParentsActionCreators.closeParentSelectorModal */.Lz.closeParentSelectorModal,
    getProfileInfo: services/* store.getProfileInfo */.h.getProfileInfo('user').action
};
/* harmony default export */ var Admin = ((0,es/* connect */.$j)(Admin_mapStateToProps, Admin_mapDispatchToProps)(LayoutAdmin));


/***/ }),

/***/ 8250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PublishButton; },
  "Z": function() { return /* binding */ ContentWrapper_Menu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(45217);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./app/reducers/AuthRedux.js
var AuthRedux = __webpack_require__(45228);
// EXTERNAL MODULE: ./app/reducers/AppRedux.js
var AppRedux = __webpack_require__(65518);
// EXTERNAL MODULE: ./app/theme/index.js + 2 modules
var theme = __webpack_require__(57895);
// EXTERNAL MODULE: ./app/selectors/index.js
var selectors = __webpack_require__(11256);
// EXTERNAL MODULE: ./app/services/index.js + 2 modules
var services = __webpack_require__(64380);
// EXTERNAL MODULE: ./controls/index.js + 30 modules
var controls = __webpack_require__(16389);
// EXTERNAL MODULE: ./globalConfigApp/index.js + 1 modules
var globalConfigApp = __webpack_require__(19169);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./app/services/api/entities/api.js

var getVersion = function() {
    return axios_default().get('/api/version');
};
/* harmony default export */ var api = ({
    getVersion: getVersion
});

// EXTERNAL MODULE: ./app/config/index.js + 1 modules
var config = __webpack_require__(68080);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/styles.js

var MENU_SIZE_EXPANDED = "13.875rem";
var MENU_SIZE_COLLAPSED = "3.75rem";
var menu = new String("nav.jsx-f15b6f8b4986410f{background-color:".concat(theme/* colors.frame */.O9.frame, ";\nmin-height:calc(100vh);\nz-index:101;\n-webkit-transition:width 0.3s ease;\ntransition:width 0.3s ease}\nnav.expanded.jsx-f15b6f8b4986410f{width:").concat(MENU_SIZE_EXPANDED, "}\nnav.collapsed.jsx-f15b6f8b4986410f{width:").concat(MENU_SIZE_COLLAPSED, "}\nnav.jsx-f15b6f8b4986410f>header.jsx-f15b6f8b4986410f{height:").concat(theme/* measurements.headerHeight */.kg.headerHeight, ";\nbackground-color:").concat(theme/* colors.darkFrame */.O9.darkFrame, ";\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-box-pack:start;\n-ms-flex-pack:start;\n-webkit-justify-content:flex-start;\njustify-content:flex-start;\npadding:0 0.75rem;\ngap:0.5rem}\n.header-toggle.jsx-f15b6f8b4986410f{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\n-webkit-justify-content:center;\njustify-content:center;\ncursor:pointer;\npadding:0.5rem;\nborder-radius:4px}\n.header-toggle.jsx-f15b6f8b4986410f:hover{background-color:rgba(255, 255, 255, 0.1)}\nnav.jsx-f15b6f8b4986410f>header.jsx-f15b6f8b4986410f .logo-link{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center}\nnav.jsx-f15b6f8b4986410f>header.jsx-f15b6f8b4986410f .logo{max-width:4rem}\n.menus.jsx-f15b6f8b4986410f{list-style:none;\npadding:0;\n-webkit-transition:width 0.3s ease;\ntransition:width 0.3s ease}\n.menus.expanded.jsx-f15b6f8b4986410f{width:").concat(MENU_SIZE_EXPANDED, "}\nnav.collapsed.jsx-f15b6f8b4986410f .menus.jsx-f15b6f8b4986410f{width:").concat(MENU_SIZE_COLLAPSED, "}\n.menus.jsx-f15b6f8b4986410f li{height:2.5rem;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncolor:").concat(theme/* colors.white */.O9.white, "}\n.menus.jsx-f15b6f8b4986410f li a{cursor:pointer;\nwidth:100%;\nheight:100%}\n.menus.jsx-f15b6f8b4986410f li:hover{background-color:").concat(theme/* colors.darkFrame */.O9.darkFrame, "}\n.menus.jsx-f15b6f8b4986410f li::before{content:'';\nwidth:0.25rem;\nheight:100%}\n.menus.jsx-f15b6f8b4986410f li:hover::before{background-color:").concat(theme/* colors.secondary */.O9.secondary, "}\n.menus.jsx-f15b6f8b4986410f li i{margin:0.5rem;\nmargin-left:0.75rem}\nnav.collapsed.jsx-f15b6f8b4986410f .menus.jsx-f15b6f8b4986410f li i{margin:0 auto}\nnav.collapsed.jsx-f15b6f8b4986410f .menus.jsx-f15b6f8b4986410f li{-webkit-justify-content:center;\njustify-content:center}\nnav.collapsed.jsx-f15b6f8b4986410f .menus.jsx-f15b6f8b4986410f li::before{display:none}\n.actions.jsx-f15b6f8b4986410f{margin:0.75rem 0.75rem 0}\n.hideOnMobile.jsx-f15b6f8b4986410f{display:block}\n.hideOnLarge.jsx-f15b6f8b4986410f{display:none}\n@media screen and (max-width:").concat(theme/* BREAKPOINTS.LG */.j$.LG, ") {.hideOnMobile.jsx-f15b6f8b4986410f{display:none}\n.hideOnLarge.jsx-f15b6f8b4986410f{display:block}\nnav.jsx-f15b6f8b4986410f>header.jsx-f15b6f8b4986410f, nav.jsx-f15b6f8b4986410f{background-color:").concat(theme/* colors.frame */.O9.frame, "}\nnav.jsx-f15b6f8b4986410f{height:").concat(theme/* measurements.headerHeight */.kg.headerHeight, ";\nposition:fixed}\nnav.collapsed.jsx-f15b6f8b4986410f{width:0}\nnav.collapsed.jsx-f15b6f8b4986410f ul.jsx-f15b6f8b4986410f{display:none}\n.menus.expanded.jsx-f15b6f8b4986410f{height:100%;\nmax-height:calc(100vh - 15rem);\noverflow-y:auto;\npadding-bottom:2rem}}"));
menu.__hash = "f15b6f8b4986410f";
var styles_version = new String("p.jsx-8d180c69a68dc05{color:".concat(theme/* colors.white */.O9.white, ";\nmax-width:").concat(MENU_SIZE_EXPANDED, "}"));
styles_version.__hash = "8d180c69a68dc05";
var menuItem = new String(".menu-item.jsx-6de76f57c39bbfcd{display:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\nposition:relative}\n.is-new.jsx-6de76f57c39bbfcd, .is-beta.jsx-6de76f57c39bbfcd{font-size:0.7rem;\nbackground:".concat(theme/* colors.badge */.O9.badge, ";\nposition:absolute;\nleft:8px;\nwidth:-webkit-fit-content;\nwidth:-moz-fit-content;\nwidth:fit-content;\nborder-radius:4px;\npadding:0.2rem}\n.is-beta.jsx-6de76f57c39bbfcd{background:").concat(theme/* colors.warning */.O9.warning, "}"));
menuItem.__hash = "6de76f57c39bbfcd";
var menuGlobalStyles = new String("nav .parent-menu-item{height:40px;\ndisplay:-webkit-box;\ndisplay:-webkit-flex;\ndisplay:-ms-flexbox;\ndisplay:flex;\n-webkit-align-items:center;\n-webkit-box-align:center;\n-ms-flex-align:center;\nalign-items:center;\ncolor:".concat(theme/* colors.white */.O9.white, ";\npadding-left:12px;\nfont-size:").concat(theme/* fontSizes.small */.CH.small, ";\ncursor:pointer;\nposition:relative}\nnav .parent-menu-item:hover{background-color:").concat(theme/* colors.darkFrame */.O9.darkFrame, "}\nnav .parent-menu-item.collapsed{-webkit-justify-content:center;\njustify-content:center;\npadding-left:0}\nnav .parent-icon{margin-right:8px}\nnav .parent-menu-item.collapsed .parent-icon{margin-right:0}\nnav .chevron-icon{margin-left:auto;\nmargin-right:8px}\nnav .padded{padding-left:1rem}\nnav .submenu-items{max-height:0;\noverflow:hidden;\n-webkit-transition:max-height 0.3s ease;\ntransition:max-height 0.3s ease}\nnav .submenu-items.open{max-height:500px}\nnav .is-new, .is-beta{font-size:.7rem;\nbackground:").concat(theme/* colors.badge */.O9.badge, ";\nposition:absolute;\nleft:8px;\nwidth:-webkit-fit-content;\nwidth:-moz-fit-content;\nwidth:fit-content;\nborder-radius:4px;\npadding:0.2rem}\nnav .is-beta{background:").concat(theme/* colors.secondary */.O9.secondary, "}\nnav .logo{max-width:3.25rem}"));
menuGlobalStyles.__hash = "66f8ef38fc4b1611";

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/VersionButton.js








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var BUILD_VERSION = (0,config["default"])('VERSION');
var TITLE = 'Asegurate de tener siempre la versi\xf3n m\xe1s reciente';
var TICK = 1000 * 60 * 5 // 5 minutes
;
var GoodVersion = function(param) {
    var version = param.version;
    /*#__PURE__*/ return((0,jsx_runtime.jsxs)("p", {
        title: TITLE,
        /*#__PURE__*/ className: "jsx-".concat(styles_version.__hash),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                icon: "ios-checkmark",
                style: {
                    fontSize: '1rem',
                    padding: '0 .3rem'
                }
            }),
            "VERSI\xd3N: v",
            version,
            (0,jsx_runtime.jsx)(style["default"], {
                id: styles_version.__hash,
                children: styles_version
            })
        ]
    }));
};
var BadVersion = function(param) {
    var version = param.version;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
        title: TITLE,
        className: "jsx-".concat(styles_version.__hash),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                icon: "ios-close",
                style: {
                    fontSize: '1rem',
                    padding: '0 .3rem'
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                className: "jsx-".concat(styles_version.__hash),
                children: [
                    "VERSI\xd3N: v",
                    version
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "jsx-".concat(styles_version.__hash),
                children: [
                    "Click",
                    ' ',
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* Button */.zx, {
                        outline: true,
                        color: "none",
                        onClick: function() {
                            window.location = window.location;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            className: "jsx-".concat(styles_version.__hash),
                            children: "AQU\xcd"
                        })
                    }),
                    ' ',
                    "para actualizar"
                ]
            }),
            (0,jsx_runtime.jsx)(style["default"], {
                id: styles_version.__hash,
                children: styles_version
            })
        ]
    });
};
var checkVersion = function(callback) {
    return _asyncToGenerator(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api.getVersion();
                case 3:
                    response = _ctx.sent;
                    if (response.status === 200) {
                        callback(response.data.version);
                    }
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    callback(String(_ctx.t0));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
};
var VersionButton = function() {
    var ref = (0,react.useState)(BUILD_VERSION), deployedVersion = ref[0], setDeployedVersion = ref[1];
    (0,react.useEffect)(function() {
        checkVersion(setDeployedVersion)();
        var interval = setInterval(checkVersion(setDeployedVersion), TICK);
        return function() {
            return clearInterval(interval);
        };
    }, []);
    if (deployedVersion === BUILD_VERSION) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(GoodVersion, {
            version: BUILD_VERSION
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BadVersion, {
        version: BUILD_VERSION
    }));
};


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/ContractFeaturesFlag/index.js
var ContractFeaturesFlag = __webpack_require__(24020);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/utils.js
/**
 * Check if a menu item should be rendered based on its feature flag
 * @param {Object} item - Menu item with optional ff property
 * @returns {boolean}
 */ var shouldRenderMenuItem = function(item) {
    if (typeof item.ff === 'function') {
        return item.ff();
    }
    if (typeof item.ff === 'boolean') {
        return item.ff;
    }
    return true;
};
/**
 * Filter menu items to only include visible ones
 * @param {Array} items - Array of menu items
 * @returns {Array} - Filtered array of visible items
 */ var filterVisibleMenuItems = function(items) {
    return items.filter(shouldRenderMenuItem);
};
/**
 * Resolve href - handles both static strings and dynamic functions
 * @param {string|Function} href - Static href or function that receives token
 * @param {string} token - JWT token for dynamic URLs
 * @returns {string}
 */ var resolveHref = function(href, token) {
    if (typeof href === 'function') {
        return href(token);
    }
    return href;
};

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/MenuItem.js










var MenuItem = function(param) {
    var item = param.item, expanded = param.expanded, padded = param.padded, token = param.token, onExpand = param.onExpand, onItemClick = param.onItemClick;
    var name = item.name, icon = item.icon, href = item.href, as = item.as, isNew = item.isNew, isBeta = item.isBeta, external = item.external, contractFeature = item.contractFeature;
    var resolvedHref = resolveHref(href, token);
    var resolvedAs = as ? resolveHref(as, token) : undefined;
    var handleClick = function(e) {
        if (!expanded && onExpand) {
            e.preventDefault();
            onExpand();
        }
        if (onItemClick) {
            onItemClick();
        }
    };
    var content = /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: resolvedHref,
            as: resolvedAs,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                title: !expanded ? name : undefined,
                target: external ? '_blank' : undefined,
                rel: external ? 'noopener noreferrer' : undefined,
                onClick: handleClick,
                className: "jsx-".concat(menuItem.__hash) + " " + (classnames_default()('menu-item', {
                    padded: padded
                }) || ""),
                children: [
                    (isNew || isBeta) && expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "jsx-".concat(menuItem.__hash) + " " + (classnames_default()({
                            'is-new': isNew,
                            'is-beta': isBeta
                        }) || ""),
                        children: [
                            isNew && /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                size: "small",
                                icon: "md-star",
                                style: {
                                    margin: 0
                                }
                            }),
                            isBeta && 'Beta'
                        ]
                    }),
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                        size: "small",
                        icon: icon
                    }),
                    expanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-".concat(menuItem.__hash),
                        children: name
                    }),
                    (0,jsx_runtime.jsx)(style["default"], {
                        id: menuItem.__hash,
                        children: menuItem
                    })
                ]
            })
        })
    });
    if (contractFeature) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ContractFeaturesFlag/* default */.Z, {
            contractFeature: contractFeature,
            children: content
        }));
    }
    return content;
};
MenuItem.propTypes = {
    item: prop_types_default().shape({
        name: (prop_types_default()).string.isRequired,
        icon: (prop_types_default()).string,
        href: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).object,
            (prop_types_default()).func
        ]).isRequired,
        as: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).object,
            (prop_types_default()).func
        ]),
        isNew: (prop_types_default()).bool,
        isBeta: (prop_types_default()).bool,
        external: (prop_types_default()).bool,
        contractFeature: (prop_types_default()).string
    }).isRequired,
    expanded: (prop_types_default()).bool,
    padded: (prop_types_default()).bool,
    token: (prop_types_default()).string,
    onExpand: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func
};
MenuItem.defaultProps = {
    expanded: true,
    padded: false,
    token: '',
    onExpand: null,
    onItemClick: function() {}
};
/* harmony default export */ var Menu_MenuItem = (MenuItem);

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/MenuGroup.js







var MenuGroup = function(param) {
    var item = param.item, index = param.index, expanded = param.expanded, isOpen = param.isOpen, onToggle = param.onToggle, token = param.token, onExpand = param.onExpand, onItemClick = param.onItemClick;
    var name = item.name, icon = item.icon, href = item.href, isNew = item.isNew, isBeta = item.isBeta, children = item.children;
    var visibleChildren = children.filter(shouldRenderMenuItem);
    if (visibleChildren.length === 0) {
        return null;
    }
    var handleParentClick = function() {
        if (!expanded && onExpand) {
            onExpand();
        } else {
            onToggle();
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuItem, {
                item: item,
                expanded: expanded,
                token: token,
                onExpand: onExpand,
                onItemClick: onItemClick
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('parent-menu-item', {
                    collapsed: !expanded
                }),
                onClick: handleParentClick,
                title: !expanded ? name : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                        className: "parent-icon",
                        size: "small",
                        icon: icon
                    }),
                    expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                /*#__PURE__*/ children: name
                            }),
                            (isNew || isBeta) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()({
                                    'is-new': isNew,
                                    'is-beta': isBeta
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        isNew && 'New',
                                        isBeta && 'Beta'
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                className: "chevron-icon",
                                size: "small",
                                icon: isOpen ? 'ios-arrow-up' : 'ios-arrow-down'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()('submenu-items', {
                    open: isOpen && expanded
                }),
                children: visibleChildren.map(function(child, ix) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Menu_MenuItem, {
                        item: child,
                        expanded: expanded,
                        padded: true,
                        token: token,
                        onExpand: onExpand,
                        onItemClick: onItemClick
                    }, "".concat(index, "_").concat(ix));
                })
            })
        ]
    }));
};
MenuGroup.propTypes = {
    item: prop_types_default().shape({
        name: (prop_types_default()).string.isRequired,
        icon: (prop_types_default()).string,
        href: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).object
        ]),
        isNew: (prop_types_default()).bool,
        isBeta: (prop_types_default()).bool,
        children: (prop_types_default()).array.isRequired
    }).isRequired,
    index: (prop_types_default()).number.isRequired,
    expanded: (prop_types_default()).bool,
    isOpen: (prop_types_default()).bool,
    onToggle: (prop_types_default()).func.isRequired,
    token: (prop_types_default()).string,
    onExpand: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func
};
MenuGroup.defaultProps = {
    expanded: true,
    isOpen: false,
    token: '',
    onExpand: null,
    onItemClick: function() {}
};
/* harmony default export */ var Menu_MenuGroup = (MenuGroup);

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/MenuList.js






var MenuList = function(param) {
    var items = param.items, expanded = param.expanded, openSubmenus = param.openSubmenus, onToggleSubmenu = param.onToggleSubmenu, token = param.token, onExpand = param.onExpand, onItemClick = param.onItemClick;
    var visibleItems = filterVisibleMenuItems(items);
    return visibleItems.map(function(item, index) {
        if (item.children) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuGroup, {
                item: item,
                index: index,
                expanded: expanded,
                isOpen: openSubmenus.includes(index),
                onToggle: function() {
                    return onToggleSubmenu(index);
                },
                token: token,
                onExpand: onExpand,
                onItemClick: onItemClick
            }, index));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuItem, {
            item: item,
            expanded: expanded,
            token: token,
            onExpand: onExpand,
            onItemClick: onItemClick
        }, index));
    });
};
MenuList.propTypes = {
    items: (prop_types_default()).array.isRequired,
    expanded: (prop_types_default()).bool,
    openSubmenus: (prop_types_default()).array,
    onToggleSubmenu: (prop_types_default()).func,
    token: (prop_types_default()).string,
    onExpand: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func
};
MenuList.defaultProps = {
    expanded: true,
    openSubmenus: [],
    onToggleSubmenu: function() {},
    token: '',
    onExpand: null,
    onItemClick: function() {}
};
/* harmony default export */ var Menu_MenuList = (MenuList);

// EXTERNAL MODULE: ./app/constants/newChildAgent.js
var newChildAgent = __webpack_require__(40308);
;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/menuConfiguration.js



var NEWS_URL = (0,config["default"])('NEWS_URL');
var INVOICE_URL = (0,config["default"])('INVOICE_URL');
// Metricas del Asistente del Asesor (hermes). Sin host configurado no hay de
// donde leerlas, asi que la entrada no se pinta.
var ADVISOR_ASSISTANT_API_BASE_URL = (0,config["default"])('ADVISOR_ASSISTANT_API_BASE_URL');
// Special menu items that require token for URL building
var specialMenuItems = {
    start: [],
    end: [
        {
            name: 'Facturaci\xf3n',
            icon: 'ios-card',
            href: function(token) {
                return("".concat(INVOICE_URL, "?t=").concat(token));
            },
            external: true,
            ff: function() {
                return Boolean(INVOICE_URL);
            }
        }
    ]
};
var menus = [
    {
        name: 'Panel de control',
        icon: 'ios-speedometer',
        href: '/dashboard'
    },
    {
        name: 'Captaci\xf3n de propiedades',
        icon: 'ios-stats',
        ff: (0,config.checkFeatureFlag)('show-on-hl-integration'),
        href: '/dashboard/leads'
    },
    {
        name: 'Mis propiedades',
        icon: 'ios-home',
        as: {
            pathname: '/dashboard/property-management',
            query: {
                status: 'APPROVED',
                page: 1
            }
        },
        href: {
            pathname: '/dashboard/property-management',
            query: {
                status: 'APPROVED',
                page: 1
            }
        }
    },
    {
        name: 'Documentaci\xf3n',
        icon: 'ios-book',
        href: '/dashboard/network-documentation'
    },
    {
        name: 'Contratos',
        ff: (0,config.checkFeatureFlag)('new-neximo-contracts'),
        icon: 'ios-folder-open',
        href: '/dashboard/contracts'
    },
    {
        name: 'Bolsa Inmobiliaria',
        icon: 'ios-pulse',
        children: [
            {
                name: 'Propiedades',
                as: '/dashboard/bin',
                href: '/dashboard/bin'
            },
            {
                name: 'Requerimientos',
                href: '/dashboard/bin/prospections',
                as: '/dashboard/bin/prospections',
                ff: (0,config.checkFeatureFlag)('show-on-hl-integration')
            },
            {
                name: 'Alertas',
                href: '/dashboard/bin/alerts',
                as: '/dashboard/bin/alerts'
            }
        ]
    },
    {
        name: 'Prospectos',
        icon: 'ios-contacts',
        ff: (0,config.checkFeatureFlag)('show-on-hl-integration'),
        children: [
            {
                name: 'Contactos',
                as: '/dashboard/crm/contacts',
                href: '/dashboard/crm/contacts'
            }
        ]
    },
    {
        name: 'Estimado de valor',
        icon: 'ios-list-box',
        children: [
            {
                name: 'Mis reportes',
                as: '/dashboard/valuations',
                href: '/dashboard/valuations'
            }
        ]
    },
    {
        name: "Universidad ".concat(globalConfigApp/* companyConfig.name */.p2.name),
        icon: 'ios-easel',
        children: [
            {
                name: 'Cursos',
                href: '/dashboard/elearning'
            },
            {
                ff: (0,config.checkFeatureFlag)('new-neximo-red'),
                name: 'Seguimiento',
                href: '/dashboard/tracing'
            },
            {
                // Estado de cumplimiento de la politica de capacitacion (R26-865).
                // Vive bajo Universidad porque es donde el asesor busca "como voy":
                // la pantalla mezcla Universidad, horas, facturacion e inventario.
                // Sin gate de contrato: a quien no le aplica la politica, la pantalla
                // se lo dice explicitamente en vez de desaparecer sin explicacion.
                name: 'Mi capacitaci\xf3n',
                href: '/dashboard/training-policy'
            }, 
        ]
    },
    {
        // Both legacy children ('PAP' and 'Mis comisiones') render the very same
        // MoneyPages screen in two segment states, so the tree collapses into a
        // single leaf. No `contractFeature` gate here on purpose: 'Mis comisiones'
        // never carried one, so gating the leaf would take the closings away from
        // advisors whose contract lacks PAP. MoneyPages degrades instead — it
        // drops the "Mi PAP" segment and lands them on the closings.
        isNew: true,
        name: 'PAP/Cierres',
        icon: 'md-repeat',
        ff: (0,config.checkFeatureFlag)('new-neximo-red'),
        href: '/dashboard/transactions/pap'
    },
    {
        // NEW MENU SECTION MY NETWORK
        name: "RED ".concat(globalConfigApp/* companyConfig.name */.p2.name),
        icon: 'md-contacts',
        ff: (0,config.checkFeatureFlag)('new-neximo-red'),
        children: [
            {
                name: 'Red',
                href: '/dashboard/network'
            },
            {
                name: 'Dar de alta',
                href: {
                    pathname: '/dashboard/team/registerAgent',
                    query: {
                        section: newChildAgent/* FIRST_AGENT_TAB */.LR
                    }
                },
                as: {
                    pathname: "/dashboard/team/registerAgent/".concat(newChildAgent/* FIRST_AGENT_TAB */.LR)
                },
                ff: !(0,config.checkFeatureFlag)('hide-classic-broker-registration')
            },
            {
                name: 'Invitar a Red',
                href: '/dashboard/team/landing-invitation',
                ff: (0,config.checkFeatureFlag)('self-service-share-landing')
            },
            {
                name: 'Mi Equipo',
                href: '/dashboard/team/network'
            },
            {
                name: 'Comisiones de RED',
                href: '/dashboard/network/commissions'
            },
            {
                name: 'Retos e Incentivos',
                href: '/dashboard/network/stats',
                ff: (0,config.checkFeatureFlag)('network-stats')
            },
            {
                name: 'Reporte de mi RED',
                href: '/dashboard/network/report',
                ff: (0,config.checkFeatureFlag)('network-stats-reports')
            }
        ]
    },
    {
        name: "RED ".concat(globalConfigApp/* companyConfig.name */.p2.name),
        icon: 'md-globe',
        ff: !(0,config.checkFeatureFlag)('new-neximo-red'),
        children: [
            {
                name: 'Seguimiento',
                href: '/dashboard/team/tracing'
            },
            {
                isNew: true,
                name: 'Dar de alta',
                href: {
                    pathname: '/dashboard/team/registerAgent',
                    query: {
                        section: newChildAgent/* FIRST_AGENT_TAB */.LR
                    }
                },
                as: {
                    pathname: "/dashboard/team/registerAgent/".concat(newChildAgent/* FIRST_AGENT_TAB */.LR)
                }
            },
            {
                name: 'Agente registrado',
                href: '/dashboard/team/registered-agent'
            },
            {
                name: 'Mi Equipo',
                href: '/dashboard/team/network'
            },
            {
                name: 'Mis comisiones',
                href: '/dashboard/team/commissions'
            }, 
        ]
    },
    {
        name: 'Estado de Cuenta',
        icon: 'ios-paper',
        href: '/dashboard/billing'
    },
    {
        ff: Boolean(NEWS_URL),
        name: 'Novedades de la plataforma',
        icon: 'md-paper',
        href: '/dashboard/news'
    },
    {
        name: 'Mi Asistente',
        icon: 'md-chatbubbles',
        ff: Boolean(ADVISOR_ASSISTANT_API_BASE_URL),
        href: '/dashboard/assistant-metrics'
    }, 
];
/* harmony default export */ var menuConfiguration = (menus);

;// CONCATENATED MODULE: ./components/Layout/ContentWrapper/Menu/index.js


















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var PublishButton = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(controls/* Button */.zx, {
        fullWidth: true,
        color: "primary",
        href: "/dashboard/properties/create",
        as: "/dashboard/properties/create",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                icon: "ios-home",
                style: {
                    fontSize: '1rem',
                    padding: '0 .3rem'
                }
            }),
            ' ',
            "Crear Propiedad"
        ]
    });
};
/**
 * Combines special menu items with regular menus
 * @param {Array} regularMenus - Regular menu items
 * @returns {Array} - Combined menu items with special items at start and end
 */ var getAllMenuItems = function(regularMenus) {
    return _toConsumableArray(specialMenuItems.start).concat(_toConsumableArray(regularMenus), _toConsumableArray(specialMenuItems.end));
};
var Menu = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Menu, Component1);
    var _super = _createSuper(Menu);
    function Menu(props) {
        _classCallCheck(this, Menu);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "toggleMenu", function() {
            _this.props.actions.toggleMenu();
        });
        _defineProperty(_assertThisInitialized(_this), "toggleSubmenu", function(index) {
            _this.setState(function(prev) {
                return {
                    openSubmenus: prev.openSubmenus.includes(index) ? prev.openSubmenus.filter(function(i) {
                        return i !== index;
                    }) : _toConsumableArray(prev.openSubmenus).concat([
                        index
                    ])
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleItemClick", function() {
            if (window.innerWidth < 768 && _this.props.menuExpanded) {
                _this.props.actions.toggleMenu();
            }
        });
        _this.state = {
            openSubmenus: []
        };
        return _this;
    }
    _createClass(Menu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (true) {
                    var savedState = localStorage.getItem('menuExpanded');
                    if (savedState !== null) {
                        this.props.actions.setMenuExpanded(JSON.parse(savedState));
                    }
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.menuExpanded !== this.props.menuExpanded && "object" !== 'undefined') {
                    localStorage.setItem('menuExpanded', JSON.stringify(this.props.menuExpanded));
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var openSubmenus = this.state.openSubmenus;
                var _props = this.props, menus1 = _props.menus, sessionData = _props.sessionData, menuExpanded = _props.menuExpanded;
                var token = sessionData.token;
                var allMenuItems = getAllMenuItems(menus1);
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "jsx-".concat(menu.__hash) + " " + (classnames_default()('nav', {
                        expanded: menuExpanded,
                        collapsed: !menuExpanded
                    }) || ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            className: "jsx-".concat(menu.__hash),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: this.toggleMenu,
                                    className: "jsx-".concat(menu.__hash) + " " + "header-toggle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(controls/* IonIcon */.gu, {
                                        icon: "ios-menu",
                                        style: {
                                            fontSize: '1.5rem',
                                            color: theme/* colors.white */.O9.white,
                                            cursor: 'pointer'
                                        }
                                    })
                                }),
                                menuExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/",
                                    target: "_blank",
                                    className: "jsx-".concat(menu.__hash) + " " + "logo-link",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,services/* image */.BH)('IAD-White.png'),
                                        alt: globalConfigApp/* companyConfig.name */.p2.name,
                                        className: "jsx-".concat(menu.__hash) + " " + "logo"
                                    })
                                })
                            ]
                        }),
                        menuExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "jsx-".concat(menu.__hash) + " " + "actions",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishButton, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VersionButton, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "jsx-".concat(menu.__hash) + " " + (classnames_default()('menus', {
                                expanded: menuExpanded
                            }) || ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_MenuList, {
                                items: allMenuItems,
                                expanded: menuExpanded,
                                openSubmenus: openSubmenus,
                                onToggleSubmenu: this.toggleSubmenu,
                                token: token,
                                onExpand: this.toggleMenu,
                                onItemClick: this.handleItemClick
                            })
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: menu.__hash,
                            children: menu
                        }),
                        (0,jsx_runtime.jsx)(style["default"], {
                            id: menuGlobalStyles.__hash,
                            children: menuGlobalStyles
                        })
                    ]
                }));
            }
        }
    ]);
    return Menu;
}(react.Component);
_defineProperty(Menu, "propTypes", {
    menus: (prop_types_default()).array,
    sessionData: prop_types_default().shape({
        token: (prop_types_default()).string
    }),
    menuExpanded: (prop_types_default()).bool.isRequired,
    actions: prop_types_default().shape({
        toggleMenu: (prop_types_default()).func.isRequired,
        logoutRequest: (prop_types_default()).func.isRequired,
        setMenuExpanded: (prop_types_default()).func.isRequired
    }).isRequired
});
_defineProperty(Menu, "defaultProps", {
    menus: [],
    sessionData: {
        token: ''
    }
});
var mapStateToProps = function(state) {
    return {
        menus: menuConfiguration,
        sessionData: (0,selectors/* getSessionData */.gP)(state),
        menuExpanded: state.app.menuExpanded
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: (0,redux/* bindActionCreators */.DE)({
            logoutRequest: AuthRedux/* AuthActionCreators.logoutRequest */.jQ.logoutRequest,
            toggleMenu: AppRedux/* AppActionCreators.toggleMenu */.fF.toggleMenu,
            setMenuExpanded: AppRedux/* AppActionCreators.setMenuExpanded */.fF.setMenuExpanded
        }, dispatch)
    };
};
/* harmony default export */ var ContentWrapper_Menu = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Menu));


/***/ }),

/***/ 11333:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52262:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 4727:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75028:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 57840:
/***/ (function() {

/* (ignored) */

/***/ })

}]);